import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AddBasketInput = {
  productId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<Scalars['ID']>;
  selectedSize?: InputMaybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  addressLineOne: Scalars['String'];
  addressLineTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['String'];
  id: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressCountAggregate = {
  __typename?: 'AddressCountAggregate';
  _all: Scalars['Int'];
  addressLineOne: Scalars['Int'];
  addressLineTwo: Scalars['Int'];
  city: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  postalCode: Scalars['Int'];
  state: Scalars['Int'];
  title: Scalars['Int'];
};

export type AddressCountOrderByAggregateInput = {
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AddressCreateInput = {
  addressLineOne: Scalars['String'];
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutAddressesInput;
  id?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressCreateManyCustomerInput = {
  addressLineOne: Scalars['String'];
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressCreateManyCustomerInputEnvelope = {
  data: Array<AddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AddressCreateManyInput = {
  addressLineOne: Scalars['String'];
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
};

export type AddressCreateOrConnectWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressCreateWithoutCustomerInput = {
  addressLineOne: Scalars['String'];
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressGroupBy = {
  __typename?: 'AddressGroupBy';
  _count?: Maybe<AddressCountAggregate>;
  _max?: Maybe<AddressMaxAggregate>;
  _min?: Maybe<AddressMinAggregate>;
  addressLineOne: Scalars['String'];
  addressLineTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customerId: Scalars['String'];
  id: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AddressListRelationFilter = {
  every?: InputMaybe<AddressWhereInput>;
  none?: InputMaybe<AddressWhereInput>;
  some?: InputMaybe<AddressWhereInput>;
};

export type AddressMaxAggregate = {
  __typename?: 'AddressMaxAggregate';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AddressMaxOrderByAggregateInput = {
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AddressMinAggregate = {
  __typename?: 'AddressMinAggregate';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AddressMinOrderByAggregateInput = {
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithAggregationInput = {
  _count?: InputMaybe<AddressCountOrderByAggregateInput>;
  _max?: InputMaybe<AddressMaxOrderByAggregateInput>;
  _min?: InputMaybe<AddressMinOrderByAggregateInput>;
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AddressOrderByWithRelationInput = {
  addressLineOne?: InputMaybe<SortOrder>;
  addressLineTwo?: InputMaybe<SortOrder>;
  city?: InputMaybe<SortOrder>;
  country?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum AddressScalarFieldEnum {
  addressLineOne = 'addressLineOne',
  addressLineTwo = 'addressLineTwo',
  city = 'city',
  country = 'country',
  createdAt = 'createdAt',
  customerId = 'customerId',
  id = 'id',
  postalCode = 'postalCode',
  state = 'state',
  title = 'title'
}

export type AddressScalarWhereInput = {
  AND?: InputMaybe<Array<AddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereInput>>;
  addressLineOne?: InputMaybe<StringFilter>;
  addressLineTwo?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type AddressScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AddressScalarWhereWithAggregatesInput>>;
  addressLineOne?: InputMaybe<StringWithAggregatesFilter>;
  addressLineTwo?: InputMaybe<StringNullableWithAggregatesFilter>;
  city?: InputMaybe<StringWithAggregatesFilter>;
  country?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  postalCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  state?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type AddressUpdateInput = {
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutAddressesInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AddressUpdateManyMutationInput = {
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AddressUpdateManyWithWhereWithoutCustomerInput = {
  data: AddressUpdateManyMutationInput;
  where: AddressScalarWhereInput;
};

export type AddressUpdateManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<AddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<AddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<AddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddressWhereUniqueInput>>;
  set?: InputMaybe<Array<AddressWhereUniqueInput>>;
  update?: InputMaybe<Array<AddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<AddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<AddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type AddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressUpdateWithoutCustomerInput = {
  addressLineOne?: InputMaybe<StringFieldUpdateOperationsInput>;
  addressLineTwo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  city?: InputMaybe<StringFieldUpdateOperationsInput>;
  country?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: AddressCreateWithoutCustomerInput;
  update: AddressUpdateWithoutCustomerInput;
  where: AddressWhereUniqueInput;
};

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>;
  NOT?: InputMaybe<Array<AddressWhereInput>>;
  OR?: InputMaybe<Array<AddressWhereInput>>;
  addressLineOne?: InputMaybe<StringFilter>;
  addressLineTwo?: InputMaybe<StringNullableFilter>;
  city?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
};

export type AddressWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateAddress = {
  __typename?: 'AggregateAddress';
  _count?: Maybe<AddressCountAggregate>;
  _max?: Maybe<AddressMaxAggregate>;
  _min?: Maybe<AddressMinAggregate>;
};

export type AggregateBasket = {
  __typename?: 'AggregateBasket';
  _count?: Maybe<BasketCountAggregate>;
  _max?: Maybe<BasketMaxAggregate>;
  _min?: Maybe<BasketMinAggregate>;
};

export type AggregateBasketItem = {
  __typename?: 'AggregateBasketItem';
  _avg?: Maybe<BasketItemAvgAggregate>;
  _count?: Maybe<BasketItemCountAggregate>;
  _max?: Maybe<BasketItemMaxAggregate>;
  _min?: Maybe<BasketItemMinAggregate>;
  _sum?: Maybe<BasketItemSumAggregate>;
};

export type AggregateCategory = {
  __typename?: 'AggregateCategory';
  _avg?: Maybe<CategoryAvgAggregate>;
  _count?: Maybe<CategoryCountAggregate>;
  _max?: Maybe<CategoryMaxAggregate>;
  _min?: Maybe<CategoryMinAggregate>;
  _sum?: Maybe<CategorySumAggregate>;
};

export type AggregateCollection = {
  __typename?: 'AggregateCollection';
  _avg?: Maybe<CollectionAvgAggregate>;
  _count?: Maybe<CollectionCountAggregate>;
  _max?: Maybe<CollectionMaxAggregate>;
  _min?: Maybe<CollectionMinAggregate>;
  _sum?: Maybe<CollectionSumAggregate>;
};

export type AggregateColor = {
  __typename?: 'AggregateColor';
  _avg?: Maybe<ColorAvgAggregate>;
  _count?: Maybe<ColorCountAggregate>;
  _max?: Maybe<ColorMaxAggregate>;
  _min?: Maybe<ColorMinAggregate>;
  _sum?: Maybe<ColorSumAggregate>;
};

export type AggregateContent = {
  __typename?: 'AggregateContent';
  _avg?: Maybe<ContentAvgAggregate>;
  _count?: Maybe<ContentCountAggregate>;
  _max?: Maybe<ContentMaxAggregate>;
  _min?: Maybe<ContentMinAggregate>;
  _sum?: Maybe<ContentSumAggregate>;
};

export type AggregateCurrency = {
  __typename?: 'AggregateCurrency';
  _avg?: Maybe<CurrencyAvgAggregate>;
  _count?: Maybe<CurrencyCountAggregate>;
  _max?: Maybe<CurrencyMaxAggregate>;
  _min?: Maybe<CurrencyMinAggregate>;
  _sum?: Maybe<CurrencySumAggregate>;
};

export type AggregateCustomer = {
  __typename?: 'AggregateCustomer';
  _count?: Maybe<CustomerCountAggregate>;
  _max?: Maybe<CustomerMaxAggregate>;
  _min?: Maybe<CustomerMinAggregate>;
};

export type AggregateDescription = {
  __typename?: 'AggregateDescription';
  _count?: Maybe<DescriptionCountAggregate>;
  _max?: Maybe<DescriptionMaxAggregate>;
  _min?: Maybe<DescriptionMinAggregate>;
};

export type AggregateDiscountCoupon = {
  __typename?: 'AggregateDiscountCoupon';
  _avg?: Maybe<DiscountCouponAvgAggregate>;
  _count?: Maybe<DiscountCouponCountAggregate>;
  _max?: Maybe<DiscountCouponMaxAggregate>;
  _min?: Maybe<DiscountCouponMinAggregate>;
  _sum?: Maybe<DiscountCouponSumAggregate>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
};

export type AggregatePage = {
  __typename?: 'AggregatePage';
  _avg?: Maybe<PageAvgAggregate>;
  _count?: Maybe<PageCountAggregate>;
  _max?: Maybe<PageMaxAggregate>;
  _min?: Maybe<PageMinAggregate>;
  _sum?: Maybe<PageSumAggregate>;
};

export type AggregatePrice = {
  __typename?: 'AggregatePrice';
  _avg?: Maybe<PriceAvgAggregate>;
  _count?: Maybe<PriceCountAggregate>;
  _max?: Maybe<PriceMaxAggregate>;
  _min?: Maybe<PriceMinAggregate>;
  _sum?: Maybe<PriceSumAggregate>;
};

export type AggregatePriceHistory = {
  __typename?: 'AggregatePriceHistory';
  _avg?: Maybe<PriceHistoryAvgAggregate>;
  _count?: Maybe<PriceHistoryCountAggregate>;
  _max?: Maybe<PriceHistoryMaxAggregate>;
  _min?: Maybe<PriceHistoryMinAggregate>;
  _sum?: Maybe<PriceHistorySumAggregate>;
};

export type AggregateProduct = {
  __typename?: 'AggregateProduct';
  _avg?: Maybe<ProductAvgAggregate>;
  _count?: Maybe<ProductCountAggregate>;
  _max?: Maybe<ProductMaxAggregate>;
  _min?: Maybe<ProductMinAggregate>;
  _sum?: Maybe<ProductSumAggregate>;
};

export type AggregateProductColor = {
  __typename?: 'AggregateProductColor';
  _count?: Maybe<ProductColorCountAggregate>;
  _max?: Maybe<ProductColorMaxAggregate>;
  _min?: Maybe<ProductColorMinAggregate>;
};

export type AggregateProductSize = {
  __typename?: 'AggregateProductSize';
  _count?: Maybe<ProductSizeCountAggregate>;
  _max?: Maybe<ProductSizeMaxAggregate>;
  _min?: Maybe<ProductSizeMinAggregate>;
};

export type AggregateSize = {
  __typename?: 'AggregateSize';
  _avg?: Maybe<SizeAvgAggregate>;
  _count?: Maybe<SizeCountAggregate>;
  _max?: Maybe<SizeMaxAggregate>;
  _min?: Maybe<SizeMinAggregate>;
  _sum?: Maybe<SizeSumAggregate>;
};

export type AggregateStaff = {
  __typename?: 'AggregateStaff';
  _count?: Maybe<StaffCountAggregate>;
  _max?: Maybe<StaffMaxAggregate>;
  _min?: Maybe<StaffMinAggregate>;
};

export type Basket = {
  __typename?: 'Basket';
  _count?: Maybe<BasketCount>;
  basketItem: Array<BasketItem>;
  createdAt: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['String'];
  id: Scalars['String'];
};


export type BasketBasketItemArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};

export type BasketCount = {
  __typename?: 'BasketCount';
  basketItem: Scalars['Int'];
};

export type BasketCountAggregate = {
  __typename?: 'BasketCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  id: Scalars['Int'];
};

export type BasketCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BasketCreateInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutBasketInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutBasketInput;
  id?: InputMaybe<Scalars['String']>;
};

export type BasketCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type BasketCreateNestedOneWithoutBasketItemInput = {
  connect?: InputMaybe<BasketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BasketCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<BasketCreateWithoutBasketItemInput>;
};

export type BasketCreateNestedOneWithoutCustomerInput = {
  connect?: InputMaybe<BasketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BasketCreateOrConnectWithoutCustomerInput>;
  create?: InputMaybe<BasketCreateWithoutCustomerInput>;
};

export type BasketCreateOrConnectWithoutBasketItemInput = {
  create: BasketCreateWithoutBasketItemInput;
  where: BasketWhereUniqueInput;
};

export type BasketCreateOrConnectWithoutCustomerInput = {
  create: BasketCreateWithoutCustomerInput;
  where: BasketWhereUniqueInput;
};

export type BasketCreateWithoutBasketItemInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutBasketInput;
  id?: InputMaybe<Scalars['String']>;
};

export type BasketCreateWithoutCustomerInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutBasketInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BasketGroupBy = {
  __typename?: 'BasketGroupBy';
  _count?: Maybe<BasketCountAggregate>;
  _max?: Maybe<BasketMaxAggregate>;
  _min?: Maybe<BasketMinAggregate>;
  createdAt: Scalars['DateTime'];
  customerId: Scalars['String'];
  id: Scalars['String'];
};

export type BasketInputPayload = {
  __typename?: 'BasketInputPayload';
  result: Scalars['String'];
};

export type BasketItem = {
  __typename?: 'BasketItem';
  additionalInfo?: Maybe<Scalars['String']>;
  basket: Basket;
  basketId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  price: Price;
  priceId: Scalars['String'];
  product: Product;
  productId: Scalars['String'];
  quantity: Scalars['Int'];
  selectedColor?: Maybe<ProductColor>;
  selectedColorId?: Maybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: Maybe<Scalars['String']>;
  selectedSize?: Maybe<ProductSize>;
};

export type BasketItemAvgAggregate = {
  __typename?: 'BasketItemAvgAggregate';
  quantity?: Maybe<Scalars['Float']>;
  selectedPrice?: Maybe<Scalars['Float']>;
};

export type BasketItemAvgOrderByAggregateInput = {
  quantity?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
};

export type BasketItemCountAggregate = {
  __typename?: 'BasketItemCountAggregate';
  _all: Scalars['Int'];
  additionalInfo: Scalars['Int'];
  basketId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  priceId: Scalars['Int'];
  productId: Scalars['Int'];
  quantity: Scalars['Int'];
  selectedColorId: Scalars['Int'];
  selectedCurrencyCode: Scalars['Int'];
  selectedPrice: Scalars['Int'];
  selectedProductSizeId: Scalars['Int'];
};

export type BasketItemCountOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  basketId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedColorId?: InputMaybe<SortOrder>;
  selectedCurrencyCode?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
};

export type BasketItemCreateInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basket: BasketCreateNestedOneWithoutBasketItemInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price: PriceCreateNestedOneWithoutBasketItemsInput;
  product: ProductCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<ProductColorCreateNestedOneWithoutBasketItemInput>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutBasketItemInput>;
};

export type BasketItemCreateManyBasketInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColorId?: InputMaybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
};

export type BasketItemCreateManyBasketInputEnvelope = {
  data: Array<BasketItemCreateManyBasketInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BasketItemCreateManyInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColorId?: InputMaybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
};

export type BasketItemCreateManyPriceInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColorId?: InputMaybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
};

export type BasketItemCreateManyPriceInputEnvelope = {
  data: Array<BasketItemCreateManyPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BasketItemCreateManyProductInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColorId?: InputMaybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
};

export type BasketItemCreateManyProductInputEnvelope = {
  data: Array<BasketItemCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BasketItemCreateManySelectedColorInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
};

export type BasketItemCreateManySelectedColorInputEnvelope = {
  data: Array<BasketItemCreateManySelectedColorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BasketItemCreateManySelectedSizeInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColorId?: InputMaybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
};

export type BasketItemCreateManySelectedSizeInputEnvelope = {
  data: Array<BasketItemCreateManySelectedSizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type BasketItemCreateNestedManyWithoutBasketInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutBasketInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutBasketInput>>;
  createMany?: InputMaybe<BasketItemCreateManyBasketInputEnvelope>;
};

export type BasketItemCreateNestedManyWithoutPriceInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutPriceInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutPriceInput>>;
  createMany?: InputMaybe<BasketItemCreateManyPriceInputEnvelope>;
};

export type BasketItemCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<BasketItemCreateManyProductInputEnvelope>;
};

export type BasketItemCreateNestedManyWithoutSelectedColorInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutSelectedColorInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutSelectedColorInput>>;
  createMany?: InputMaybe<BasketItemCreateManySelectedColorInputEnvelope>;
};

export type BasketItemCreateNestedManyWithoutSelectedSizeInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutSelectedSizeInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutSelectedSizeInput>>;
  createMany?: InputMaybe<BasketItemCreateManySelectedSizeInputEnvelope>;
};

export type BasketItemCreateOrConnectWithoutBasketInput = {
  create: BasketItemCreateWithoutBasketInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemCreateOrConnectWithoutPriceInput = {
  create: BasketItemCreateWithoutPriceInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemCreateOrConnectWithoutProductInput = {
  create: BasketItemCreateWithoutProductInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemCreateOrConnectWithoutSelectedColorInput = {
  create: BasketItemCreateWithoutSelectedColorInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemCreateOrConnectWithoutSelectedSizeInput = {
  create: BasketItemCreateWithoutSelectedSizeInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemCreateWithoutBasketInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price: PriceCreateNestedOneWithoutBasketItemsInput;
  product: ProductCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<ProductColorCreateNestedOneWithoutBasketItemInput>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutBasketItemInput>;
};

export type BasketItemCreateWithoutPriceInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basket: BasketCreateNestedOneWithoutBasketItemInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<ProductColorCreateNestedOneWithoutBasketItemInput>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutBasketItemInput>;
};

export type BasketItemCreateWithoutProductInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basket: BasketCreateNestedOneWithoutBasketItemInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price: PriceCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<ProductColorCreateNestedOneWithoutBasketItemInput>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutBasketItemInput>;
};

export type BasketItemCreateWithoutSelectedColorInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basket: BasketCreateNestedOneWithoutBasketItemInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price: PriceCreateNestedOneWithoutBasketItemsInput;
  product: ProductCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutBasketItemInput>;
};

export type BasketItemCreateWithoutSelectedSizeInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  basket: BasketCreateNestedOneWithoutBasketItemInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price: PriceCreateNestedOneWithoutBasketItemsInput;
  product: ProductCreateNestedOneWithoutBasketItemsInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedColor?: InputMaybe<ProductColorCreateNestedOneWithoutBasketItemInput>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
};

export type BasketItemGroupBy = {
  __typename?: 'BasketItemGroupBy';
  _avg?: Maybe<BasketItemAvgAggregate>;
  _count?: Maybe<BasketItemCountAggregate>;
  _max?: Maybe<BasketItemMaxAggregate>;
  _min?: Maybe<BasketItemMinAggregate>;
  _sum?: Maybe<BasketItemSumAggregate>;
  additionalInfo?: Maybe<Scalars['String']>;
  basketId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  priceId: Scalars['String'];
  productId: Scalars['String'];
  quantity: Scalars['Int'];
  selectedColorId?: Maybe<Scalars['String']>;
  selectedCurrencyCode: Scalars['String'];
  selectedPrice: Scalars['Float'];
  selectedProductSizeId?: Maybe<Scalars['String']>;
};

export type BasketItemListRelationFilter = {
  every?: InputMaybe<BasketItemWhereInput>;
  none?: InputMaybe<BasketItemWhereInput>;
  some?: InputMaybe<BasketItemWhereInput>;
};

export type BasketItemMaxAggregate = {
  __typename?: 'BasketItemMaxAggregate';
  additionalInfo?: Maybe<Scalars['String']>;
  basketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  selectedColorId?: Maybe<Scalars['String']>;
  selectedCurrencyCode?: Maybe<Scalars['String']>;
  selectedPrice?: Maybe<Scalars['Float']>;
  selectedProductSizeId?: Maybe<Scalars['String']>;
};

export type BasketItemMaxOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  basketId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedColorId?: InputMaybe<SortOrder>;
  selectedCurrencyCode?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
};

export type BasketItemMinAggregate = {
  __typename?: 'BasketItemMinAggregate';
  additionalInfo?: Maybe<Scalars['String']>;
  basketId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  priceId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  selectedColorId?: Maybe<Scalars['String']>;
  selectedCurrencyCode?: Maybe<Scalars['String']>;
  selectedPrice?: Maybe<Scalars['Float']>;
  selectedProductSizeId?: Maybe<Scalars['String']>;
};

export type BasketItemMinOrderByAggregateInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  basketId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedColorId?: InputMaybe<SortOrder>;
  selectedCurrencyCode?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
};

export type BasketItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BasketItemOrderByWithAggregationInput = {
  _avg?: InputMaybe<BasketItemAvgOrderByAggregateInput>;
  _count?: InputMaybe<BasketItemCountOrderByAggregateInput>;
  _max?: InputMaybe<BasketItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<BasketItemMinOrderByAggregateInput>;
  _sum?: InputMaybe<BasketItemSumOrderByAggregateInput>;
  additionalInfo?: InputMaybe<SortOrder>;
  basketId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  priceId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedColorId?: InputMaybe<SortOrder>;
  selectedCurrencyCode?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
};

export type BasketItemOrderByWithRelationInput = {
  additionalInfo?: InputMaybe<SortOrder>;
  basket?: InputMaybe<BasketOrderByWithRelationInput>;
  basketId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<PriceOrderByWithRelationInput>;
  priceId?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedColor?: InputMaybe<ProductColorOrderByWithRelationInput>;
  selectedColorId?: InputMaybe<SortOrder>;
  selectedCurrencyCode?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
  selectedSize?: InputMaybe<ProductSizeOrderByWithRelationInput>;
};

export enum BasketItemScalarFieldEnum {
  additionalInfo = 'additionalInfo',
  basketId = 'basketId',
  createdAt = 'createdAt',
  id = 'id',
  priceId = 'priceId',
  productId = 'productId',
  quantity = 'quantity',
  selectedColorId = 'selectedColorId',
  selectedCurrencyCode = 'selectedCurrencyCode',
  selectedPrice = 'selectedPrice',
  selectedProductSizeId = 'selectedProductSizeId'
}

export type BasketItemScalarWhereInput = {
  AND?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  OR?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  additionalInfo?: InputMaybe<StringNullableFilter>;
  basketId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  priceId?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  selectedColorId?: InputMaybe<StringNullableFilter>;
  selectedCurrencyCode?: InputMaybe<StringFilter>;
  selectedPrice?: InputMaybe<FloatFilter>;
  selectedProductSizeId?: InputMaybe<StringNullableFilter>;
};

export type BasketItemScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BasketItemScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BasketItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BasketItemScalarWhereWithAggregatesInput>>;
  additionalInfo?: InputMaybe<StringNullableWithAggregatesFilter>;
  basketId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  priceId?: InputMaybe<StringWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
  quantity?: InputMaybe<IntWithAggregatesFilter>;
  selectedColorId?: InputMaybe<StringNullableWithAggregatesFilter>;
  selectedCurrencyCode?: InputMaybe<StringWithAggregatesFilter>;
  selectedPrice?: InputMaybe<FloatWithAggregatesFilter>;
  selectedProductSizeId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type BasketItemSumAggregate = {
  __typename?: 'BasketItemSumAggregate';
  quantity?: Maybe<Scalars['Int']>;
  selectedPrice?: Maybe<Scalars['Float']>;
};

export type BasketItemSumOrderByAggregateInput = {
  quantity?: InputMaybe<SortOrder>;
  selectedPrice?: InputMaybe<SortOrder>;
};

export type BasketItemUpdateInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  basket?: InputMaybe<BasketUpdateOneRequiredWithoutBasketItemInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<PriceUpdateOneRequiredWithoutBasketItemsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedColor?: InputMaybe<ProductColorUpdateOneWithoutBasketItemInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutBasketItemInput>;
};

export type BasketItemUpdateManyMutationInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type BasketItemUpdateManyWithWhereWithoutBasketInput = {
  data: BasketItemUpdateManyMutationInput;
  where: BasketItemScalarWhereInput;
};

export type BasketItemUpdateManyWithWhereWithoutPriceInput = {
  data: BasketItemUpdateManyMutationInput;
  where: BasketItemScalarWhereInput;
};

export type BasketItemUpdateManyWithWhereWithoutProductInput = {
  data: BasketItemUpdateManyMutationInput;
  where: BasketItemScalarWhereInput;
};

export type BasketItemUpdateManyWithWhereWithoutSelectedColorInput = {
  data: BasketItemUpdateManyMutationInput;
  where: BasketItemScalarWhereInput;
};

export type BasketItemUpdateManyWithWhereWithoutSelectedSizeInput = {
  data: BasketItemUpdateManyMutationInput;
  where: BasketItemScalarWhereInput;
};

export type BasketItemUpdateManyWithoutBasketInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutBasketInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutBasketInput>>;
  createMany?: InputMaybe<BasketItemCreateManyBasketInputEnvelope>;
  delete?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  update?: InputMaybe<Array<BasketItemUpdateWithWhereUniqueWithoutBasketInput>>;
  updateMany?: InputMaybe<Array<BasketItemUpdateManyWithWhereWithoutBasketInput>>;
  upsert?: InputMaybe<Array<BasketItemUpsertWithWhereUniqueWithoutBasketInput>>;
};

export type BasketItemUpdateManyWithoutPriceInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutPriceInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutPriceInput>>;
  createMany?: InputMaybe<BasketItemCreateManyPriceInputEnvelope>;
  delete?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  update?: InputMaybe<Array<BasketItemUpdateWithWhereUniqueWithoutPriceInput>>;
  updateMany?: InputMaybe<Array<BasketItemUpdateManyWithWhereWithoutPriceInput>>;
  upsert?: InputMaybe<Array<BasketItemUpsertWithWhereUniqueWithoutPriceInput>>;
};

export type BasketItemUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutProductInput>>;
  createMany?: InputMaybe<BasketItemCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  update?: InputMaybe<Array<BasketItemUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<BasketItemUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<BasketItemUpsertWithWhereUniqueWithoutProductInput>>;
};

export type BasketItemUpdateManyWithoutSelectedColorInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutSelectedColorInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutSelectedColorInput>>;
  createMany?: InputMaybe<BasketItemCreateManySelectedColorInputEnvelope>;
  delete?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  update?: InputMaybe<Array<BasketItemUpdateWithWhereUniqueWithoutSelectedColorInput>>;
  updateMany?: InputMaybe<Array<BasketItemUpdateManyWithWhereWithoutSelectedColorInput>>;
  upsert?: InputMaybe<Array<BasketItemUpsertWithWhereUniqueWithoutSelectedColorInput>>;
};

export type BasketItemUpdateManyWithoutSelectedSizeInput = {
  connect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BasketItemCreateOrConnectWithoutSelectedSizeInput>>;
  create?: InputMaybe<Array<BasketItemCreateWithoutSelectedSizeInput>>;
  createMany?: InputMaybe<BasketItemCreateManySelectedSizeInputEnvelope>;
  delete?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BasketItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BasketItemWhereUniqueInput>>;
  update?: InputMaybe<Array<BasketItemUpdateWithWhereUniqueWithoutSelectedSizeInput>>;
  updateMany?: InputMaybe<Array<BasketItemUpdateManyWithWhereWithoutSelectedSizeInput>>;
  upsert?: InputMaybe<Array<BasketItemUpsertWithWhereUniqueWithoutSelectedSizeInput>>;
};

export type BasketItemUpdateWithWhereUniqueWithoutBasketInput = {
  data: BasketItemUpdateWithoutBasketInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpdateWithWhereUniqueWithoutPriceInput = {
  data: BasketItemUpdateWithoutPriceInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpdateWithWhereUniqueWithoutProductInput = {
  data: BasketItemUpdateWithoutProductInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpdateWithWhereUniqueWithoutSelectedColorInput = {
  data: BasketItemUpdateWithoutSelectedColorInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpdateWithWhereUniqueWithoutSelectedSizeInput = {
  data: BasketItemUpdateWithoutSelectedSizeInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpdateWithoutBasketInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<PriceUpdateOneRequiredWithoutBasketItemsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedColor?: InputMaybe<ProductColorUpdateOneWithoutBasketItemInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutBasketItemInput>;
};

export type BasketItemUpdateWithoutPriceInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  basket?: InputMaybe<BasketUpdateOneRequiredWithoutBasketItemInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedColor?: InputMaybe<ProductColorUpdateOneWithoutBasketItemInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutBasketItemInput>;
};

export type BasketItemUpdateWithoutProductInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  basket?: InputMaybe<BasketUpdateOneRequiredWithoutBasketItemInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<PriceUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedColor?: InputMaybe<ProductColorUpdateOneWithoutBasketItemInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutBasketItemInput>;
};

export type BasketItemUpdateWithoutSelectedColorInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  basket?: InputMaybe<BasketUpdateOneRequiredWithoutBasketItemInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<PriceUpdateOneRequiredWithoutBasketItemsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutBasketItemInput>;
};

export type BasketItemUpdateWithoutSelectedSizeInput = {
  additionalInfo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  basket?: InputMaybe<BasketUpdateOneRequiredWithoutBasketItemInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<PriceUpdateOneRequiredWithoutBasketItemsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutBasketItemsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedColor?: InputMaybe<ProductColorUpdateOneWithoutBasketItemInput>;
  selectedCurrencyCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  selectedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type BasketItemUpsertWithWhereUniqueWithoutBasketInput = {
  create: BasketItemCreateWithoutBasketInput;
  update: BasketItemUpdateWithoutBasketInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpsertWithWhereUniqueWithoutPriceInput = {
  create: BasketItemCreateWithoutPriceInput;
  update: BasketItemUpdateWithoutPriceInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpsertWithWhereUniqueWithoutProductInput = {
  create: BasketItemCreateWithoutProductInput;
  update: BasketItemUpdateWithoutProductInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpsertWithWhereUniqueWithoutSelectedColorInput = {
  create: BasketItemCreateWithoutSelectedColorInput;
  update: BasketItemUpdateWithoutSelectedColorInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemUpsertWithWhereUniqueWithoutSelectedSizeInput = {
  create: BasketItemCreateWithoutSelectedSizeInput;
  update: BasketItemUpdateWithoutSelectedSizeInput;
  where: BasketItemWhereUniqueInput;
};

export type BasketItemWhereInput = {
  AND?: InputMaybe<Array<BasketItemWhereInput>>;
  NOT?: InputMaybe<Array<BasketItemWhereInput>>;
  OR?: InputMaybe<Array<BasketItemWhereInput>>;
  additionalInfo?: InputMaybe<StringNullableFilter>;
  basket?: InputMaybe<BasketRelationFilter>;
  basketId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<PriceRelationFilter>;
  priceId?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  selectedColor?: InputMaybe<ProductColorRelationFilter>;
  selectedColorId?: InputMaybe<StringNullableFilter>;
  selectedCurrencyCode?: InputMaybe<StringFilter>;
  selectedPrice?: InputMaybe<FloatFilter>;
  selectedProductSizeId?: InputMaybe<StringNullableFilter>;
  selectedSize?: InputMaybe<ProductSizeRelationFilter>;
};

export type BasketItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BasketMaxAggregate = {
  __typename?: 'BasketMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type BasketMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BasketMinAggregate = {
  __typename?: 'BasketMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type BasketMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BasketOrderByWithAggregationInput = {
  _count?: InputMaybe<BasketCountOrderByAggregateInput>;
  _max?: InputMaybe<BasketMaxOrderByAggregateInput>;
  _min?: InputMaybe<BasketMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BasketOrderByWithRelationInput = {
  basketItem?: InputMaybe<BasketItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type BasketRelationFilter = {
  is?: InputMaybe<BasketWhereInput>;
  isNot?: InputMaybe<BasketWhereInput>;
};

export enum BasketScalarFieldEnum {
  createdAt = 'createdAt',
  customerId = 'customerId',
  id = 'id'
}

export type BasketScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<BasketScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<BasketScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<BasketScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
};

export type BasketUpdateInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutBasketInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutBasketInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BasketUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BasketUpdateOneRequiredWithoutBasketItemInput = {
  connect?: InputMaybe<BasketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BasketCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<BasketCreateWithoutBasketItemInput>;
  update?: InputMaybe<BasketUpdateWithoutBasketItemInput>;
  upsert?: InputMaybe<BasketUpsertWithoutBasketItemInput>;
};

export type BasketUpdateOneWithoutCustomerInput = {
  connect?: InputMaybe<BasketWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BasketCreateOrConnectWithoutCustomerInput>;
  create?: InputMaybe<BasketCreateWithoutCustomerInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BasketUpdateWithoutCustomerInput>;
  upsert?: InputMaybe<BasketUpsertWithoutCustomerInput>;
};

export type BasketUpdateWithoutBasketItemInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutBasketInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BasketUpdateWithoutCustomerInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutBasketInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BasketUpsertWithoutBasketItemInput = {
  create: BasketCreateWithoutBasketItemInput;
  update: BasketUpdateWithoutBasketItemInput;
};

export type BasketUpsertWithoutCustomerInput = {
  create: BasketCreateWithoutCustomerInput;
  update: BasketUpdateWithoutCustomerInput;
};

export type BasketWhereInput = {
  AND?: InputMaybe<Array<BasketWhereInput>>;
  NOT?: InputMaybe<Array<BasketWhereInput>>;
  OR?: InputMaybe<Array<BasketWhereInput>>;
  basketItem?: InputMaybe<BasketItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
};

export type BasketWhereUniqueInput = {
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export enum BrandType {
  BOLDPIECES = 'BOLDPIECES',
  SINEMIS = 'SINEMIS'
}

export type Category = {
  __typename?: 'Category';
  _count?: Maybe<CategoryCount>;
  brand: BrandType;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  discountAmount: Scalars['Float'];
  id: Scalars['String'];
  order: Scalars['Int'];
  parentCategory?: Maybe<Category>;
  parentCategoryId?: Maybe<Scalars['String']>;
  photos: Array<Scalars['String']>;
  products: Array<Product>;
  status: Scalars['Boolean'];
  subCategories: Array<Category>;
};


export type CategoryDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type CategoryProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type CategorySubCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};

export type CategoryAvgAggregate = {
  __typename?: 'CategoryAvgAggregate';
  discountAmount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type CategoryAvgOrderByAggregateInput = {
  discountAmount?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type CategoryCount = {
  __typename?: 'CategoryCount';
  descriptions: Scalars['Int'];
  products: Scalars['Int'];
  subCategories: Scalars['Int'];
};

export type CategoryCountAggregate = {
  __typename?: 'CategoryCountAggregate';
  _all: Scalars['Int'];
  brand: Scalars['Int'];
  createdAt: Scalars['Int'];
  discountAmount: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  parentCategoryId: Scalars['Int'];
  photos: Scalars['Int'];
  status: Scalars['Int'];
};

export type CategoryCountOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  parentCategoryId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CategoryCreateInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCategoryInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
};

export type CategoryCreateManyInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentCategoryId?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryCreateManyParentCategoryInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryCreateManyParentCategoryInputEnvelope = {
  data: Array<CategoryCreateManyParentCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryCreateNestedManyWithoutParentCategoryInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutParentCategoryInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutParentCategoryInput>>;
  createMany?: InputMaybe<CategoryCreateManyParentCategoryInputEnvelope>;
};

export type CategoryCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CategoryCreateWithoutDescriptionsInput>;
};

export type CategoryCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CategoryCreateWithoutProductsInput>;
};

export type CategoryCreateNestedOneWithoutSubCategoriesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSubCategoriesInput>;
  create?: InputMaybe<CategoryCreateWithoutSubCategoriesInput>;
};

export type CategoryCreateOrConnectWithoutDescriptionsInput = {
  create: CategoryCreateWithoutDescriptionsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutParentCategoryInput = {
  create: CategoryCreateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutProductsInput = {
  create: CategoryCreateWithoutProductsInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateOrConnectWithoutSubCategoriesInput = {
  create: CategoryCreateWithoutSubCategoriesInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryCreateWithoutDescriptionsInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCategoryInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
};

export type CategoryCreateWithoutParentCategoryInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCategoryInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
};

export type CategoryCreateWithoutProductsInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
  subCategories?: InputMaybe<CategoryCreateNestedManyWithoutParentCategoryInput>;
};

export type CategoryCreateWithoutSubCategoriesInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  parentCategory?: InputMaybe<CategoryCreateNestedOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCategoryInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CategoryCreatephotosInput = {
  set: Array<Scalars['String']>;
};

export type CategoryGroupBy = {
  __typename?: 'CategoryGroupBy';
  _avg?: Maybe<CategoryAvgAggregate>;
  _count?: Maybe<CategoryCountAggregate>;
  _max?: Maybe<CategoryMaxAggregate>;
  _min?: Maybe<CategoryMinAggregate>;
  _sum?: Maybe<CategorySumAggregate>;
  brand: BrandType;
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  id: Scalars['String'];
  order: Scalars['Int'];
  parentCategoryId?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Scalars['String']>>;
  status: Scalars['Boolean'];
};

export type CategoryListRelationFilter = {
  every?: InputMaybe<CategoryWhereInput>;
  none?: InputMaybe<CategoryWhereInput>;
  some?: InputMaybe<CategoryWhereInput>;
};

export type CategoryMaxAggregate = {
  __typename?: 'CategoryMaxAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentCategoryId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CategoryMaxOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  parentCategoryId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CategoryMinAggregate = {
  __typename?: 'CategoryMinAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  parentCategoryId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CategoryMinOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  parentCategoryId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<CategoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<CategoryCountOrderByAggregateInput>;
  _max?: InputMaybe<CategoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<CategoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<CategorySumOrderByAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  parentCategoryId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CategoryOrderByWithRelationInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  discountAmount?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  parentCategory?: InputMaybe<CategoryOrderByWithRelationInput>;
  parentCategoryId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  subCategories?: InputMaybe<CategoryOrderByRelationAggregateInput>;
};

export type CategoryRelationFilter = {
  is?: InputMaybe<CategoryWhereInput>;
  isNot?: InputMaybe<CategoryWhereInput>;
};

export enum CategoryScalarFieldEnum {
  brand = 'brand',
  createdAt = 'createdAt',
  discountAmount = 'discountAmount',
  id = 'id',
  order = 'order',
  parentCategoryId = 'parentCategoryId',
  photos = 'photos',
  status = 'status'
}

export type CategoryScalarWhereInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereInput>>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discountAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  parentCategoryId?: InputMaybe<StringNullableFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type CategoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CategoryScalarWhereWithAggregatesInput>>;
  brand?: InputMaybe<EnumBrandTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  discountAmount?: InputMaybe<FloatWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  parentCategoryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type CategorySumAggregate = {
  __typename?: 'CategorySumAggregate';
  discountAmount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Int']>;
};

export type CategorySumOrderByAggregateInput = {
  discountAmount?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type CategoryUpdateInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCategoryInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryInput>;
};

export type CategoryUpdateManyMutationInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CategoryUpdateManyWithWhereWithoutParentCategoryInput = {
  data: CategoryUpdateManyMutationInput;
  where: CategoryScalarWhereInput;
};

export type CategoryUpdateManyWithoutParentCategoryInput = {
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CategoryCreateOrConnectWithoutParentCategoryInput>>;
  create?: InputMaybe<Array<CategoryCreateWithoutParentCategoryInput>>;
  createMany?: InputMaybe<CategoryCreateManyParentCategoryInputEnvelope>;
  delete?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<CategoryUpdateWithWhereUniqueWithoutParentCategoryInput>>;
  updateMany?: InputMaybe<Array<CategoryUpdateManyWithWhereWithoutParentCategoryInput>>;
  upsert?: InputMaybe<Array<CategoryUpsertWithWhereUniqueWithoutParentCategoryInput>>;
};

export type CategoryUpdateOneRequiredWithoutProductsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CategoryCreateWithoutProductsInput>;
  update?: InputMaybe<CategoryUpdateWithoutProductsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutProductsInput>;
};

export type CategoryUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CategoryCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CategoryUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutDescriptionsInput>;
};

export type CategoryUpdateOneWithoutSubCategoriesInput = {
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CategoryCreateOrConnectWithoutSubCategoriesInput>;
  create?: InputMaybe<CategoryCreateWithoutSubCategoriesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CategoryUpdateWithoutSubCategoriesInput>;
  upsert?: InputMaybe<CategoryUpsertWithoutSubCategoriesInput>;
};

export type CategoryUpdateWithWhereUniqueWithoutParentCategoryInput = {
  data: CategoryUpdateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateWithoutDescriptionsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCategoryInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryInput>;
};

export type CategoryUpdateWithoutParentCategoryInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCategoryInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryInput>;
};

export type CategoryUpdateWithoutProductsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  subCategories?: InputMaybe<CategoryUpdateManyWithoutParentCategoryInput>;
};

export type CategoryUpdateWithoutSubCategoriesInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCategoryInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  parentCategory?: InputMaybe<CategoryUpdateOneWithoutSubCategoriesInput>;
  photos?: InputMaybe<CategoryUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCategoryInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CategoryUpdatephotosInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type CategoryUpsertWithWhereUniqueWithoutParentCategoryInput = {
  create: CategoryCreateWithoutParentCategoryInput;
  update: CategoryUpdateWithoutParentCategoryInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpsertWithoutDescriptionsInput = {
  create: CategoryCreateWithoutDescriptionsInput;
  update: CategoryUpdateWithoutDescriptionsInput;
};

export type CategoryUpsertWithoutProductsInput = {
  create: CategoryCreateWithoutProductsInput;
  update: CategoryUpdateWithoutProductsInput;
};

export type CategoryUpsertWithoutSubCategoriesInput = {
  create: CategoryCreateWithoutSubCategoriesInput;
  update: CategoryUpdateWithoutSubCategoriesInput;
};

export type CategoryWhereInput = {
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  NOT?: InputMaybe<Array<CategoryWhereInput>>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  discountAmount?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  parentCategory?: InputMaybe<CategoryRelationFilter>;
  parentCategoryId?: InputMaybe<StringNullableFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  status?: InputMaybe<BoolFilter>;
  subCategories?: InputMaybe<CategoryListRelationFilter>;
};

export type CategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Collection = {
  __typename?: 'Collection';
  _count?: Maybe<CollectionCount>;
  brand: BrandType;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  order: Scalars['Int'];
  photos: Array<Scalars['String']>;
  products: Array<Product>;
  status: Scalars['Boolean'];
};


export type CollectionDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type CollectionProductsArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};

export type CollectionAvgAggregate = {
  __typename?: 'CollectionAvgAggregate';
  order?: Maybe<Scalars['Float']>;
};

export type CollectionAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type CollectionCount = {
  __typename?: 'CollectionCount';
  descriptions: Scalars['Int'];
  products: Scalars['Int'];
};

export type CollectionCountAggregate = {
  __typename?: 'CollectionCountAggregate';
  _all: Scalars['Int'];
  brand: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  photos: Scalars['Int'];
  status: Scalars['Int'];
};

export type CollectionCountOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CollectionCreateInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCollectionInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CollectionCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCollectionInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CollectionCreateManyInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CollectionCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CollectionCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CollectionCreateWithoutDescriptionsInput>;
};

export type CollectionCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<CollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CollectionCreateWithoutProductsInput>;
};

export type CollectionCreateOrConnectWithoutDescriptionsInput = {
  create: CollectionCreateWithoutDescriptionsInput;
  where: CollectionWhereUniqueInput;
};

export type CollectionCreateOrConnectWithoutProductsInput = {
  create: CollectionCreateWithoutProductsInput;
  where: CollectionWhereUniqueInput;
};

export type CollectionCreateWithoutDescriptionsInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CollectionCreatephotosInput>;
  products?: InputMaybe<ProductCreateNestedManyWithoutCollectionInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CollectionCreateWithoutProductsInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCollectionInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<CollectionCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type CollectionCreatephotosInput = {
  set: Array<Scalars['String']>;
};

export type CollectionGroupBy = {
  __typename?: 'CollectionGroupBy';
  _avg?: Maybe<CollectionAvgAggregate>;
  _count?: Maybe<CollectionCountAggregate>;
  _max?: Maybe<CollectionMaxAggregate>;
  _min?: Maybe<CollectionMinAggregate>;
  _sum?: Maybe<CollectionSumAggregate>;
  brand: BrandType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  photos?: Maybe<Array<Scalars['String']>>;
  status: Scalars['Boolean'];
};

export type CollectionMaxAggregate = {
  __typename?: 'CollectionMaxAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CollectionMaxOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CollectionMinAggregate = {
  __typename?: 'CollectionMinAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type CollectionMinOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CollectionOrderByWithAggregationInput = {
  _avg?: InputMaybe<CollectionAvgOrderByAggregateInput>;
  _count?: InputMaybe<CollectionCountOrderByAggregateInput>;
  _max?: InputMaybe<CollectionMaxOrderByAggregateInput>;
  _min?: InputMaybe<CollectionMinOrderByAggregateInput>;
  _sum?: InputMaybe<CollectionSumOrderByAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type CollectionOrderByWithRelationInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  products?: InputMaybe<ProductOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
};

export type CollectionRelationFilter = {
  is?: InputMaybe<CollectionWhereInput>;
  isNot?: InputMaybe<CollectionWhereInput>;
};

export enum CollectionScalarFieldEnum {
  brand = 'brand',
  createdAt = 'createdAt',
  id = 'id',
  order = 'order',
  photos = 'photos',
  status = 'status'
}

export type CollectionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CollectionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CollectionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CollectionScalarWhereWithAggregatesInput>>;
  brand?: InputMaybe<EnumBrandTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type CollectionSumAggregate = {
  __typename?: 'CollectionSumAggregate';
  order?: Maybe<Scalars['Int']>;
};

export type CollectionSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type CollectionUpdateInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCollectionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CollectionUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCollectionInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CollectionUpdateManyMutationInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CollectionUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CollectionUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CollectionCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CollectionUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<CollectionUpsertWithoutDescriptionsInput>;
};

export type CollectionUpdateOneWithoutProductsInput = {
  connect?: InputMaybe<CollectionWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CollectionCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<CollectionCreateWithoutProductsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CollectionUpdateWithoutProductsInput>;
  upsert?: InputMaybe<CollectionUpsertWithoutProductsInput>;
};

export type CollectionUpdateWithoutDescriptionsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CollectionUpdatephotosInput>;
  products?: InputMaybe<ProductUpdateManyWithoutCollectionInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CollectionUpdateWithoutProductsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCollectionInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<CollectionUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type CollectionUpdatephotosInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type CollectionUpsertWithoutDescriptionsInput = {
  create: CollectionCreateWithoutDescriptionsInput;
  update: CollectionUpdateWithoutDescriptionsInput;
};

export type CollectionUpsertWithoutProductsInput = {
  create: CollectionCreateWithoutProductsInput;
  update: CollectionUpdateWithoutProductsInput;
};

export type CollectionWhereInput = {
  AND?: InputMaybe<Array<CollectionWhereInput>>;
  NOT?: InputMaybe<Array<CollectionWhereInput>>;
  OR?: InputMaybe<Array<CollectionWhereInput>>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  products?: InputMaybe<ProductListRelationFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type CollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Color = {
  __typename?: 'Color';
  _count?: Maybe<ColorCount>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  order: Scalars['Int'];
  photos: Array<Scalars['String']>;
  productColor: Array<ProductColor>;
  status: Scalars['Boolean'];
};


export type ColorDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type ColorProductColorArgs = {
  cursor?: InputMaybe<ProductColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};

export type ColorAvgAggregate = {
  __typename?: 'ColorAvgAggregate';
  order?: Maybe<Scalars['Float']>;
};

export type ColorAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ColorCount = {
  __typename?: 'ColorCount';
  descriptions: Scalars['Int'];
  productColor: Scalars['Int'];
};

export type ColorCountAggregate = {
  __typename?: 'ColorCountAggregate';
  _all: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  photos: Scalars['Int'];
  status: Scalars['Int'];
};

export type ColorCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ColorCreateInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutColorInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ColorCreatephotosInput>;
  productColor?: InputMaybe<ProductColorCreateNestedManyWithoutColorInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ColorCreateManyInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ColorCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ColorCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ColorCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ColorCreateWithoutDescriptionsInput>;
};

export type ColorCreateNestedOneWithoutProductColorInput = {
  connect?: InputMaybe<ColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ColorCreateOrConnectWithoutProductColorInput>;
  create?: InputMaybe<ColorCreateWithoutProductColorInput>;
};

export type ColorCreateOrConnectWithoutDescriptionsInput = {
  create: ColorCreateWithoutDescriptionsInput;
  where: ColorWhereUniqueInput;
};

export type ColorCreateOrConnectWithoutProductColorInput = {
  create: ColorCreateWithoutProductColorInput;
  where: ColorWhereUniqueInput;
};

export type ColorCreateWithoutDescriptionsInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ColorCreatephotosInput>;
  productColor?: InputMaybe<ProductColorCreateNestedManyWithoutColorInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ColorCreateWithoutProductColorInput = {
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutColorInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ColorCreatephotosInput>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ColorCreatephotosInput = {
  set: Array<Scalars['String']>;
};

export type ColorGroupBy = {
  __typename?: 'ColorGroupBy';
  _avg?: Maybe<ColorAvgAggregate>;
  _count?: Maybe<ColorCountAggregate>;
  _max?: Maybe<ColorMaxAggregate>;
  _min?: Maybe<ColorMinAggregate>;
  _sum?: Maybe<ColorSumAggregate>;
  code?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  photos?: Maybe<Array<Scalars['String']>>;
  status: Scalars['Boolean'];
};

export type ColorMaxAggregate = {
  __typename?: 'ColorMaxAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ColorMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ColorMinAggregate = {
  __typename?: 'ColorMinAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ColorMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ColorOrderByWithAggregationInput = {
  _avg?: InputMaybe<ColorAvgOrderByAggregateInput>;
  _count?: InputMaybe<ColorCountOrderByAggregateInput>;
  _max?: InputMaybe<ColorMaxOrderByAggregateInput>;
  _min?: InputMaybe<ColorMinOrderByAggregateInput>;
  _sum?: InputMaybe<ColorSumOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ColorOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  productColor?: InputMaybe<ProductColorOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
};

export type ColorRelationFilter = {
  is?: InputMaybe<ColorWhereInput>;
  isNot?: InputMaybe<ColorWhereInput>;
};

export enum ColorScalarFieldEnum {
  code = 'code',
  createdAt = 'createdAt',
  id = 'id',
  order = 'order',
  photos = 'photos',
  status = 'status'
}

export type ColorScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ColorScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ColorScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ColorScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type ColorSumAggregate = {
  __typename?: 'ColorSumAggregate';
  order?: Maybe<Scalars['Int']>;
};

export type ColorSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ColorUpdateInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ColorUpdatephotosInput>;
  productColor?: InputMaybe<ProductColorUpdateManyWithoutColorInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ColorUpdateManyMutationInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ColorUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ColorUpdateOneRequiredWithoutProductColorInput = {
  connect?: InputMaybe<ColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ColorCreateOrConnectWithoutProductColorInput>;
  create?: InputMaybe<ColorCreateWithoutProductColorInput>;
  update?: InputMaybe<ColorUpdateWithoutProductColorInput>;
  upsert?: InputMaybe<ColorUpsertWithoutProductColorInput>;
};

export type ColorUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ColorCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ColorCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ColorUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<ColorUpsertWithoutDescriptionsInput>;
};

export type ColorUpdateWithoutDescriptionsInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ColorUpdatephotosInput>;
  productColor?: InputMaybe<ProductColorUpdateManyWithoutColorInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ColorUpdateWithoutProductColorInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ColorUpdatephotosInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ColorUpdatephotosInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type ColorUpsertWithoutDescriptionsInput = {
  create: ColorCreateWithoutDescriptionsInput;
  update: ColorUpdateWithoutDescriptionsInput;
};

export type ColorUpsertWithoutProductColorInput = {
  create: ColorCreateWithoutProductColorInput;
  update: ColorUpdateWithoutProductColorInput;
};

export type ColorWhereInput = {
  AND?: InputMaybe<Array<ColorWhereInput>>;
  NOT?: InputMaybe<Array<ColorWhereInput>>;
  OR?: InputMaybe<Array<ColorWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  productColor?: InputMaybe<ProductColorListRelationFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type ColorWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Content = {
  __typename?: 'Content';
  _count?: Maybe<ContentCount>;
  contentType: ContentType;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  mediaType: MediaType;
  order: Scalars['Int'];
  page?: Maybe<Page>;
  pageId?: Maybe<Scalars['String']>;
  photos: Array<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
};


export type ContentDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};

export type ContentAvgAggregate = {
  __typename?: 'ContentAvgAggregate';
  order?: Maybe<Scalars['Float']>;
};

export type ContentAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type ContentCount = {
  __typename?: 'ContentCount';
  descriptions: Scalars['Int'];
};

export type ContentCountAggregate = {
  __typename?: 'ContentCountAggregate';
  _all: Scalars['Int'];
  contentType: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  mediaType: Scalars['Int'];
  order: Scalars['Int'];
  pageId: Scalars['Int'];
  photos: Scalars['Int'];
  video: Scalars['Int'];
};

export type ContentCountOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  video?: InputMaybe<SortOrder>;
};

export type ContentCreateInput = {
  contentType: ContentType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutContentInput>;
  id?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<PageCreateNestedOneWithoutContentInput>;
  photos?: InputMaybe<ContentCreatephotosInput>;
  video?: InputMaybe<Scalars['String']>;
};

export type ContentCreateManyInput = {
  contentType: ContentType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  order?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['String']>;
  photos?: InputMaybe<ContentCreatephotosInput>;
  video?: InputMaybe<Scalars['String']>;
};

export type ContentCreateManyPageInput = {
  contentType: ContentType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ContentCreatephotosInput>;
  video?: InputMaybe<Scalars['String']>;
};

export type ContentCreateManyPageInputEnvelope = {
  data: Array<ContentCreateManyPageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ContentCreateNestedManyWithoutPageInput = {
  connect?: InputMaybe<Array<ContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentCreateOrConnectWithoutPageInput>>;
  create?: InputMaybe<Array<ContentCreateWithoutPageInput>>;
  createMany?: InputMaybe<ContentCreateManyPageInputEnvelope>;
};

export type ContentCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ContentCreateWithoutDescriptionsInput>;
};

export type ContentCreateOrConnectWithoutDescriptionsInput = {
  create: ContentCreateWithoutDescriptionsInput;
  where: ContentWhereUniqueInput;
};

export type ContentCreateOrConnectWithoutPageInput = {
  create: ContentCreateWithoutPageInput;
  where: ContentWhereUniqueInput;
};

export type ContentCreateWithoutDescriptionsInput = {
  contentType: ContentType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  order?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<PageCreateNestedOneWithoutContentInput>;
  photos?: InputMaybe<ContentCreatephotosInput>;
  video?: InputMaybe<Scalars['String']>;
};

export type ContentCreateWithoutPageInput = {
  contentType: ContentType;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutContentInput>;
  id?: InputMaybe<Scalars['String']>;
  mediaType: MediaType;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ContentCreatephotosInput>;
  video?: InputMaybe<Scalars['String']>;
};

export type ContentCreatephotosInput = {
  set: Array<Scalars['String']>;
};

export type ContentGroupBy = {
  __typename?: 'ContentGroupBy';
  _avg?: Maybe<ContentAvgAggregate>;
  _count?: Maybe<ContentCountAggregate>;
  _max?: Maybe<ContentMaxAggregate>;
  _min?: Maybe<ContentMinAggregate>;
  _sum?: Maybe<ContentSumAggregate>;
  contentType: ContentType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  mediaType: MediaType;
  order: Scalars['Int'];
  pageId?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Scalars['String']>>;
  video?: Maybe<Scalars['String']>;
};

export type ContentListRelationFilter = {
  every?: InputMaybe<ContentWhereInput>;
  none?: InputMaybe<ContentWhereInput>;
  some?: InputMaybe<ContentWhereInput>;
};

export type ContentMaxAggregate = {
  __typename?: 'ContentMaxAggregate';
  contentType?: Maybe<ContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaType>;
  order?: Maybe<Scalars['Int']>;
  pageId?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
};

export type ContentMaxOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  video?: InputMaybe<SortOrder>;
};

export type ContentMinAggregate = {
  __typename?: 'ContentMinAggregate';
  contentType?: Maybe<ContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaType>;
  order?: Maybe<Scalars['Int']>;
  pageId?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
};

export type ContentMinOrderByAggregateInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  video?: InputMaybe<SortOrder>;
};

export type ContentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContentOrderByWithAggregationInput = {
  _avg?: InputMaybe<ContentAvgOrderByAggregateInput>;
  _count?: InputMaybe<ContentCountOrderByAggregateInput>;
  _max?: InputMaybe<ContentMaxOrderByAggregateInput>;
  _min?: InputMaybe<ContentMinOrderByAggregateInput>;
  _sum?: InputMaybe<ContentSumOrderByAggregateInput>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  video?: InputMaybe<SortOrder>;
};

export type ContentOrderByWithRelationInput = {
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  mediaType?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<PageOrderByWithRelationInput>;
  pageId?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  video?: InputMaybe<SortOrder>;
};

export type ContentRelationFilter = {
  is?: InputMaybe<ContentWhereInput>;
  isNot?: InputMaybe<ContentWhereInput>;
};

export enum ContentScalarFieldEnum {
  contentType = 'contentType',
  createdAt = 'createdAt',
  id = 'id',
  mediaType = 'mediaType',
  order = 'order',
  pageId = 'pageId',
  photos = 'photos',
  video = 'video'
}

export type ContentScalarWhereInput = {
  AND?: InputMaybe<Array<ContentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ContentScalarWhereInput>>;
  OR?: InputMaybe<Array<ContentScalarWhereInput>>;
  contentType?: InputMaybe<EnumContentTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  order?: InputMaybe<IntFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  video?: InputMaybe<StringNullableFilter>;
};

export type ContentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ContentScalarWhereWithAggregatesInput>>;
  contentType?: InputMaybe<EnumContentTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  mediaType?: InputMaybe<EnumMediaTypeWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  pageId?: InputMaybe<StringNullableWithAggregatesFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  video?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ContentSumAggregate = {
  __typename?: 'ContentSumAggregate';
  order?: Maybe<Scalars['Int']>;
};

export type ContentSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export enum ContentType {
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  VIDEO = 'VIDEO'
}

export type ContentUpdateInput = {
  contentType?: InputMaybe<EnumContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutContentInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaType?: InputMaybe<EnumMediaTypeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutContentInput>;
  photos?: InputMaybe<ContentUpdatephotosInput>;
  video?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContentUpdateManyMutationInput = {
  contentType?: InputMaybe<EnumContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaType?: InputMaybe<EnumMediaTypeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ContentUpdatephotosInput>;
  video?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContentUpdateManyWithWhereWithoutPageInput = {
  data: ContentUpdateManyMutationInput;
  where: ContentScalarWhereInput;
};

export type ContentUpdateManyWithoutPageInput = {
  connect?: InputMaybe<Array<ContentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContentCreateOrConnectWithoutPageInput>>;
  create?: InputMaybe<Array<ContentCreateWithoutPageInput>>;
  createMany?: InputMaybe<ContentCreateManyPageInputEnvelope>;
  delete?: InputMaybe<Array<ContentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContentWhereUniqueInput>>;
  set?: InputMaybe<Array<ContentWhereUniqueInput>>;
  update?: InputMaybe<Array<ContentUpdateWithWhereUniqueWithoutPageInput>>;
  updateMany?: InputMaybe<Array<ContentUpdateManyWithWhereWithoutPageInput>>;
  upsert?: InputMaybe<Array<ContentUpsertWithWhereUniqueWithoutPageInput>>;
};

export type ContentUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ContentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ContentCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ContentCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ContentUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<ContentUpsertWithoutDescriptionsInput>;
};

export type ContentUpdateWithWhereUniqueWithoutPageInput = {
  data: ContentUpdateWithoutPageInput;
  where: ContentWhereUniqueInput;
};

export type ContentUpdateWithoutDescriptionsInput = {
  contentType?: InputMaybe<EnumContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaType?: InputMaybe<EnumMediaTypeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutContentInput>;
  photos?: InputMaybe<ContentUpdatephotosInput>;
  video?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContentUpdateWithoutPageInput = {
  contentType?: InputMaybe<EnumContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutContentInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  mediaType?: InputMaybe<EnumMediaTypeFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ContentUpdatephotosInput>;
  video?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ContentUpdatephotosInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type ContentUpsertWithWhereUniqueWithoutPageInput = {
  create: ContentCreateWithoutPageInput;
  update: ContentUpdateWithoutPageInput;
  where: ContentWhereUniqueInput;
};

export type ContentUpsertWithoutDescriptionsInput = {
  create: ContentCreateWithoutDescriptionsInput;
  update: ContentUpdateWithoutDescriptionsInput;
};

export type ContentWhereInput = {
  AND?: InputMaybe<Array<ContentWhereInput>>;
  NOT?: InputMaybe<Array<ContentWhereInput>>;
  OR?: InputMaybe<Array<ContentWhereInput>>;
  contentType?: InputMaybe<EnumContentTypeFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  mediaType?: InputMaybe<EnumMediaTypeFilter>;
  order?: InputMaybe<IntFilter>;
  page?: InputMaybe<PageRelationFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  video?: InputMaybe<StringNullableFilter>;
};

export type ContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type CreateCheckoutFormInput = {
  cartId: Scalars['String'];
  couponCode?: InputMaybe<Scalars['String']>;
  identityNumber: Scalars['String'];
  locale: Scalars['String'];
  paymentAddress: Scalars['String'];
  paymentAddressId: Scalars['String'];
  paymentCity: Scalars['String'];
  paymentCountry: Scalars['String'];
  paymentEmail: Scalars['String'];
  paymentFirstName: Scalars['String'];
  paymentLastName: Scalars['String'];
  paymentPhoneNumber: Scalars['String'];
  paymentPostalCode: Scalars['String'];
  shippingAddress: Scalars['String'];
  shippingAddressId: Scalars['String'];
  shippingCity: Scalars['String'];
  shippingCountry: Scalars['String'];
  shippingEmail: Scalars['String'];
  shippingFirstName: Scalars['String'];
  shippingLastName: Scalars['String'];
  shippingPhoneNumber: Scalars['String'];
  shippingPostalCode: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  _count?: Maybe<CurrencyCount>;
  autoUpdate: Scalars['Boolean'];
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  payments: Array<Payment>;
  prefix?: Maybe<Scalars['String']>;
  priceHistory: Array<PriceHistory>;
  prices: Array<Price>;
  productOrders: Array<ProductOrder>;
  sell: Scalars['Float'];
  status: Scalars['Boolean'];
  suffix?: Maybe<Scalars['String']>;
};


export type CurrencyDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type CurrencyPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type CurrencyPriceHistoryArgs = {
  cursor?: InputMaybe<PriceHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type CurrencyPricesArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type CurrencyProductOrdersArgs = {
  cursor?: InputMaybe<ProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductOrderWhereInput>;
};

export type CurrencyAvgAggregate = {
  __typename?: 'CurrencyAvgAggregate';
  buy?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
  sell?: Maybe<Scalars['Float']>;
};

export type CurrencyAvgOrderByAggregateInput = {
  buy?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
};

export type CurrencyCount = {
  __typename?: 'CurrencyCount';
  descriptions: Scalars['Int'];
  payments: Scalars['Int'];
  priceHistory: Scalars['Int'];
  prices: Scalars['Int'];
  productOrders: Scalars['Int'];
};

export type CurrencyCountAggregate = {
  __typename?: 'CurrencyCountAggregate';
  _all: Scalars['Int'];
  autoUpdate: Scalars['Int'];
  buy: Scalars['Int'];
  code: Scalars['Int'];
  id: Scalars['Int'];
  isDefault: Scalars['Int'];
  order: Scalars['Int'];
  prefix: Scalars['Int'];
  sell: Scalars['Int'];
  status: Scalars['Int'];
  suffix: Scalars['Int'];
};

export type CurrencyCountOrderByAggregateInput = {
  autoUpdate?: InputMaybe<SortOrder>;
  buy?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  prefix?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrder>;
};

export type CurrencyCreateInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCurrencyInput>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutCurrencyInput>;
  prefix?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<PriceHistoryCreateNestedManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateManyInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CurrencyCreateWithoutDescriptionsInput>;
};

export type CurrencyCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<CurrencyCreateWithoutPaymentsInput>;
};

export type CurrencyCreateNestedOneWithoutPriceHistoryInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPriceHistoryInput>;
  create?: InputMaybe<CurrencyCreateWithoutPriceHistoryInput>;
};

export type CurrencyCreateNestedOneWithoutPricesInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<CurrencyCreateWithoutPricesInput>;
};

export type CurrencyCreateNestedOneWithoutProductOrdersInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutProductOrdersInput>;
  create?: InputMaybe<CurrencyCreateWithoutProductOrdersInput>;
};

export type CurrencyCreateOrConnectWithoutDescriptionsInput = {
  create: CurrencyCreateWithoutDescriptionsInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutPaymentsInput = {
  create: CurrencyCreateWithoutPaymentsInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutPriceHistoryInput = {
  create: CurrencyCreateWithoutPriceHistoryInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutPricesInput = {
  create: CurrencyCreateWithoutPricesInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateOrConnectWithoutProductOrdersInput = {
  create: CurrencyCreateWithoutProductOrdersInput;
  where: CurrencyWhereUniqueInput;
};

export type CurrencyCreateWithoutDescriptionsInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutCurrencyInput>;
  prefix?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<PriceHistoryCreateNestedManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateWithoutPaymentsInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCurrencyInput>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  prefix?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<PriceHistoryCreateNestedManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateWithoutPriceHistoryInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCurrencyInput>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutCurrencyInput>;
  prefix?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateWithoutPricesInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCurrencyInput>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutCurrencyInput>;
  prefix?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<PriceHistoryCreateNestedManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyCreateWithoutProductOrdersInput = {
  autoUpdate?: InputMaybe<Scalars['Boolean']>;
  buy: Scalars['Float'];
  code: Scalars['String'];
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutCurrencyInput>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutCurrencyInput>;
  prefix?: InputMaybe<Scalars['String']>;
  priceHistory?: InputMaybe<PriceHistoryCreateNestedManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutCurrencyInput>;
  sell: Scalars['Float'];
  status?: InputMaybe<Scalars['Boolean']>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CurrencyGroupBy = {
  __typename?: 'CurrencyGroupBy';
  _avg?: Maybe<CurrencyAvgAggregate>;
  _count?: Maybe<CurrencyCountAggregate>;
  _max?: Maybe<CurrencyMaxAggregate>;
  _min?: Maybe<CurrencyMinAggregate>;
  _sum?: Maybe<CurrencySumAggregate>;
  autoUpdate: Scalars['Boolean'];
  buy: Scalars['Float'];
  code: Scalars['String'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  order: Scalars['Int'];
  prefix?: Maybe<Scalars['String']>;
  sell: Scalars['Float'];
  status: Scalars['Boolean'];
  suffix?: Maybe<Scalars['String']>;
};

export type CurrencyMaxAggregate = {
  __typename?: 'CurrencyMaxAggregate';
  autoUpdate?: Maybe<Scalars['Boolean']>;
  buy?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  prefix?: Maybe<Scalars['String']>;
  sell?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Boolean']>;
  suffix?: Maybe<Scalars['String']>;
};

export type CurrencyMaxOrderByAggregateInput = {
  autoUpdate?: InputMaybe<SortOrder>;
  buy?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  prefix?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrder>;
};

export type CurrencyMinAggregate = {
  __typename?: 'CurrencyMinAggregate';
  autoUpdate?: Maybe<Scalars['Boolean']>;
  buy?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  order?: Maybe<Scalars['Int']>;
  prefix?: Maybe<Scalars['String']>;
  sell?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['Boolean']>;
  suffix?: Maybe<Scalars['String']>;
};

export type CurrencyMinOrderByAggregateInput = {
  autoUpdate?: InputMaybe<SortOrder>;
  buy?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  prefix?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrder>;
};

export type CurrencyOrderByWithAggregationInput = {
  _avg?: InputMaybe<CurrencyAvgOrderByAggregateInput>;
  _count?: InputMaybe<CurrencyCountOrderByAggregateInput>;
  _max?: InputMaybe<CurrencyMaxOrderByAggregateInput>;
  _min?: InputMaybe<CurrencyMinOrderByAggregateInput>;
  _sum?: InputMaybe<CurrencySumOrderByAggregateInput>;
  autoUpdate?: InputMaybe<SortOrder>;
  buy?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  prefix?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrder>;
};

export type CurrencyOrderByWithRelationInput = {
  autoUpdate?: InputMaybe<SortOrder>;
  buy?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  prefix?: InputMaybe<SortOrder>;
  priceHistory?: InputMaybe<PriceHistoryOrderByRelationAggregateInput>;
  prices?: InputMaybe<PriceOrderByRelationAggregateInput>;
  productOrders?: InputMaybe<ProductOrderOrderByRelationAggregateInput>;
  sell?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  suffix?: InputMaybe<SortOrder>;
};

export type CurrencyRelationFilter = {
  is?: InputMaybe<CurrencyWhereInput>;
  isNot?: InputMaybe<CurrencyWhereInput>;
};

export enum CurrencyScalarFieldEnum {
  autoUpdate = 'autoUpdate',
  buy = 'buy',
  code = 'code',
  id = 'id',
  isDefault = 'isDefault',
  order = 'order',
  prefix = 'prefix',
  sell = 'sell',
  status = 'status',
  suffix = 'suffix'
}

export type CurrencyScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CurrencyScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CurrencyScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CurrencyScalarWhereWithAggregatesInput>>;
  autoUpdate?: InputMaybe<BoolWithAggregatesFilter>;
  buy?: InputMaybe<FloatWithAggregatesFilter>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isDefault?: InputMaybe<BoolWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  prefix?: InputMaybe<StringNullableWithAggregatesFilter>;
  sell?: InputMaybe<FloatWithAggregatesFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
  suffix?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type CurrencySumAggregate = {
  __typename?: 'CurrencySumAggregate';
  buy?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Int']>;
  sell?: Maybe<Scalars['Float']>;
};

export type CurrencySumOrderByAggregateInput = {
  buy?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sell?: InputMaybe<SortOrder>;
};

export type CurrencyUpdateInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCurrencyInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutCurrencyInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceHistory?: InputMaybe<PriceHistoryUpdateManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateManyMutationInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateOneRequiredWithoutPaymentsInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<CurrencyCreateWithoutPaymentsInput>;
  update?: InputMaybe<CurrencyUpdateWithoutPaymentsInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutPaymentsInput>;
};

export type CurrencyUpdateOneRequiredWithoutPriceHistoryInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPriceHistoryInput>;
  create?: InputMaybe<CurrencyCreateWithoutPriceHistoryInput>;
  update?: InputMaybe<CurrencyUpdateWithoutPriceHistoryInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutPriceHistoryInput>;
};

export type CurrencyUpdateOneRequiredWithoutPricesInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<CurrencyCreateWithoutPricesInput>;
  update?: InputMaybe<CurrencyUpdateWithoutPricesInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutPricesInput>;
};

export type CurrencyUpdateOneRequiredWithoutProductOrdersInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutProductOrdersInput>;
  create?: InputMaybe<CurrencyCreateWithoutProductOrdersInput>;
  update?: InputMaybe<CurrencyUpdateWithoutProductOrdersInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutProductOrdersInput>;
};

export type CurrencyUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<CurrencyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CurrencyCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<CurrencyCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CurrencyUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<CurrencyUpsertWithoutDescriptionsInput>;
};

export type CurrencyUpdateWithoutDescriptionsInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutCurrencyInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceHistory?: InputMaybe<PriceHistoryUpdateManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutPaymentsInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCurrencyInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceHistory?: InputMaybe<PriceHistoryUpdateManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutPriceHistoryInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCurrencyInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutCurrencyInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutPricesInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCurrencyInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutCurrencyInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceHistory?: InputMaybe<PriceHistoryUpdateManyWithoutCurrencyInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpdateWithoutProductOrdersInput = {
  autoUpdate?: InputMaybe<BoolFieldUpdateOperationsInput>;
  buy?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutCurrencyInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutCurrencyInput>;
  prefix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  priceHistory?: InputMaybe<PriceHistoryUpdateManyWithoutCurrencyInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutCurrencyInput>;
  sell?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  suffix?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CurrencyUpsertWithoutDescriptionsInput = {
  create: CurrencyCreateWithoutDescriptionsInput;
  update: CurrencyUpdateWithoutDescriptionsInput;
};

export type CurrencyUpsertWithoutPaymentsInput = {
  create: CurrencyCreateWithoutPaymentsInput;
  update: CurrencyUpdateWithoutPaymentsInput;
};

export type CurrencyUpsertWithoutPriceHistoryInput = {
  create: CurrencyCreateWithoutPriceHistoryInput;
  update: CurrencyUpdateWithoutPriceHistoryInput;
};

export type CurrencyUpsertWithoutPricesInput = {
  create: CurrencyCreateWithoutPricesInput;
  update: CurrencyUpdateWithoutPricesInput;
};

export type CurrencyUpsertWithoutProductOrdersInput = {
  create: CurrencyCreateWithoutProductOrdersInput;
  update: CurrencyUpdateWithoutProductOrdersInput;
};

export type CurrencyWhereInput = {
  AND?: InputMaybe<Array<CurrencyWhereInput>>;
  NOT?: InputMaybe<Array<CurrencyWhereInput>>;
  OR?: InputMaybe<Array<CurrencyWhereInput>>;
  autoUpdate?: InputMaybe<BoolFilter>;
  buy?: InputMaybe<FloatFilter>;
  code?: InputMaybe<StringFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  order?: InputMaybe<IntFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  prefix?: InputMaybe<StringNullableFilter>;
  priceHistory?: InputMaybe<PriceHistoryListRelationFilter>;
  prices?: InputMaybe<PriceListRelationFilter>;
  productOrders?: InputMaybe<ProductOrderListRelationFilter>;
  sell?: InputMaybe<FloatFilter>;
  status?: InputMaybe<BoolFilter>;
  suffix?: InputMaybe<StringNullableFilter>;
};

export type CurrencyWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export enum CustomProductsOrderByFilter {
  AZ_ASC = 'AZ_ASC',
  AZ_DESC = 'AZ_DESC',
  OR_ASC = 'OR_ASC',
  OR_DESC = 'OR_DESC',
  PR_ASC = 'PR_ASC',
  PR_DESC = 'PR_DESC'
}

export type CustomProductsPayload = {
  __typename?: 'CustomProductsPayload';
  count: Scalars['Int'];
  items: Array<ICustomProductsPayload>;
};

export type Customer = {
  __typename?: 'Customer';
  _count?: Maybe<CustomerCount>;
  addresses: Array<Address>;
  basket?: Maybe<Basket>;
  createdAt: Scalars['DateTime'];
  discountCoupons: Array<DiscountCoupon>;
  email: Scalars['String'];
  emailActivated: Scalars['Boolean'];
  id: Scalars['String'];
  identityNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  orders: Array<Order>;
  phoneActivated: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type CustomerAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type CustomerDiscountCouponsArgs = {
  cursor?: InputMaybe<DiscountCouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<DiscountCouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type CustomerOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type CustomerAuthPayload = {
  __typename?: 'CustomerAuthPayload';
  /** Basket ID */
  basketId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  surname: Scalars['String'];
  token: Scalars['String'];
};

export type CustomerCount = {
  __typename?: 'CustomerCount';
  addresses: Scalars['Int'];
  discountCoupons: Scalars['Int'];
  orders: Scalars['Int'];
};

export type CustomerCountAggregate = {
  __typename?: 'CustomerCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  emailActivated: Scalars['Int'];
  id: Scalars['Int'];
  identityNumber: Scalars['Int'];
  name: Scalars['Int'];
  password: Scalars['Int'];
  phoneActivated: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  surname: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type CustomerCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailActivated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneActivated?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerCreateInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketCreateNestedOneWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCoupons?: InputMaybe<DiscountCouponCreateNestedManyWithoutCustomerInput>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerCreateNestedOneWithoutAddressesInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
};

export type CustomerCreateNestedOneWithoutBasketInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutBasketInput>;
  create?: InputMaybe<CustomerCreateWithoutBasketInput>;
};

export type CustomerCreateNestedOneWithoutDiscountCouponsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutDiscountCouponsInput>;
  create?: InputMaybe<CustomerCreateWithoutDiscountCouponsInput>;
};

export type CustomerCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
};

export type CustomerCreateOrConnectWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutBasketInput = {
  create: CustomerCreateWithoutBasketInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutDiscountCouponsInput = {
  create: CustomerCreateWithoutDiscountCouponsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateWithoutAddressesInput = {
  basket?: InputMaybe<BasketCreateNestedOneWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCoupons?: InputMaybe<DiscountCouponCreateNestedManyWithoutCustomerInput>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerCreateWithoutBasketInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCoupons?: InputMaybe<DiscountCouponCreateNestedManyWithoutCustomerInput>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerCreateWithoutDiscountCouponsInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketCreateNestedOneWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutCustomerInput>;
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerCreateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressCreateNestedManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketCreateNestedOneWithoutCustomerInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCoupons?: InputMaybe<DiscountCouponCreateNestedManyWithoutCustomerInput>;
  email: Scalars['String'];
  emailActivated?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneActivated?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomerGroupBy = {
  __typename?: 'CustomerGroupBy';
  _count?: Maybe<CustomerCountAggregate>;
  _max?: Maybe<CustomerMaxAggregate>;
  _min?: Maybe<CustomerMinAggregate>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailActivated: Scalars['Boolean'];
  id: Scalars['String'];
  identityNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneActivated: Scalars['Boolean'];
  phoneNumber?: Maybe<Scalars['String']>;
  surname: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type CustomerMaxAggregate = {
  __typename?: 'CustomerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailActivated?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneActivated?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailActivated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneActivated?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerMinAggregate = {
  __typename?: 'CustomerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  emailActivated?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneActivated?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailActivated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneActivated?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerOrderByWithAggregationInput = {
  _count?: InputMaybe<CustomerCountOrderByAggregateInput>;
  _max?: InputMaybe<CustomerMaxOrderByAggregateInput>;
  _min?: InputMaybe<CustomerMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailActivated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneActivated?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerOrderByWithRelationInput = {
  addresses?: InputMaybe<AddressOrderByRelationAggregateInput>;
  basket?: InputMaybe<BasketOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  discountCoupons?: InputMaybe<DiscountCouponOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrder>;
  emailActivated?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  password?: InputMaybe<SortOrder>;
  phoneActivated?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CustomerRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export enum CustomerScalarFieldEnum {
  createdAt = 'createdAt',
  email = 'email',
  emailActivated = 'emailActivated',
  id = 'id',
  identityNumber = 'identityNumber',
  name = 'name',
  password = 'password',
  phoneActivated = 'phoneActivated',
  phoneNumber = 'phoneNumber',
  surname = 'surname',
  updatedAt = 'updatedAt'
}

export type CustomerScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<CustomerScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<CustomerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CustomerScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  emailActivated?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identityNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  password?: InputMaybe<StringWithAggregatesFilter>;
  phoneActivated?: InputMaybe<BoolWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  surname?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type CustomerUpdateInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketUpdateOneWithoutCustomerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountCoupons?: InputMaybe<DiscountCouponUpdateManyWithoutCustomerInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateOneRequiredWithoutAddressesInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutAddressesInput>;
  create?: InputMaybe<CustomerCreateWithoutAddressesInput>;
  update?: InputMaybe<CustomerUpdateWithoutAddressesInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutAddressesInput>;
};

export type CustomerUpdateOneRequiredWithoutBasketInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutBasketInput>;
  create?: InputMaybe<CustomerCreateWithoutBasketInput>;
  update?: InputMaybe<CustomerUpdateWithoutBasketInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutBasketInput>;
};

export type CustomerUpdateOneRequiredWithoutOrdersInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<CustomerCreateWithoutOrdersInput>;
  update?: InputMaybe<CustomerUpdateWithoutOrdersInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutOrdersInput>;
};

export type CustomerUpdateOneWithoutDiscountCouponsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutDiscountCouponsInput>;
  create?: InputMaybe<CustomerCreateWithoutDiscountCouponsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CustomerUpdateWithoutDiscountCouponsInput>;
  upsert?: InputMaybe<CustomerUpsertWithoutDiscountCouponsInput>;
};

export type CustomerUpdateWithoutAddressesInput = {
  basket?: InputMaybe<BasketUpdateOneWithoutCustomerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountCoupons?: InputMaybe<DiscountCouponUpdateManyWithoutCustomerInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutBasketInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountCoupons?: InputMaybe<DiscountCouponUpdateManyWithoutCustomerInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutDiscountCouponsInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketUpdateOneWithoutCustomerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutCustomerInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpdateWithoutOrdersInput = {
  addresses?: InputMaybe<AddressUpdateManyWithoutCustomerInput>;
  basket?: InputMaybe<BasketUpdateOneWithoutCustomerInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountCoupons?: InputMaybe<DiscountCouponUpdateManyWithoutCustomerInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneActivated?: InputMaybe<BoolFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  surname?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomerUpsertWithoutAddressesInput = {
  create: CustomerCreateWithoutAddressesInput;
  update: CustomerUpdateWithoutAddressesInput;
};

export type CustomerUpsertWithoutBasketInput = {
  create: CustomerCreateWithoutBasketInput;
  update: CustomerUpdateWithoutBasketInput;
};

export type CustomerUpsertWithoutDiscountCouponsInput = {
  create: CustomerCreateWithoutDiscountCouponsInput;
  update: CustomerUpdateWithoutDiscountCouponsInput;
};

export type CustomerUpsertWithoutOrdersInput = {
  create: CustomerCreateWithoutOrdersInput;
  update: CustomerUpdateWithoutOrdersInput;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  addresses?: InputMaybe<AddressListRelationFilter>;
  basket?: InputMaybe<BasketRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discountCoupons?: InputMaybe<DiscountCouponListRelationFilter>;
  email?: InputMaybe<StringFilter>;
  emailActivated?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  identityNumber?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  password?: InputMaybe<StringFilter>;
  phoneActivated?: InputMaybe<BoolFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  surname?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CustomerWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type CustomersPayload = {
  __typename?: 'CustomersPayload';
  count: Scalars['Int'];
  items: Array<Customer>;
};

export type DashboardStatisticsPayload = {
  __typename?: 'DashboardStatisticsPayload';
  last4Products?: Maybe<Array<Product>>;
  pendingOrders?: Maybe<Array<Order>>;
  todayEarnings?: Maybe<Scalars['Float']>;
  todayOrderCount?: Maybe<Scalars['Int']>;
  weeklyEarnings?: Maybe<Scalars['Float']>;
  weeklyOrderCount?: Maybe<Scalars['Int']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type Description = {
  __typename?: 'Description';
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  category?: Maybe<Category>;
  categoryId?: Maybe<Scalars['String']>;
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['String']>;
  color?: Maybe<Color>;
  colorId?: Maybe<Scalars['String']>;
  content?: Maybe<Content>;
  contentId?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCoupon?: Maybe<DiscountCoupon>;
  discountCouponId?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  language: LanguageOptions;
  page?: Maybe<Page>;
  pageId?: Maybe<Scalars['String']>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  size?: Maybe<Size>;
  sizeId?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCountAggregate = {
  __typename?: 'DescriptionCountAggregate';
  _all: Scalars['Int'];
  buttonText: Scalars['Int'];
  buttonUrl: Scalars['Int'];
  categoryId: Scalars['Int'];
  collectionId: Scalars['Int'];
  colorId: Scalars['Int'];
  contentId: Scalars['Int'];
  currencyId: Scalars['Int'];
  description: Scalars['Int'];
  discountCouponId: Scalars['Int'];
  headline: Scalars['Int'];
  id: Scalars['Int'];
  language: Scalars['Int'];
  pageId: Scalars['Int'];
  productId: Scalars['Int'];
  sizeId: Scalars['Int'];
  slug: Scalars['Int'];
  title: Scalars['Int'];
};

export type DescriptionCountOrderByAggregateInput = {
  buttonText?: InputMaybe<SortOrder>;
  buttonUrl?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  colorId?: InputMaybe<SortOrder>;
  contentId?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type DescriptionCreateInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyCategoryInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyCategoryInputEnvelope = {
  data: Array<DescriptionCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyCollectionInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyCollectionInputEnvelope = {
  data: Array<DescriptionCreateManyCollectionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyColorInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyColorInputEnvelope = {
  data: Array<DescriptionCreateManyColorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyContentInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyContentInputEnvelope = {
  data: Array<DescriptionCreateManyContentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyCurrencyInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyCurrencyInputEnvelope = {
  data: Array<DescriptionCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyDiscountCouponInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyDiscountCouponInputEnvelope = {
  data: Array<DescriptionCreateManyDiscountCouponInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyPageInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  productId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyPageInputEnvelope = {
  data: Array<DescriptionCreateManyPageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManyProductInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  sizeId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManyProductInputEnvelope = {
  data: Array<DescriptionCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateManySizeInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  collectionId?: InputMaybe<Scalars['String']>;
  colorId?: InputMaybe<Scalars['String']>;
  contentId?: InputMaybe<Scalars['String']>;
  currencyId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  pageId?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateManySizeInputEnvelope = {
  data: Array<DescriptionCreateManySizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DescriptionCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCategoryInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutCollectionInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCollectionInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutColorInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutColorInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutColorInput>>;
  createMany?: InputMaybe<DescriptionCreateManyColorInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutContentInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutContentInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutContentInput>>;
  createMany?: InputMaybe<DescriptionCreateManyContentInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCurrencyInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutDiscountCouponInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutDiscountCouponInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutDiscountCouponInput>>;
  createMany?: InputMaybe<DescriptionCreateManyDiscountCouponInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutPageInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutPageInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutPageInput>>;
  createMany?: InputMaybe<DescriptionCreateManyPageInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutProductInput>>;
  createMany?: InputMaybe<DescriptionCreateManyProductInputEnvelope>;
};

export type DescriptionCreateNestedManyWithoutSizeInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutSizeInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutSizeInput>>;
  createMany?: InputMaybe<DescriptionCreateManySizeInputEnvelope>;
};

export type DescriptionCreateOrConnectWithoutCategoryInput = {
  create: DescriptionCreateWithoutCategoryInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutCollectionInput = {
  create: DescriptionCreateWithoutCollectionInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutColorInput = {
  create: DescriptionCreateWithoutColorInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutContentInput = {
  create: DescriptionCreateWithoutContentInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutCurrencyInput = {
  create: DescriptionCreateWithoutCurrencyInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutDiscountCouponInput = {
  create: DescriptionCreateWithoutDiscountCouponInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutPageInput = {
  create: DescriptionCreateWithoutPageInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutProductInput = {
  create: DescriptionCreateWithoutProductInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateOrConnectWithoutSizeInput = {
  create: DescriptionCreateWithoutSizeInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionCreateWithoutCategoryInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutCollectionInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutColorInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutContentInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutCurrencyInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutDiscountCouponInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutPageInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutProductInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionCreateWithoutSizeInput = {
  buttonText?: InputMaybe<Scalars['String']>;
  buttonUrl?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<CategoryCreateNestedOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorCreateNestedOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentCreateNestedOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyCreateNestedOneWithoutDescriptionsInput>;
  description?: InputMaybe<Scalars['String']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutDescriptionsInput>;
  headline?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<LanguageOptions>;
  page?: InputMaybe<PageCreateNestedOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductCreateNestedOneWithoutDescriptionsInput>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionGroupBy = {
  __typename?: 'DescriptionGroupBy';
  _count?: Maybe<DescriptionCountAggregate>;
  _max?: Maybe<DescriptionMaxAggregate>;
  _min?: Maybe<DescriptionMinAggregate>;
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCouponId?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  language: LanguageOptions;
  pageId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sizeId?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type DescriptionListRelationFilter = {
  every?: InputMaybe<DescriptionWhereInput>;
  none?: InputMaybe<DescriptionWhereInput>;
  some?: InputMaybe<DescriptionWhereInput>;
};

export type DescriptionMaxAggregate = {
  __typename?: 'DescriptionMaxAggregate';
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCouponId?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageOptions>;
  pageId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sizeId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DescriptionMaxOrderByAggregateInput = {
  buttonText?: InputMaybe<SortOrder>;
  buttonUrl?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  colorId?: InputMaybe<SortOrder>;
  contentId?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type DescriptionMinAggregate = {
  __typename?: 'DescriptionMinAggregate';
  buttonText?: Maybe<Scalars['String']>;
  buttonUrl?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  colorId?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCouponId?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageOptions>;
  pageId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sizeId?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type DescriptionMinOrderByAggregateInput = {
  buttonText?: InputMaybe<SortOrder>;
  buttonUrl?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  colorId?: InputMaybe<SortOrder>;
  contentId?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type DescriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DescriptionOrderByWithAggregationInput = {
  _count?: InputMaybe<DescriptionCountOrderByAggregateInput>;
  _max?: InputMaybe<DescriptionMaxOrderByAggregateInput>;
  _min?: InputMaybe<DescriptionMinOrderByAggregateInput>;
  buttonText?: InputMaybe<SortOrder>;
  buttonUrl?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  colorId?: InputMaybe<SortOrder>;
  contentId?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  pageId?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type DescriptionOrderByWithRelationInput = {
  buttonText?: InputMaybe<SortOrder>;
  buttonUrl?: InputMaybe<SortOrder>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  collection?: InputMaybe<CollectionOrderByWithRelationInput>;
  collectionId?: InputMaybe<SortOrder>;
  color?: InputMaybe<ColorOrderByWithRelationInput>;
  colorId?: InputMaybe<SortOrder>;
  content?: InputMaybe<ContentOrderByWithRelationInput>;
  contentId?: InputMaybe<SortOrder>;
  currency?: InputMaybe<CurrencyOrderByWithRelationInput>;
  currencyId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  discountCoupon?: InputMaybe<DiscountCouponOrderByWithRelationInput>;
  discountCouponId?: InputMaybe<SortOrder>;
  headline?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  page?: InputMaybe<PageOrderByWithRelationInput>;
  pageId?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  size?: InputMaybe<SizeOrderByWithRelationInput>;
  sizeId?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum DescriptionScalarFieldEnum {
  buttonText = 'buttonText',
  buttonUrl = 'buttonUrl',
  categoryId = 'categoryId',
  collectionId = 'collectionId',
  colorId = 'colorId',
  contentId = 'contentId',
  currencyId = 'currencyId',
  description = 'description',
  discountCouponId = 'discountCouponId',
  headline = 'headline',
  id = 'id',
  language = 'language',
  pageId = 'pageId',
  productId = 'productId',
  sizeId = 'sizeId',
  slug = 'slug',
  title = 'title'
}

export type DescriptionScalarWhereInput = {
  AND?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  buttonText?: InputMaybe<StringNullableFilter>;
  buttonUrl?: InputMaybe<StringNullableFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  collectionId?: InputMaybe<StringNullableFilter>;
  colorId?: InputMaybe<StringNullableFilter>;
  contentId?: InputMaybe<StringNullableFilter>;
  currencyId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountCouponId?: InputMaybe<StringNullableFilter>;
  headline?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<EnumLanguageOptionsFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  sizeId?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type DescriptionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DescriptionScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DescriptionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DescriptionScalarWhereWithAggregatesInput>>;
  buttonText?: InputMaybe<StringNullableWithAggregatesFilter>;
  buttonUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  categoryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  collectionId?: InputMaybe<StringNullableWithAggregatesFilter>;
  colorId?: InputMaybe<StringNullableWithAggregatesFilter>;
  contentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  currencyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  discountCouponId?: InputMaybe<StringNullableWithAggregatesFilter>;
  headline?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  language?: InputMaybe<EnumLanguageOptionsWithAggregatesFilter>;
  pageId?: InputMaybe<StringNullableWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  sizeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  slug?: InputMaybe<StringWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type DescriptionUpdateInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateManyMutationInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateManyWithWhereWithoutCategoryInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutCollectionInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutColorInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutContentInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutCurrencyInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutDiscountCouponInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutPageInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutProductInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithWhereWithoutSizeInput = {
  data: DescriptionUpdateManyMutationInput;
  where: DescriptionScalarWhereInput;
};

export type DescriptionUpdateManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type DescriptionUpdateManyWithoutCollectionInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCollectionInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutCollectionInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutCollectionInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutCollectionInput>>;
};

export type DescriptionUpdateManyWithoutColorInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutColorInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutColorInput>>;
  createMany?: InputMaybe<DescriptionCreateManyColorInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutColorInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutColorInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutColorInput>>;
};

export type DescriptionUpdateManyWithoutContentInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutContentInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutContentInput>>;
  createMany?: InputMaybe<DescriptionCreateManyContentInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutContentInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutContentInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutContentInput>>;
};

export type DescriptionUpdateManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<DescriptionCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type DescriptionUpdateManyWithoutDiscountCouponInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutDiscountCouponInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutDiscountCouponInput>>;
  createMany?: InputMaybe<DescriptionCreateManyDiscountCouponInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutDiscountCouponInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutDiscountCouponInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutDiscountCouponInput>>;
};

export type DescriptionUpdateManyWithoutPageInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutPageInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutPageInput>>;
  createMany?: InputMaybe<DescriptionCreateManyPageInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutPageInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutPageInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutPageInput>>;
};

export type DescriptionUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutProductInput>>;
  createMany?: InputMaybe<DescriptionCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutProductInput>>;
};

export type DescriptionUpdateManyWithoutSizeInput = {
  connect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DescriptionCreateOrConnectWithoutSizeInput>>;
  create?: InputMaybe<Array<DescriptionCreateWithoutSizeInput>>;
  createMany?: InputMaybe<DescriptionCreateManySizeInputEnvelope>;
  delete?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<DescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<DescriptionUpdateWithWhereUniqueWithoutSizeInput>>;
  updateMany?: InputMaybe<Array<DescriptionUpdateManyWithWhereWithoutSizeInput>>;
  upsert?: InputMaybe<Array<DescriptionUpsertWithWhereUniqueWithoutSizeInput>>;
};

export type DescriptionUpdateWithWhereUniqueWithoutCategoryInput = {
  data: DescriptionUpdateWithoutCategoryInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutCollectionInput = {
  data: DescriptionUpdateWithoutCollectionInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutColorInput = {
  data: DescriptionUpdateWithoutColorInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutContentInput = {
  data: DescriptionUpdateWithoutContentInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: DescriptionUpdateWithoutCurrencyInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutDiscountCouponInput = {
  data: DescriptionUpdateWithoutDiscountCouponInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutPageInput = {
  data: DescriptionUpdateWithoutPageInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutProductInput = {
  data: DescriptionUpdateWithoutProductInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithWhereUniqueWithoutSizeInput = {
  data: DescriptionUpdateWithoutSizeInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpdateWithoutCategoryInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutCollectionInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutColorInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutContentInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutCurrencyInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutDiscountCouponInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutPageInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutProductInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  size?: InputMaybe<SizeUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpdateWithoutSizeInput = {
  buttonText?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  buttonUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneWithoutDescriptionsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutDescriptionsInput>;
  color?: InputMaybe<ColorUpdateOneWithoutDescriptionsInput>;
  content?: InputMaybe<ContentUpdateOneWithoutDescriptionsInput>;
  currency?: InputMaybe<CurrencyUpdateOneWithoutDescriptionsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutDescriptionsInput>;
  headline?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<EnumLanguageOptionsFieldUpdateOperationsInput>;
  page?: InputMaybe<PageUpdateOneWithoutDescriptionsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutDescriptionsInput>;
  slug?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DescriptionUpsertWithWhereUniqueWithoutCategoryInput = {
  create: DescriptionCreateWithoutCategoryInput;
  update: DescriptionUpdateWithoutCategoryInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutCollectionInput = {
  create: DescriptionCreateWithoutCollectionInput;
  update: DescriptionUpdateWithoutCollectionInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutColorInput = {
  create: DescriptionCreateWithoutColorInput;
  update: DescriptionUpdateWithoutColorInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutContentInput = {
  create: DescriptionCreateWithoutContentInput;
  update: DescriptionUpdateWithoutContentInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: DescriptionCreateWithoutCurrencyInput;
  update: DescriptionUpdateWithoutCurrencyInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutDiscountCouponInput = {
  create: DescriptionCreateWithoutDiscountCouponInput;
  update: DescriptionUpdateWithoutDiscountCouponInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutPageInput = {
  create: DescriptionCreateWithoutPageInput;
  update: DescriptionUpdateWithoutPageInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutProductInput = {
  create: DescriptionCreateWithoutProductInput;
  update: DescriptionUpdateWithoutProductInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionUpsertWithWhereUniqueWithoutSizeInput = {
  create: DescriptionCreateWithoutSizeInput;
  update: DescriptionUpdateWithoutSizeInput;
  where: DescriptionWhereUniqueInput;
};

export type DescriptionWhereInput = {
  AND?: InputMaybe<Array<DescriptionWhereInput>>;
  NOT?: InputMaybe<Array<DescriptionWhereInput>>;
  OR?: InputMaybe<Array<DescriptionWhereInput>>;
  buttonText?: InputMaybe<StringNullableFilter>;
  buttonUrl?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  collection?: InputMaybe<CollectionRelationFilter>;
  collectionId?: InputMaybe<StringNullableFilter>;
  color?: InputMaybe<ColorRelationFilter>;
  colorId?: InputMaybe<StringNullableFilter>;
  content?: InputMaybe<ContentRelationFilter>;
  contentId?: InputMaybe<StringNullableFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  discountCoupon?: InputMaybe<DiscountCouponRelationFilter>;
  discountCouponId?: InputMaybe<StringNullableFilter>;
  headline?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<EnumLanguageOptionsFilter>;
  page?: InputMaybe<PageRelationFilter>;
  pageId?: InputMaybe<StringNullableFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  size?: InputMaybe<SizeRelationFilter>;
  sizeId?: InputMaybe<StringNullableFilter>;
  slug?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type DescriptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DiscountCoupon = {
  __typename?: 'DiscountCoupon';
  _count?: Maybe<DiscountCouponCount>;
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']>;
  descriptions: Array<Description>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  orders: Array<Order>;
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};


export type DiscountCouponDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type DiscountCouponOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};

export type DiscountCouponAvgAggregate = {
  __typename?: 'DiscountCouponAvgAggregate';
  amount?: Maybe<Scalars['Float']>;
};

export type DiscountCouponAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type DiscountCouponCount = {
  __typename?: 'DiscountCouponCount';
  descriptions: Scalars['Int'];
  orders: Scalars['Int'];
};

export type DiscountCouponCountAggregate = {
  __typename?: 'DiscountCouponCountAggregate';
  _all: Scalars['Int'];
  amount: Scalars['Int'];
  code: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  id: Scalars['Int'];
  image: Scalars['Int'];
  isPercentage: Scalars['Int'];
  status: Scalars['Int'];
  validUntil: Scalars['Int'];
};

export type DiscountCouponCountOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isPercentage?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};

export type DiscountCouponCreateInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerCreateNestedOneWithoutDiscountCouponsInput>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutDiscountCouponInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutDiscountCouponInput>;
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponCreateManyCustomerInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponCreateManyCustomerInputEnvelope = {
  data: Array<DiscountCouponCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DiscountCouponCreateManyInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<DiscountCouponWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DiscountCouponCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<DiscountCouponCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<DiscountCouponCreateManyCustomerInputEnvelope>;
};

export type DiscountCouponCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<DiscountCouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscountCouponCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<DiscountCouponCreateWithoutDescriptionsInput>;
};

export type DiscountCouponCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<DiscountCouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscountCouponCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<DiscountCouponCreateWithoutOrdersInput>;
};

export type DiscountCouponCreateOrConnectWithoutCustomerInput = {
  create: DiscountCouponCreateWithoutCustomerInput;
  where: DiscountCouponWhereUniqueInput;
};

export type DiscountCouponCreateOrConnectWithoutDescriptionsInput = {
  create: DiscountCouponCreateWithoutDescriptionsInput;
  where: DiscountCouponWhereUniqueInput;
};

export type DiscountCouponCreateOrConnectWithoutOrdersInput = {
  create: DiscountCouponCreateWithoutOrdersInput;
  where: DiscountCouponWhereUniqueInput;
};

export type DiscountCouponCreateWithoutCustomerInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutDiscountCouponInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutDiscountCouponInput>;
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponCreateWithoutDescriptionsInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerCreateNestedOneWithoutDiscountCouponsInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  orders?: InputMaybe<OrderCreateNestedManyWithoutDiscountCouponInput>;
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponCreateWithoutOrdersInput = {
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer?: InputMaybe<CustomerCreateNestedOneWithoutDiscountCouponsInput>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutDiscountCouponInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponGroupBy = {
  __typename?: 'DiscountCouponGroupBy';
  _avg?: Maybe<DiscountCouponAvgAggregate>;
  _count?: Maybe<DiscountCouponCountAggregate>;
  _max?: Maybe<DiscountCouponMaxAggregate>;
  _min?: Maybe<DiscountCouponMinAggregate>;
  _sum?: Maybe<DiscountCouponSumAggregate>;
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customerId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  isPercentage: Scalars['Boolean'];
  status: Scalars['Boolean'];
  validUntil: Scalars['DateTime'];
};

export type DiscountCouponListRelationFilter = {
  every?: InputMaybe<DiscountCouponWhereInput>;
  none?: InputMaybe<DiscountCouponWhereInput>;
  some?: InputMaybe<DiscountCouponWhereInput>;
};

export type DiscountCouponMaxAggregate = {
  __typename?: 'DiscountCouponMaxAggregate';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Boolean']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type DiscountCouponMaxOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isPercentage?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};

export type DiscountCouponMinAggregate = {
  __typename?: 'DiscountCouponMinAggregate';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  isPercentage?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Boolean']>;
  validUntil?: Maybe<Scalars['DateTime']>;
};

export type DiscountCouponMinOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isPercentage?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};

export type DiscountCouponOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DiscountCouponOrderByWithAggregationInput = {
  _avg?: InputMaybe<DiscountCouponAvgOrderByAggregateInput>;
  _count?: InputMaybe<DiscountCouponCountOrderByAggregateInput>;
  _max?: InputMaybe<DiscountCouponMaxOrderByAggregateInput>;
  _min?: InputMaybe<DiscountCouponMinOrderByAggregateInput>;
  _sum?: InputMaybe<DiscountCouponSumOrderByAggregateInput>;
  amount?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isPercentage?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};

export type DiscountCouponOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  image?: InputMaybe<SortOrder>;
  isPercentage?: InputMaybe<SortOrder>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrder>;
  validUntil?: InputMaybe<SortOrder>;
};

export type DiscountCouponRelationFilter = {
  is?: InputMaybe<DiscountCouponWhereInput>;
  isNot?: InputMaybe<DiscountCouponWhereInput>;
};

export enum DiscountCouponScalarFieldEnum {
  amount = 'amount',
  code = 'code',
  createdAt = 'createdAt',
  customerId = 'customerId',
  id = 'id',
  image = 'image',
  isPercentage = 'isPercentage',
  status = 'status',
  validUntil = 'validUntil'
}

export type DiscountCouponScalarWhereInput = {
  AND?: InputMaybe<Array<DiscountCouponScalarWhereInput>>;
  NOT?: InputMaybe<Array<DiscountCouponScalarWhereInput>>;
  OR?: InputMaybe<Array<DiscountCouponScalarWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  status?: InputMaybe<BoolFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type DiscountCouponScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<DiscountCouponScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<DiscountCouponScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<DiscountCouponScalarWhereWithAggregatesInput>>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  image?: InputMaybe<StringNullableWithAggregatesFilter>;
  isPercentage?: InputMaybe<BoolWithAggregatesFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
  validUntil?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type DiscountCouponSumAggregate = {
  __typename?: 'DiscountCouponSumAggregate';
  amount?: Maybe<Scalars['Float']>;
};

export type DiscountCouponSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type DiscountCouponUpdateInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneWithoutDiscountCouponsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutDiscountCouponInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPercentage?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutDiscountCouponInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountCouponUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPercentage?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountCouponUpdateManyWithWhereWithoutCustomerInput = {
  data: DiscountCouponUpdateManyMutationInput;
  where: DiscountCouponScalarWhereInput;
};

export type DiscountCouponUpdateManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<DiscountCouponWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DiscountCouponCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<DiscountCouponCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<DiscountCouponCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<DiscountCouponWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DiscountCouponScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DiscountCouponWhereUniqueInput>>;
  set?: InputMaybe<Array<DiscountCouponWhereUniqueInput>>;
  update?: InputMaybe<Array<DiscountCouponUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<DiscountCouponUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<DiscountCouponUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type DiscountCouponUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<DiscountCouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscountCouponCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<DiscountCouponCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DiscountCouponUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<DiscountCouponUpsertWithoutDescriptionsInput>;
};

export type DiscountCouponUpdateOneWithoutOrdersInput = {
  connect?: InputMaybe<DiscountCouponWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DiscountCouponCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<DiscountCouponCreateWithoutOrdersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<DiscountCouponUpdateWithoutOrdersInput>;
  upsert?: InputMaybe<DiscountCouponUpsertWithoutOrdersInput>;
};

export type DiscountCouponUpdateWithWhereUniqueWithoutCustomerInput = {
  data: DiscountCouponUpdateWithoutCustomerInput;
  where: DiscountCouponWhereUniqueInput;
};

export type DiscountCouponUpdateWithoutCustomerInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutDiscountCouponInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPercentage?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutDiscountCouponInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountCouponUpdateWithoutDescriptionsInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneWithoutDiscountCouponsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPercentage?: InputMaybe<BoolFieldUpdateOperationsInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutDiscountCouponInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountCouponUpdateWithoutOrdersInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneWithoutDiscountCouponsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutDiscountCouponInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isPercentage?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
  validUntil?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DiscountCouponUpsertWithWhereUniqueWithoutCustomerInput = {
  create: DiscountCouponCreateWithoutCustomerInput;
  update: DiscountCouponUpdateWithoutCustomerInput;
  where: DiscountCouponWhereUniqueInput;
};

export type DiscountCouponUpsertWithoutDescriptionsInput = {
  create: DiscountCouponCreateWithoutDescriptionsInput;
  update: DiscountCouponUpdateWithoutDescriptionsInput;
};

export type DiscountCouponUpsertWithoutOrdersInput = {
  create: DiscountCouponCreateWithoutOrdersInput;
  update: DiscountCouponUpdateWithoutOrdersInput;
};

export type DiscountCouponWhereInput = {
  AND?: InputMaybe<Array<DiscountCouponWhereInput>>;
  NOT?: InputMaybe<Array<DiscountCouponWhereInput>>;
  OR?: InputMaybe<Array<DiscountCouponWhereInput>>;
  amount?: InputMaybe<FloatFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringNullableFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  image?: InputMaybe<StringNullableFilter>;
  isPercentage?: InputMaybe<BoolFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  status?: InputMaybe<BoolFilter>;
  validUntil?: InputMaybe<DateTimeFilter>;
};

export type DiscountCouponWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export enum DiscountType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export type EnumBrandTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<BrandType>;
};

export type EnumBrandTypeFilter = {
  equals?: InputMaybe<BrandType>;
  in?: InputMaybe<Array<BrandType>>;
  not?: InputMaybe<NestedEnumBrandTypeFilter>;
  notIn?: InputMaybe<Array<BrandType>>;
};

export type EnumBrandTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBrandTypeFilter>;
  _min?: InputMaybe<NestedEnumBrandTypeFilter>;
  equals?: InputMaybe<BrandType>;
  in?: InputMaybe<Array<BrandType>>;
  not?: InputMaybe<NestedEnumBrandTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BrandType>>;
};

export type EnumContentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ContentType>;
};

export type EnumContentTypeFilter = {
  equals?: InputMaybe<ContentType>;
  in?: InputMaybe<Array<ContentType>>;
  not?: InputMaybe<NestedEnumContentTypeFilter>;
  notIn?: InputMaybe<Array<ContentType>>;
};

export type EnumContentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumContentTypeFilter>;
  _min?: InputMaybe<NestedEnumContentTypeFilter>;
  equals?: InputMaybe<ContentType>;
  in?: InputMaybe<Array<ContentType>>;
  not?: InputMaybe<NestedEnumContentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ContentType>>;
};

export type EnumDiscountTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DiscountType>;
};

export type EnumDiscountTypeFilter = {
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type EnumDiscountTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDiscountTypeFilter>;
  _min?: InputMaybe<NestedEnumDiscountTypeFilter>;
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type EnumLanguageOptionsFieldUpdateOperationsInput = {
  set?: InputMaybe<LanguageOptions>;
};

export type EnumLanguageOptionsFilter = {
  equals?: InputMaybe<LanguageOptions>;
  in?: InputMaybe<Array<LanguageOptions>>;
  not?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  notIn?: InputMaybe<Array<LanguageOptions>>;
};

export type EnumLanguageOptionsWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  _min?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  equals?: InputMaybe<LanguageOptions>;
  in?: InputMaybe<Array<LanguageOptions>>;
  not?: InputMaybe<NestedEnumLanguageOptionsWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LanguageOptions>>;
};

export type EnumMediaTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<MediaType>;
};

export type EnumMediaTypeFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type EnumMediaTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMediaTypeFilter>;
  _min?: InputMaybe<NestedEnumMediaTypeFilter>;
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type EnumOrderStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderStatus>;
};

export type EnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumOrderStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOrderStatusFilter>;
  _min?: InputMaybe<NestedEnumOrderStatusFilter>;
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type EnumPageTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PageType>;
};

export type EnumPageTypeFilter = {
  equals?: InputMaybe<PageType>;
  in?: InputMaybe<Array<PageType>>;
  not?: InputMaybe<NestedEnumPageTypeFilter>;
  notIn?: InputMaybe<Array<PageType>>;
};

export type EnumPageTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPageTypeFilter>;
  _min?: InputMaybe<NestedEnumPageTypeFilter>;
  equals?: InputMaybe<PageType>;
  in?: InputMaybe<Array<PageType>>;
  not?: InputMaybe<NestedEnumPageTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PageType>>;
};

export type EnumStaffRoleTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<StaffRoleType>;
};

export type EnumStaffRoleTypeFilter = {
  equals?: InputMaybe<StaffRoleType>;
  in?: InputMaybe<Array<StaffRoleType>>;
  not?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  notIn?: InputMaybe<Array<StaffRoleType>>;
};

export type EnumStaffRoleTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  _min?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  equals?: InputMaybe<StaffRoleType>;
  in?: InputMaybe<Array<StaffRoleType>>;
  not?: InputMaybe<NestedEnumStaffRoleTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<StaffRoleType>>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type ICustomProductsPayload = {
  __typename?: 'ICustomProductsPayload';
  brand: BrandType;
  categoryDescription?: Maybe<Scalars['String']>;
  categorySlug: Scalars['String'];
  categoryTitle: Scalars['String'];
  collectionDescription?: Maybe<Scalars['String']>;
  collectionSlug: Scalars['String'];
  collectionTitle: Scalars['String'];
  currencyCode: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  discountAmount: Scalars['Int'];
  discountType: DiscountType;
  discountedPrice: Scalars['Float'];
  id: Scalars['String'];
  order: Scalars['Float'];
  originalPrice: Scalars['Float'];
  photos: Array<Scalars['String']>;
  price: Scalars['Float'];
  slug: Scalars['String'];
  title: Scalars['String'];
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export enum LanguageOptions {
  EN = 'EN',
  TR = 'TR'
}

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export enum MediaType {
  GALLERY = 'GALLERY',
  SINGLE = 'SINGLE',
  THUMBNAIL = 'THUMBNAIL'
}

export type Mutation = {
  __typename?: 'Mutation';
  addBasket: BasketInputPayload;
  createAddress: Address;
  createBasket: Basket;
  createBasketItem: BasketItem;
  createCategory: Category;
  createCheckoutForm: Scalars['String'];
  createCollection: Collection;
  createColor: Color;
  createContent: Content;
  createCurrency: Currency;
  createCustomProductSize: ProductSize;
  createCustomer: Customer;
  createDescription: Description;
  createDiscountCoupon: DiscountCoupon;
  createManyAddress: AffectedRowsOutput;
  createManyBasket: AffectedRowsOutput;
  createManyBasketItem: AffectedRowsOutput;
  createManyCategory: AffectedRowsOutput;
  createManyCollection: AffectedRowsOutput;
  createManyColor: AffectedRowsOutput;
  createManyContent: AffectedRowsOutput;
  createManyCurrency: AffectedRowsOutput;
  createManyCustomer: AffectedRowsOutput;
  createManyDescription: AffectedRowsOutput;
  createManyDiscountCoupon: AffectedRowsOutput;
  createManyOrder: AffectedRowsOutput;
  createManyPage: AffectedRowsOutput;
  createManyPrice: AffectedRowsOutput;
  createManyPriceHistory: AffectedRowsOutput;
  createManyProduct: AffectedRowsOutput;
  createManyProductColor: AffectedRowsOutput;
  createManyProductSize: AffectedRowsOutput;
  createManySize: AffectedRowsOutput;
  createManyStaff: AffectedRowsOutput;
  createOrder: Order;
  createPage: Page;
  createPrice: Price;
  createPriceHistory: PriceHistory;
  createProduct: Product;
  createProductColor: ProductColor;
  createProductCustom: Product;
  createProductSize: ProductSize;
  createSize: Size;
  createStaff: Staff;
  customerLogin: CustomerAuthPayload;
  /** Registration */
  customerRegister: CustomerAuthPayload;
  deleteAddress?: Maybe<Address>;
  deleteBasket?: Maybe<Basket>;
  deleteBasketItem?: Maybe<BasketItem>;
  deleteCategory?: Maybe<Category>;
  deleteCollection?: Maybe<Collection>;
  deleteColor?: Maybe<Color>;
  deleteContent?: Maybe<Content>;
  deleteCurrency?: Maybe<Currency>;
  deleteCustomer?: Maybe<Customer>;
  deleteDescription?: Maybe<Description>;
  deleteDiscountCoupon?: Maybe<DiscountCoupon>;
  deleteManyAddress: AffectedRowsOutput;
  deleteManyBasket: AffectedRowsOutput;
  deleteManyBasketItem: AffectedRowsOutput;
  deleteManyCategory: AffectedRowsOutput;
  deleteManyCollection: AffectedRowsOutput;
  deleteManyColor: AffectedRowsOutput;
  deleteManyContent: AffectedRowsOutput;
  deleteManyCurrency: AffectedRowsOutput;
  deleteManyCustomer: AffectedRowsOutput;
  deleteManyDescription: AffectedRowsOutput;
  deleteManyDiscountCoupon: AffectedRowsOutput;
  deleteManyOrder: AffectedRowsOutput;
  deleteManyPage: AffectedRowsOutput;
  deleteManyPrice: AffectedRowsOutput;
  deleteManyPriceHistory: AffectedRowsOutput;
  deleteManyProduct: AffectedRowsOutput;
  deleteManyProductColor: AffectedRowsOutput;
  deleteManyProductSize: AffectedRowsOutput;
  deleteManySize: AffectedRowsOutput;
  deleteManyStaff: AffectedRowsOutput;
  deleteOrder?: Maybe<Order>;
  deletePage?: Maybe<Page>;
  deletePrice?: Maybe<Price>;
  deletePriceHistory?: Maybe<PriceHistory>;
  deleteProduct?: Maybe<Product>;
  deleteProductColor?: Maybe<ProductColor>;
  deleteProductSize?: Maybe<ProductSize>;
  deleteSize?: Maybe<Size>;
  deleteStaff?: Maybe<Staff>;
  forgotChangePassword: Scalars['Boolean'];
  makeCategoryDiscount: Scalars['Boolean'];
  removeBasket: BasketInputPayload;
  sendForgetPasswordEmail: Scalars['Boolean'];
  staffLogin: StaffLoginPayload;
  updateAddress?: Maybe<Address>;
  updateBasket: BasketInputPayload;
  updateBasketItem?: Maybe<BasketItem>;
  updateCategory?: Maybe<Category>;
  updateCollection?: Maybe<Collection>;
  updateColor?: Maybe<Color>;
  updateContent?: Maybe<Content>;
  updateCurrency?: Maybe<Currency>;
  updateCustomProductSize: ProductSize;
  updateCustomer?: Maybe<Customer>;
  updateDescription?: Maybe<Description>;
  updateDiscountCoupon?: Maybe<DiscountCoupon>;
  updateManyAddress: AffectedRowsOutput;
  updateManyBasket: AffectedRowsOutput;
  updateManyBasketItem: AffectedRowsOutput;
  updateManyCategory: AffectedRowsOutput;
  updateManyCollection: AffectedRowsOutput;
  updateManyColor: AffectedRowsOutput;
  updateManyContent: AffectedRowsOutput;
  updateManyCurrency: AffectedRowsOutput;
  updateManyCustomer: AffectedRowsOutput;
  updateManyDescription: AffectedRowsOutput;
  updateManyDiscountCoupon: AffectedRowsOutput;
  updateManyOrder: AffectedRowsOutput;
  updateManyPage: AffectedRowsOutput;
  updateManyPrice: AffectedRowsOutput;
  updateManyPriceHistory: AffectedRowsOutput;
  updateManyProduct: AffectedRowsOutput;
  updateManyProductColor: AffectedRowsOutput;
  updateManyProductSize: AffectedRowsOutput;
  updateManySize: AffectedRowsOutput;
  updateManyStaff: AffectedRowsOutput;
  updateMeCustomer: Scalars['Boolean'];
  updateOrder?: Maybe<Order>;
  updatePage?: Maybe<Page>;
  updatePrice: Scalars['Boolean'];
  updatePriceHistory?: Maybe<PriceHistory>;
  updateProduct: Product;
  updateProductColor?: Maybe<ProductColor>;
  updateProductSize?: Maybe<ProductSize>;
  updateSize?: Maybe<Size>;
  updateStaff?: Maybe<Staff>;
  uploadFile: Scalars['JSONObject'];
  upsertAddress: Address;
  upsertBasket: Basket;
  upsertBasketItem: BasketItem;
  upsertCategory: Category;
  upsertCollection: Collection;
  upsertColor: Color;
  upsertContent: Content;
  upsertCurrency: Currency;
  upsertCustomer: Customer;
  upsertDescription: Description;
  upsertDiscountCoupon: DiscountCoupon;
  upsertOrder: Order;
  upsertPage: Page;
  upsertPrice: Price;
  upsertPriceHistory: PriceHistory;
  upsertProduct: Product;
  upsertProductColor: ProductColor;
  upsertProductSize: ProductSize;
  upsertSize: Size;
  upsertStaff: Staff;
  useDiscountCoupon: DiscountCoupon;
};


export type MutationAddBasketArgs = {
  basketId: Scalars['String'];
};


export type MutationCreateAddressArgs = {
  data: AddressCreateInput;
};


export type MutationCreateBasketArgs = {
  data: BasketCreateInput;
};


export type MutationCreateBasketItemArgs = {
  data: BasketItemCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateCheckoutFormArgs = {
  data: CreateCheckoutFormInput;
};


export type MutationCreateCollectionArgs = {
  data: CollectionCreateInput;
};


export type MutationCreateColorArgs = {
  data: ColorCreateInput;
};


export type MutationCreateContentArgs = {
  data: ContentCreateInput;
};


export type MutationCreateCurrencyArgs = {
  data: CurrencyCreateInput;
};


export type MutationCreateCustomProductSizeArgs = {
  price: Scalars['Float'];
  sizeId: Scalars['String'];
};


export type MutationCreateCustomerArgs = {
  data: CustomerCreateInput;
};


export type MutationCreateDescriptionArgs = {
  data: DescriptionCreateInput;
};


export type MutationCreateDiscountCouponArgs = {
  data: DiscountCouponCreateInput;
};


export type MutationCreateManyAddressArgs = {
  data: Array<AddressCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyBasketArgs = {
  data: Array<BasketCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyBasketItemArgs = {
  data: Array<BasketItemCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCategoryArgs = {
  data: Array<CategoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCollectionArgs = {
  data: Array<CollectionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyColorArgs = {
  data: Array<ColorCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyContentArgs = {
  data: Array<ContentCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCurrencyArgs = {
  data: Array<CurrencyCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCustomerArgs = {
  data: Array<CustomerCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyDescriptionArgs = {
  data: Array<DescriptionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyDiscountCouponArgs = {
  data: Array<DiscountCouponCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyOrderArgs = {
  data: Array<OrderCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPageArgs = {
  data: Array<PageCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPriceArgs = {
  data: Array<PriceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPriceHistoryArgs = {
  data: Array<PriceHistoryCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyProductArgs = {
  data: Array<ProductCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyProductColorArgs = {
  data: Array<ProductColorCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyProductSizeArgs = {
  data: Array<ProductSizeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManySizeArgs = {
  data: Array<SizeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyStaffArgs = {
  data: Array<StaffCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateOrderArgs = {
  data: OrderCreateInput;
};


export type MutationCreatePageArgs = {
  data: PageCreateInput;
};


export type MutationCreatePriceArgs = {
  data: PriceCreateInput;
};


export type MutationCreatePriceHistoryArgs = {
  data: PriceHistoryCreateInput;
};


export type MutationCreateProductArgs = {
  data: ProductCreateInput;
};


export type MutationCreateProductColorArgs = {
  data: ProductColorCreateInput;
};


export type MutationCreateProductCustomArgs = {
  data: ProductCreateCustomInput;
};


export type MutationCreateProductSizeArgs = {
  data: ProductSizeCreateInput;
};


export type MutationCreateSizeArgs = {
  data: SizeCreateInput;
};


export type MutationCreateStaffArgs = {
  data: StaffCreateInput;
};


export type MutationCustomerLoginArgs = {
  data: LoginInput;
};


export type MutationCustomerRegisterArgs = {
  data: CustomerCreateInput;
};


export type MutationDeleteAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type MutationDeleteBasketArgs = {
  where: BasketWhereUniqueInput;
};


export type MutationDeleteBasketItemArgs = {
  where: BasketItemWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteCollectionArgs = {
  where: CollectionWhereUniqueInput;
};


export type MutationDeleteColorArgs = {
  where: ColorWhereUniqueInput;
};


export type MutationDeleteContentArgs = {
  where: ContentWhereUniqueInput;
};


export type MutationDeleteCurrencyArgs = {
  where: CurrencyWhereUniqueInput;
};


export type MutationDeleteCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type MutationDeleteDescriptionArgs = {
  where: DescriptionWhereUniqueInput;
};


export type MutationDeleteDiscountCouponArgs = {
  where: DiscountCouponWhereUniqueInput;
};


export type MutationDeleteManyAddressArgs = {
  where?: InputMaybe<AddressWhereInput>;
};


export type MutationDeleteManyBasketArgs = {
  where?: InputMaybe<BasketWhereInput>;
};


export type MutationDeleteManyBasketItemArgs = {
  where?: InputMaybe<BasketItemWhereInput>;
};


export type MutationDeleteManyCategoryArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type MutationDeleteManyCollectionArgs = {
  where?: InputMaybe<CollectionWhereInput>;
};


export type MutationDeleteManyColorArgs = {
  where?: InputMaybe<ColorWhereInput>;
};


export type MutationDeleteManyContentArgs = {
  where?: InputMaybe<ContentWhereInput>;
};


export type MutationDeleteManyCurrencyArgs = {
  where?: InputMaybe<CurrencyWhereInput>;
};


export type MutationDeleteManyCustomerArgs = {
  where?: InputMaybe<CustomerWhereInput>;
};


export type MutationDeleteManyDescriptionArgs = {
  where?: InputMaybe<DescriptionWhereInput>;
};


export type MutationDeleteManyDiscountCouponArgs = {
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type MutationDeleteManyOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationDeleteManyPageArgs = {
  where?: InputMaybe<PageWhereInput>;
};


export type MutationDeleteManyPriceArgs = {
  where?: InputMaybe<PriceWhereInput>;
};


export type MutationDeleteManyPriceHistoryArgs = {
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type MutationDeleteManyProductArgs = {
  where?: InputMaybe<ProductWhereInput>;
};


export type MutationDeleteManyProductColorArgs = {
  where?: InputMaybe<ProductColorWhereInput>;
};


export type MutationDeleteManyProductSizeArgs = {
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type MutationDeleteManySizeArgs = {
  where?: InputMaybe<SizeWhereInput>;
};


export type MutationDeleteManyStaffArgs = {
  where?: InputMaybe<StaffWhereInput>;
};


export type MutationDeleteOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeletePageArgs = {
  where: PageWhereUniqueInput;
};


export type MutationDeletePriceArgs = {
  where: PriceWhereUniqueInput;
};


export type MutationDeletePriceHistoryArgs = {
  where: PriceHistoryWhereUniqueInput;
};


export type MutationDeleteProductArgs = {
  where: ProductWhereUniqueInput;
};


export type MutationDeleteProductColorArgs = {
  where: ProductColorWhereUniqueInput;
};


export type MutationDeleteProductSizeArgs = {
  where: ProductSizeWhereUniqueInput;
};


export type MutationDeleteSizeArgs = {
  where: SizeWhereUniqueInput;
};


export type MutationDeleteStaffArgs = {
  where: StaffWhereUniqueInput;
};


export type MutationForgotChangePasswordArgs = {
  code: Scalars['String'];
  newPassword: StringFieldUpdateOperationsInput;
};


export type MutationMakeCategoryDiscountArgs = {
  discountAmount: Scalars['Float'];
  where: CategoryWhereUniqueInput;
};


export type MutationRemoveBasketArgs = {
  basketId: Scalars['String'];
};


export type MutationSendForgetPasswordEmailArgs = {
  email: Scalars['String'];
};


export type MutationStaffLoginArgs = {
  data: LoginInput;
};


export type MutationUpdateAddressArgs = {
  data: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpdateBasketArgs = {
  currencyCode: Scalars['String'];
  data: AddBasketInput;
};


export type MutationUpdateBasketItemArgs = {
  data: BasketItemUpdateInput;
  where: BasketItemWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateCollectionArgs = {
  data: CollectionUpdateInput;
  where: CollectionWhereUniqueInput;
};


export type MutationUpdateColorArgs = {
  data: ColorUpdateInput;
  where: ColorWhereUniqueInput;
};


export type MutationUpdateContentArgs = {
  data: ContentUpdateInput;
  where: ContentWhereUniqueInput;
};


export type MutationUpdateCurrencyArgs = {
  data: CurrencyUpdateInput;
  where: CurrencyWhereUniqueInput;
};


export type MutationUpdateCustomProductSizeArgs = {
  price: Scalars['Float'];
  priceId: Scalars['String'];
  sizeId: Scalars['String'];
};


export type MutationUpdateCustomerArgs = {
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateDescriptionArgs = {
  data: DescriptionUpdateInput;
  where: DescriptionWhereUniqueInput;
};


export type MutationUpdateDiscountCouponArgs = {
  data: DiscountCouponUpdateInput;
  where: DiscountCouponWhereUniqueInput;
};


export type MutationUpdateManyAddressArgs = {
  data: AddressUpdateManyMutationInput;
  where?: InputMaybe<AddressWhereInput>;
};


export type MutationUpdateManyBasketArgs = {
  data: BasketUpdateManyMutationInput;
  where?: InputMaybe<BasketWhereInput>;
};


export type MutationUpdateManyBasketItemArgs = {
  data: BasketItemUpdateManyMutationInput;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type MutationUpdateManyCategoryArgs = {
  data: CategoryUpdateManyMutationInput;
  where?: InputMaybe<CategoryWhereInput>;
};


export type MutationUpdateManyCollectionArgs = {
  data: CollectionUpdateManyMutationInput;
  where?: InputMaybe<CollectionWhereInput>;
};


export type MutationUpdateManyColorArgs = {
  data: ColorUpdateManyMutationInput;
  where?: InputMaybe<ColorWhereInput>;
};


export type MutationUpdateManyContentArgs = {
  data: ContentUpdateManyMutationInput;
  where?: InputMaybe<ContentWhereInput>;
};


export type MutationUpdateManyCurrencyArgs = {
  data: CurrencyUpdateManyMutationInput;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type MutationUpdateManyCustomerArgs = {
  data: CustomerUpdateManyMutationInput;
  where?: InputMaybe<CustomerWhereInput>;
};


export type MutationUpdateManyDescriptionArgs = {
  data: DescriptionUpdateManyMutationInput;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type MutationUpdateManyDiscountCouponArgs = {
  data: DiscountCouponUpdateManyMutationInput;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateManyPageArgs = {
  data: PageUpdateManyMutationInput;
  where?: InputMaybe<PageWhereInput>;
};


export type MutationUpdateManyPriceArgs = {
  data: PriceUpdateManyMutationInput;
  where?: InputMaybe<PriceWhereInput>;
};


export type MutationUpdateManyPriceHistoryArgs = {
  data: PriceHistoryUpdateManyMutationInput;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type MutationUpdateManyProductArgs = {
  data: ProductUpdateManyMutationInput;
  where?: InputMaybe<ProductWhereInput>;
};


export type MutationUpdateManyProductColorArgs = {
  data: ProductColorUpdateManyMutationInput;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type MutationUpdateManyProductSizeArgs = {
  data: ProductSizeUpdateManyMutationInput;
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type MutationUpdateManySizeArgs = {
  data: SizeUpdateManyMutationInput;
  where?: InputMaybe<SizeWhereInput>;
};


export type MutationUpdateManyStaffArgs = {
  data: StaffUpdateManyMutationInput;
  where?: InputMaybe<StaffWhereInput>;
};


export type MutationUpdateMeCustomerArgs = {
  data: UpdateMeInput;
};


export type MutationUpdateOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdatePageArgs = {
  data: PageUpdateInput;
  where: PageWhereUniqueInput;
};


export type MutationUpdatePriceArgs = {
  price: Scalars['Float'];
  productId: Scalars['String'];
};


export type MutationUpdatePriceHistoryArgs = {
  data: PriceHistoryUpdateInput;
  where: PriceHistoryWhereUniqueInput;
};


export type MutationUpdateProductArgs = {
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpdateProductColorArgs = {
  data: ProductColorUpdateInput;
  where: ProductColorWhereUniqueInput;
};


export type MutationUpdateProductSizeArgs = {
  data: ProductSizeUpdateInput;
  where: ProductSizeWhereUniqueInput;
};


export type MutationUpdateSizeArgs = {
  data: SizeUpdateInput;
  where: SizeWhereUniqueInput;
};


export type MutationUpdateStaffArgs = {
  data: StaffUpdateInput;
  where: StaffWhereUniqueInput;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
};


export type MutationUpsertAddressArgs = {
  create: AddressCreateInput;
  update: AddressUpdateInput;
  where: AddressWhereUniqueInput;
};


export type MutationUpsertBasketArgs = {
  create: BasketCreateInput;
  update: BasketUpdateInput;
  where: BasketWhereUniqueInput;
};


export type MutationUpsertBasketItemArgs = {
  create: BasketItemCreateInput;
  update: BasketItemUpdateInput;
  where: BasketItemWhereUniqueInput;
};


export type MutationUpsertCategoryArgs = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertCollectionArgs = {
  create: CollectionCreateInput;
  update: CollectionUpdateInput;
  where: CollectionWhereUniqueInput;
};


export type MutationUpsertColorArgs = {
  create: ColorCreateInput;
  update: ColorUpdateInput;
  where: ColorWhereUniqueInput;
};


export type MutationUpsertContentArgs = {
  create: ContentCreateInput;
  update: ContentUpdateInput;
  where: ContentWhereUniqueInput;
};


export type MutationUpsertCurrencyArgs = {
  create: CurrencyCreateInput;
  update: CurrencyUpdateInput;
  where: CurrencyWhereUniqueInput;
};


export type MutationUpsertCustomerArgs = {
  create: CustomerCreateInput;
  update: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpsertDescriptionArgs = {
  create: DescriptionCreateInput;
  update: DescriptionUpdateInput;
  where: DescriptionWhereUniqueInput;
};


export type MutationUpsertDiscountCouponArgs = {
  create: DiscountCouponCreateInput;
  update: DiscountCouponUpdateInput;
  where: DiscountCouponWhereUniqueInput;
};


export type MutationUpsertOrderArgs = {
  create: OrderCreateInput;
  update: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpsertPageArgs = {
  create: PageCreateInput;
  update: PageUpdateInput;
  where: PageWhereUniqueInput;
};


export type MutationUpsertPriceArgs = {
  create: PriceCreateInput;
  update: PriceUpdateInput;
  where: PriceWhereUniqueInput;
};


export type MutationUpsertPriceHistoryArgs = {
  create: PriceHistoryCreateInput;
  update: PriceHistoryUpdateInput;
  where: PriceHistoryWhereUniqueInput;
};


export type MutationUpsertProductArgs = {
  create: ProductCreateInput;
  update: ProductUpdateInput;
  where: ProductWhereUniqueInput;
};


export type MutationUpsertProductColorArgs = {
  create: ProductColorCreateInput;
  update: ProductColorUpdateInput;
  where: ProductColorWhereUniqueInput;
};


export type MutationUpsertProductSizeArgs = {
  create: ProductSizeCreateInput;
  update: ProductSizeUpdateInput;
  where: ProductSizeWhereUniqueInput;
};


export type MutationUpsertSizeArgs = {
  create: SizeCreateInput;
  update: SizeUpdateInput;
  where: SizeWhereUniqueInput;
};


export type MutationUpsertStaffArgs = {
  create: StaffCreateInput;
  update: StaffUpdateInput;
  where: StaffWhereUniqueInput;
};


export type MutationUseDiscountCouponArgs = {
  couponCode: Scalars['String'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumBrandTypeFilter = {
  equals?: InputMaybe<BrandType>;
  in?: InputMaybe<Array<BrandType>>;
  not?: InputMaybe<NestedEnumBrandTypeFilter>;
  notIn?: InputMaybe<Array<BrandType>>;
};

export type NestedEnumBrandTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumBrandTypeFilter>;
  _min?: InputMaybe<NestedEnumBrandTypeFilter>;
  equals?: InputMaybe<BrandType>;
  in?: InputMaybe<Array<BrandType>>;
  not?: InputMaybe<NestedEnumBrandTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<BrandType>>;
};

export type NestedEnumContentTypeFilter = {
  equals?: InputMaybe<ContentType>;
  in?: InputMaybe<Array<ContentType>>;
  not?: InputMaybe<NestedEnumContentTypeFilter>;
  notIn?: InputMaybe<Array<ContentType>>;
};

export type NestedEnumContentTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumContentTypeFilter>;
  _min?: InputMaybe<NestedEnumContentTypeFilter>;
  equals?: InputMaybe<ContentType>;
  in?: InputMaybe<Array<ContentType>>;
  not?: InputMaybe<NestedEnumContentTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ContentType>>;
};

export type NestedEnumDiscountTypeFilter = {
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type NestedEnumDiscountTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumDiscountTypeFilter>;
  _min?: InputMaybe<NestedEnumDiscountTypeFilter>;
  equals?: InputMaybe<DiscountType>;
  in?: InputMaybe<Array<DiscountType>>;
  not?: InputMaybe<NestedEnumDiscountTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DiscountType>>;
};

export type NestedEnumLanguageOptionsFilter = {
  equals?: InputMaybe<LanguageOptions>;
  in?: InputMaybe<Array<LanguageOptions>>;
  not?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  notIn?: InputMaybe<Array<LanguageOptions>>;
};

export type NestedEnumLanguageOptionsWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  _min?: InputMaybe<NestedEnumLanguageOptionsFilter>;
  equals?: InputMaybe<LanguageOptions>;
  in?: InputMaybe<Array<LanguageOptions>>;
  not?: InputMaybe<NestedEnumLanguageOptionsWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LanguageOptions>>;
};

export type NestedEnumMediaTypeFilter = {
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type NestedEnumMediaTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumMediaTypeFilter>;
  _min?: InputMaybe<NestedEnumMediaTypeFilter>;
  equals?: InputMaybe<MediaType>;
  in?: InputMaybe<Array<MediaType>>;
  not?: InputMaybe<NestedEnumMediaTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<MediaType>>;
};

export type NestedEnumOrderStatusFilter = {
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumOrderStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumOrderStatusFilter>;
  _min?: InputMaybe<NestedEnumOrderStatusFilter>;
  equals?: InputMaybe<OrderStatus>;
  in?: InputMaybe<Array<OrderStatus>>;
  not?: InputMaybe<NestedEnumOrderStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<OrderStatus>>;
};

export type NestedEnumPageTypeFilter = {
  equals?: InputMaybe<PageType>;
  in?: InputMaybe<Array<PageType>>;
  not?: InputMaybe<NestedEnumPageTypeFilter>;
  notIn?: InputMaybe<Array<PageType>>;
};

export type NestedEnumPageTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPageTypeFilter>;
  _min?: InputMaybe<NestedEnumPageTypeFilter>;
  equals?: InputMaybe<PageType>;
  in?: InputMaybe<Array<PageType>>;
  not?: InputMaybe<NestedEnumPageTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PageType>>;
};

export type NestedEnumStaffRoleTypeFilter = {
  equals?: InputMaybe<StaffRoleType>;
  in?: InputMaybe<Array<StaffRoleType>>;
  not?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  notIn?: InputMaybe<Array<StaffRoleType>>;
};

export type NestedEnumStaffRoleTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  _min?: InputMaybe<NestedEnumStaffRoleTypeFilter>;
  equals?: InputMaybe<StaffRoleType>;
  in?: InputMaybe<Array<StaffRoleType>>;
  not?: InputMaybe<NestedEnumStaffRoleTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<StaffRoleType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  _count?: Maybe<OrderCount>;
  agreementSale?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customer: Customer;
  customerId: Scalars['String'];
  discountCoupon?: Maybe<DiscountCoupon>;
  discountCouponId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identityNumber?: Maybe<Scalars['String']>;
  informationSale?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCompleted: Scalars['Boolean'];
  isShipped: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  orderHistories: Array<OrderHistory>;
  orderStatus: OrderStatus;
  payment?: Maybe<Payment>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentCompany?: Maybe<Scalars['String']>;
  paymentCountry?: Maybe<Scalars['String']>;
  paymentEmail?: Maybe<Scalars['String']>;
  paymentFirstName?: Maybe<Scalars['String']>;
  paymentLastName?: Maybe<Scalars['String']>;
  paymentPhoneNumber?: Maybe<Scalars['String']>;
  paymentPostalCode?: Maybe<Scalars['String']>;
  paymentTaxNumber?: Maybe<Scalars['String']>;
  paymentTaxOffice?: Maybe<Scalars['String']>;
  products: Array<ProductOrder>;
  shippingAddress?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingCountry?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  shippingFirstName?: Maybe<Scalars['String']>;
  shippingLastName?: Maybe<Scalars['String']>;
  shippingNumber?: Maybe<Scalars['String']>;
  shippingPhoneNumber?: Maybe<Scalars['String']>;
  shippingPostalCode?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingTitle?: Maybe<Scalars['String']>;
};


export type OrderOrderHistoriesArgs = {
  cursor?: InputMaybe<OrderHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderHistoryWhereInput>;
};


export type OrderProductsArgs = {
  cursor?: InputMaybe<ProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductOrderWhereInput>;
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
};

export type OrderAvgOrderByAggregateInput = {
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  orderHistories: Scalars['Int'];
  products: Scalars['Int'];
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int'];
  agreementSale: Scalars['Int'];
  conversationId: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  discountCouponId: Scalars['Int'];
  id: Scalars['Int'];
  identityNumber: Scalars['Int'];
  informationSale: Scalars['Int'];
  invoiceNumber: Scalars['Int'];
  isCompleted: Scalars['Int'];
  isShipped: Scalars['Int'];
  language: Scalars['Int'];
  orderStatus: Scalars['Int'];
  paymentAddress: Scalars['Int'];
  paymentCity: Scalars['Int'];
  paymentCompany: Scalars['Int'];
  paymentCountry: Scalars['Int'];
  paymentEmail: Scalars['Int'];
  paymentFirstName: Scalars['Int'];
  paymentLastName: Scalars['Int'];
  paymentPhoneNumber: Scalars['Int'];
  paymentPostalCode: Scalars['Int'];
  paymentTaxNumber: Scalars['Int'];
  paymentTaxOffice: Scalars['Int'];
  shippingAddress: Scalars['Int'];
  shippingCity: Scalars['Int'];
  shippingConvertedPrice: Scalars['Int'];
  shippingCountry: Scalars['Int'];
  shippingEmail: Scalars['Int'];
  shippingFirstName: Scalars['Int'];
  shippingLastName: Scalars['Int'];
  shippingNumber: Scalars['Int'];
  shippingPhoneNumber: Scalars['Int'];
  shippingPostalCode: Scalars['Int'];
  shippingPrice: Scalars['Int'];
  shippingTitle: Scalars['Int'];
};

export type OrderCountOrderByAggregateInput = {
  agreementSale?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  informationSale?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isShipped?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  orderStatus?: InputMaybe<SortOrder>;
  paymentAddress?: InputMaybe<SortOrder>;
  paymentCity?: InputMaybe<SortOrder>;
  paymentCompany?: InputMaybe<SortOrder>;
  paymentCountry?: InputMaybe<SortOrder>;
  paymentEmail?: InputMaybe<SortOrder>;
  paymentFirstName?: InputMaybe<SortOrder>;
  paymentLastName?: InputMaybe<SortOrder>;
  paymentPhoneNumber?: InputMaybe<SortOrder>;
  paymentPostalCode?: InputMaybe<SortOrder>;
  paymentTaxNumber?: InputMaybe<SortOrder>;
  paymentTaxOffice?: InputMaybe<SortOrder>;
  shippingAddress?: InputMaybe<SortOrder>;
  shippingCity?: InputMaybe<SortOrder>;
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingCountry?: InputMaybe<SortOrder>;
  shippingEmail?: InputMaybe<SortOrder>;
  shippingFirstName?: InputMaybe<SortOrder>;
  shippingLastName?: InputMaybe<SortOrder>;
  shippingNumber?: InputMaybe<SortOrder>;
  shippingPhoneNumber?: InputMaybe<SortOrder>;
  shippingPostalCode?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  shippingTitle?: InputMaybe<SortOrder>;
};

export type OrderCreateInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutOrdersInput>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderHistories?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  orderStatus: OrderStatus;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductOrderCreateNestedManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateManyCustomerInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCouponId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderStatus: OrderStatus;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateManyCustomerInputEnvelope = {
  data: Array<OrderCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type OrderCreateManyDiscountCouponInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderStatus: OrderStatus;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateManyDiscountCouponInputEnvelope = {
  data: Array<OrderCreateManyDiscountCouponInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type OrderCreateManyInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  discountCouponId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderStatus: OrderStatus;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateNestedManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
};

export type OrderCreateNestedManyWithoutDiscountCouponInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutDiscountCouponInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutDiscountCouponInput>>;
  createMany?: InputMaybe<OrderCreateManyDiscountCouponInputEnvelope>;
};

export type OrderCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<OrderCreateWithoutPaymentInput>;
};

export type OrderCreateNestedOneWithoutProductsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<OrderCreateWithoutProductsInput>;
};

export type OrderCreateOrConnectWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDiscountCouponInput = {
  create: OrderCreateWithoutDiscountCouponInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutPaymentInput = {
  create: OrderCreateWithoutPaymentInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutProductsInput = {
  create: OrderCreateWithoutProductsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutCustomerInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutOrdersInput>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderHistories?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  orderStatus: OrderStatus;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductOrderCreateNestedManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateWithoutDiscountCouponInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderHistories?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  orderStatus: OrderStatus;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductOrderCreateNestedManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateWithoutPaymentInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutOrdersInput>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderHistories?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  orderStatus: OrderStatus;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<ProductOrderCreateNestedManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderCreateWithoutProductsInput = {
  agreementSale?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customer: CustomerCreateNestedOneWithoutOrdersInput;
  discountCoupon?: InputMaybe<DiscountCouponCreateNestedOneWithoutOrdersInput>;
  id?: InputMaybe<Scalars['String']>;
  identityNumber?: InputMaybe<Scalars['String']>;
  informationSale?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  isShipped?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  orderHistories?: InputMaybe<OrderHistoryCreateNestedManyWithoutOrderInput>;
  orderStatus: OrderStatus;
  payment?: InputMaybe<PaymentCreateNestedOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<Scalars['String']>;
  paymentCity?: InputMaybe<Scalars['String']>;
  paymentCompany?: InputMaybe<Scalars['String']>;
  paymentCountry?: InputMaybe<Scalars['String']>;
  paymentEmail?: InputMaybe<Scalars['String']>;
  paymentFirstName?: InputMaybe<Scalars['String']>;
  paymentLastName?: InputMaybe<Scalars['String']>;
  paymentPhoneNumber?: InputMaybe<Scalars['String']>;
  paymentPostalCode?: InputMaybe<Scalars['String']>;
  paymentTaxNumber?: InputMaybe<Scalars['String']>;
  paymentTaxOffice?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<Scalars['String']>;
  shippingCity?: InputMaybe<Scalars['String']>;
  shippingConvertedPrice?: InputMaybe<Scalars['Float']>;
  shippingCountry?: InputMaybe<Scalars['String']>;
  shippingEmail?: InputMaybe<Scalars['String']>;
  shippingFirstName?: InputMaybe<Scalars['String']>;
  shippingLastName?: InputMaybe<Scalars['String']>;
  shippingNumber?: InputMaybe<Scalars['String']>;
  shippingPhoneNumber?: InputMaybe<Scalars['String']>;
  shippingPostalCode?: InputMaybe<Scalars['String']>;
  shippingPrice?: InputMaybe<Scalars['Float']>;
  shippingTitle?: InputMaybe<Scalars['String']>;
};

export type OrderGroupBy = {
  __typename?: 'OrderGroupBy';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
  agreementSale?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  customerId: Scalars['String'];
  discountCouponId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  identityNumber?: Maybe<Scalars['String']>;
  informationSale?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCompleted: Scalars['Boolean'];
  isShipped: Scalars['Boolean'];
  language?: Maybe<Scalars['String']>;
  orderStatus: OrderStatus;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentCompany?: Maybe<Scalars['String']>;
  paymentCountry?: Maybe<Scalars['String']>;
  paymentEmail?: Maybe<Scalars['String']>;
  paymentFirstName?: Maybe<Scalars['String']>;
  paymentLastName?: Maybe<Scalars['String']>;
  paymentPhoneNumber?: Maybe<Scalars['String']>;
  paymentPostalCode?: Maybe<Scalars['String']>;
  paymentTaxNumber?: Maybe<Scalars['String']>;
  paymentTaxOffice?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingCountry?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  shippingFirstName?: Maybe<Scalars['String']>;
  shippingLastName?: Maybe<Scalars['String']>;
  shippingNumber?: Maybe<Scalars['String']>;
  shippingPhoneNumber?: Maybe<Scalars['String']>;
  shippingPostalCode?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingTitle?: Maybe<Scalars['String']>;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  emailSent: Scalars['Boolean'];
  id: Scalars['String'];
  order: Order;
  orderId: Scalars['String'];
  title: Scalars['String'];
};

export type OrderHistoryCreateManyOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  emailSent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type OrderHistoryCreateManyOrderInputEnvelope = {
  data: Array<OrderHistoryCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type OrderHistoryCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyOrderInputEnvelope>;
};

export type OrderHistoryCreateOrConnectWithoutOrderInput = {
  create: OrderHistoryCreateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryCreateWithoutOrderInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  emailSent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type OrderHistoryListRelationFilter = {
  every?: InputMaybe<OrderHistoryWhereInput>;
  none?: InputMaybe<OrderHistoryWhereInput>;
  some?: InputMaybe<OrderHistoryWhereInput>;
};

export type OrderHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderHistoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  emailSent?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum OrderHistoryScalarFieldEnum {
  createdAt = 'createdAt',
  description = 'description',
  emailSent = 'emailSent',
  id = 'id',
  orderId = 'orderId',
  title = 'title'
}

export type OrderHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  emailSent?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type OrderHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderHistoryUpdateManyWithWhereWithoutOrderInput = {
  data: OrderHistoryUpdateManyMutationInput;
  where: OrderHistoryScalarWhereInput;
};

export type OrderHistoryUpdateManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderHistoryCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderHistoryCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderHistoryCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderHistoryUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderHistoryUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderHistoryUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderHistoryUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderHistoryUpdateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryUpdateWithoutOrderInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailSent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type OrderHistoryUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderHistoryCreateWithoutOrderInput;
  update: OrderHistoryUpdateWithoutOrderInput;
  where: OrderHistoryWhereUniqueInput;
};

export type OrderHistoryWhereInput = {
  AND?: InputMaybe<Array<OrderHistoryWhereInput>>;
  NOT?: InputMaybe<Array<OrderHistoryWhereInput>>;
  OR?: InputMaybe<Array<OrderHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  emailSent?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  title?: InputMaybe<StringFilter>;
};

export type OrderHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  agreementSale?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  discountCouponId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  informationSale?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<OrderStatus>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentCompany?: Maybe<Scalars['String']>;
  paymentCountry?: Maybe<Scalars['String']>;
  paymentEmail?: Maybe<Scalars['String']>;
  paymentFirstName?: Maybe<Scalars['String']>;
  paymentLastName?: Maybe<Scalars['String']>;
  paymentPhoneNumber?: Maybe<Scalars['String']>;
  paymentPostalCode?: Maybe<Scalars['String']>;
  paymentTaxNumber?: Maybe<Scalars['String']>;
  paymentTaxOffice?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingCountry?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  shippingFirstName?: Maybe<Scalars['String']>;
  shippingLastName?: Maybe<Scalars['String']>;
  shippingNumber?: Maybe<Scalars['String']>;
  shippingPhoneNumber?: Maybe<Scalars['String']>;
  shippingPostalCode?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingTitle?: Maybe<Scalars['String']>;
};

export type OrderMaxOrderByAggregateInput = {
  agreementSale?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  informationSale?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isShipped?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  orderStatus?: InputMaybe<SortOrder>;
  paymentAddress?: InputMaybe<SortOrder>;
  paymentCity?: InputMaybe<SortOrder>;
  paymentCompany?: InputMaybe<SortOrder>;
  paymentCountry?: InputMaybe<SortOrder>;
  paymentEmail?: InputMaybe<SortOrder>;
  paymentFirstName?: InputMaybe<SortOrder>;
  paymentLastName?: InputMaybe<SortOrder>;
  paymentPhoneNumber?: InputMaybe<SortOrder>;
  paymentPostalCode?: InputMaybe<SortOrder>;
  paymentTaxNumber?: InputMaybe<SortOrder>;
  paymentTaxOffice?: InputMaybe<SortOrder>;
  shippingAddress?: InputMaybe<SortOrder>;
  shippingCity?: InputMaybe<SortOrder>;
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingCountry?: InputMaybe<SortOrder>;
  shippingEmail?: InputMaybe<SortOrder>;
  shippingFirstName?: InputMaybe<SortOrder>;
  shippingLastName?: InputMaybe<SortOrder>;
  shippingNumber?: InputMaybe<SortOrder>;
  shippingPhoneNumber?: InputMaybe<SortOrder>;
  shippingPostalCode?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  shippingTitle?: InputMaybe<SortOrder>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  agreementSale?: Maybe<Scalars['String']>;
  conversationId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  discountCouponId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  identityNumber?: Maybe<Scalars['String']>;
  informationSale?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isShipped?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<OrderStatus>;
  paymentAddress?: Maybe<Scalars['String']>;
  paymentCity?: Maybe<Scalars['String']>;
  paymentCompany?: Maybe<Scalars['String']>;
  paymentCountry?: Maybe<Scalars['String']>;
  paymentEmail?: Maybe<Scalars['String']>;
  paymentFirstName?: Maybe<Scalars['String']>;
  paymentLastName?: Maybe<Scalars['String']>;
  paymentPhoneNumber?: Maybe<Scalars['String']>;
  paymentPostalCode?: Maybe<Scalars['String']>;
  paymentTaxNumber?: Maybe<Scalars['String']>;
  paymentTaxOffice?: Maybe<Scalars['String']>;
  shippingAddress?: Maybe<Scalars['String']>;
  shippingCity?: Maybe<Scalars['String']>;
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingCountry?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  shippingFirstName?: Maybe<Scalars['String']>;
  shippingLastName?: Maybe<Scalars['String']>;
  shippingNumber?: Maybe<Scalars['String']>;
  shippingPhoneNumber?: Maybe<Scalars['String']>;
  shippingPostalCode?: Maybe<Scalars['String']>;
  shippingPrice?: Maybe<Scalars['Float']>;
  shippingTitle?: Maybe<Scalars['String']>;
};

export type OrderMinOrderByAggregateInput = {
  agreementSale?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  informationSale?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isShipped?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  orderStatus?: InputMaybe<SortOrder>;
  paymentAddress?: InputMaybe<SortOrder>;
  paymentCity?: InputMaybe<SortOrder>;
  paymentCompany?: InputMaybe<SortOrder>;
  paymentCountry?: InputMaybe<SortOrder>;
  paymentEmail?: InputMaybe<SortOrder>;
  paymentFirstName?: InputMaybe<SortOrder>;
  paymentLastName?: InputMaybe<SortOrder>;
  paymentPhoneNumber?: InputMaybe<SortOrder>;
  paymentPostalCode?: InputMaybe<SortOrder>;
  paymentTaxNumber?: InputMaybe<SortOrder>;
  paymentTaxOffice?: InputMaybe<SortOrder>;
  shippingAddress?: InputMaybe<SortOrder>;
  shippingCity?: InputMaybe<SortOrder>;
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingCountry?: InputMaybe<SortOrder>;
  shippingEmail?: InputMaybe<SortOrder>;
  shippingFirstName?: InputMaybe<SortOrder>;
  shippingLastName?: InputMaybe<SortOrder>;
  shippingNumber?: InputMaybe<SortOrder>;
  shippingPhoneNumber?: InputMaybe<SortOrder>;
  shippingPostalCode?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  shippingTitle?: InputMaybe<SortOrder>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithAggregationInput = {
  _avg?: InputMaybe<OrderAvgOrderByAggregateInput>;
  _count?: InputMaybe<OrderCountOrderByAggregateInput>;
  _max?: InputMaybe<OrderMaxOrderByAggregateInput>;
  _min?: InputMaybe<OrderMinOrderByAggregateInput>;
  _sum?: InputMaybe<OrderSumOrderByAggregateInput>;
  agreementSale?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  discountCouponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  informationSale?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isShipped?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  orderStatus?: InputMaybe<SortOrder>;
  paymentAddress?: InputMaybe<SortOrder>;
  paymentCity?: InputMaybe<SortOrder>;
  paymentCompany?: InputMaybe<SortOrder>;
  paymentCountry?: InputMaybe<SortOrder>;
  paymentEmail?: InputMaybe<SortOrder>;
  paymentFirstName?: InputMaybe<SortOrder>;
  paymentLastName?: InputMaybe<SortOrder>;
  paymentPhoneNumber?: InputMaybe<SortOrder>;
  paymentPostalCode?: InputMaybe<SortOrder>;
  paymentTaxNumber?: InputMaybe<SortOrder>;
  paymentTaxOffice?: InputMaybe<SortOrder>;
  shippingAddress?: InputMaybe<SortOrder>;
  shippingCity?: InputMaybe<SortOrder>;
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingCountry?: InputMaybe<SortOrder>;
  shippingEmail?: InputMaybe<SortOrder>;
  shippingFirstName?: InputMaybe<SortOrder>;
  shippingLastName?: InputMaybe<SortOrder>;
  shippingNumber?: InputMaybe<SortOrder>;
  shippingPhoneNumber?: InputMaybe<SortOrder>;
  shippingPostalCode?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  shippingTitle?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  agreementSale?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  discountCoupon?: InputMaybe<DiscountCouponOrderByWithRelationInput>;
  discountCouponId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  identityNumber?: InputMaybe<SortOrder>;
  informationSale?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  isCompleted?: InputMaybe<SortOrder>;
  isShipped?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  orderHistories?: InputMaybe<OrderHistoryOrderByRelationAggregateInput>;
  orderStatus?: InputMaybe<SortOrder>;
  payment?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentAddress?: InputMaybe<SortOrder>;
  paymentCity?: InputMaybe<SortOrder>;
  paymentCompany?: InputMaybe<SortOrder>;
  paymentCountry?: InputMaybe<SortOrder>;
  paymentEmail?: InputMaybe<SortOrder>;
  paymentFirstName?: InputMaybe<SortOrder>;
  paymentLastName?: InputMaybe<SortOrder>;
  paymentPhoneNumber?: InputMaybe<SortOrder>;
  paymentPostalCode?: InputMaybe<SortOrder>;
  paymentTaxNumber?: InputMaybe<SortOrder>;
  paymentTaxOffice?: InputMaybe<SortOrder>;
  products?: InputMaybe<ProductOrderOrderByRelationAggregateInput>;
  shippingAddress?: InputMaybe<SortOrder>;
  shippingCity?: InputMaybe<SortOrder>;
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingCountry?: InputMaybe<SortOrder>;
  shippingEmail?: InputMaybe<SortOrder>;
  shippingFirstName?: InputMaybe<SortOrder>;
  shippingLastName?: InputMaybe<SortOrder>;
  shippingNumber?: InputMaybe<SortOrder>;
  shippingPhoneNumber?: InputMaybe<SortOrder>;
  shippingPostalCode?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
  shippingTitle?: InputMaybe<SortOrder>;
};

export type OrderRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

export enum OrderScalarFieldEnum {
  agreementSale = 'agreementSale',
  conversationId = 'conversationId',
  createdAt = 'createdAt',
  customerId = 'customerId',
  discountCouponId = 'discountCouponId',
  id = 'id',
  identityNumber = 'identityNumber',
  informationSale = 'informationSale',
  invoiceNumber = 'invoiceNumber',
  isCompleted = 'isCompleted',
  isShipped = 'isShipped',
  language = 'language',
  orderStatus = 'orderStatus',
  paymentAddress = 'paymentAddress',
  paymentCity = 'paymentCity',
  paymentCompany = 'paymentCompany',
  paymentCountry = 'paymentCountry',
  paymentEmail = 'paymentEmail',
  paymentFirstName = 'paymentFirstName',
  paymentLastName = 'paymentLastName',
  paymentPhoneNumber = 'paymentPhoneNumber',
  paymentPostalCode = 'paymentPostalCode',
  paymentTaxNumber = 'paymentTaxNumber',
  paymentTaxOffice = 'paymentTaxOffice',
  shippingAddress = 'shippingAddress',
  shippingCity = 'shippingCity',
  shippingConvertedPrice = 'shippingConvertedPrice',
  shippingCountry = 'shippingCountry',
  shippingEmail = 'shippingEmail',
  shippingFirstName = 'shippingFirstName',
  shippingLastName = 'shippingLastName',
  shippingNumber = 'shippingNumber',
  shippingPhoneNumber = 'shippingPhoneNumber',
  shippingPostalCode = 'shippingPostalCode',
  shippingPrice = 'shippingPrice',
  shippingTitle = 'shippingTitle'
}

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  agreementSale?: InputMaybe<StringNullableFilter>;
  conversationId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  discountCouponId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identityNumber?: InputMaybe<StringNullableFilter>;
  informationSale?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  isShipped?: InputMaybe<BoolFilter>;
  language?: InputMaybe<StringNullableFilter>;
  orderStatus?: InputMaybe<EnumOrderStatusFilter>;
  paymentAddress?: InputMaybe<StringNullableFilter>;
  paymentCity?: InputMaybe<StringNullableFilter>;
  paymentCompany?: InputMaybe<StringNullableFilter>;
  paymentCountry?: InputMaybe<StringNullableFilter>;
  paymentEmail?: InputMaybe<StringNullableFilter>;
  paymentFirstName?: InputMaybe<StringNullableFilter>;
  paymentLastName?: InputMaybe<StringNullableFilter>;
  paymentPhoneNumber?: InputMaybe<StringNullableFilter>;
  paymentPostalCode?: InputMaybe<StringNullableFilter>;
  paymentTaxNumber?: InputMaybe<StringNullableFilter>;
  paymentTaxOffice?: InputMaybe<StringNullableFilter>;
  shippingAddress?: InputMaybe<StringNullableFilter>;
  shippingCity?: InputMaybe<StringNullableFilter>;
  shippingConvertedPrice?: InputMaybe<FloatNullableFilter>;
  shippingCountry?: InputMaybe<StringNullableFilter>;
  shippingEmail?: InputMaybe<StringNullableFilter>;
  shippingFirstName?: InputMaybe<StringNullableFilter>;
  shippingLastName?: InputMaybe<StringNullableFilter>;
  shippingNumber?: InputMaybe<StringNullableFilter>;
  shippingPhoneNumber?: InputMaybe<StringNullableFilter>;
  shippingPostalCode?: InputMaybe<StringNullableFilter>;
  shippingPrice?: InputMaybe<FloatNullableFilter>;
  shippingTitle?: InputMaybe<StringNullableFilter>;
};

export type OrderScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereWithAggregatesInput>>;
  agreementSale?: InputMaybe<StringNullableWithAggregatesFilter>;
  conversationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<StringWithAggregatesFilter>;
  discountCouponId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  identityNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  informationSale?: InputMaybe<StringNullableWithAggregatesFilter>;
  invoiceNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  isCompleted?: InputMaybe<BoolWithAggregatesFilter>;
  isShipped?: InputMaybe<BoolWithAggregatesFilter>;
  language?: InputMaybe<StringNullableWithAggregatesFilter>;
  orderStatus?: InputMaybe<EnumOrderStatusWithAggregatesFilter>;
  paymentAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentCity?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentCompany?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentCountry?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentPhoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentPostalCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentTaxNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  paymentTaxOffice?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingAddress?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingCity?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingConvertedPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  shippingCountry?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingEmail?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingFirstName?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingLastName?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingPhoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingPostalCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  shippingPrice?: InputMaybe<FloatNullableWithAggregatesFilter>;
  shippingTitle?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum OrderStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILURE = 'FAILURE',
  PAID = 'PAID',
  PENDING = 'PENDING',
  RETURN = 'RETURN',
  SHIPPED = 'SHIPPED',
  WAITING_FOR_CONFIRMATION = 'WAITING_FOR_CONFIRMATION'
}

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  shippingConvertedPrice?: Maybe<Scalars['Float']>;
  shippingPrice?: Maybe<Scalars['Float']>;
};

export type OrderSumOrderByAggregateInput = {
  shippingConvertedPrice?: InputMaybe<SortOrder>;
  shippingPrice?: InputMaybe<SortOrder>;
};

export type OrderUpdateInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderHistories?: InputMaybe<OrderHistoryUpdateManyWithoutOrderInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductOrderUpdateManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpdateManyMutationInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutDiscountCouponInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutCustomerInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderUpdateManyWithoutDiscountCouponInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutDiscountCouponInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutDiscountCouponInput>>;
  createMany?: InputMaybe<OrderCreateManyDiscountCouponInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutDiscountCouponInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutDiscountCouponInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutDiscountCouponInput>>;
};

export type OrderUpdateOneRequiredWithoutPaymentInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<OrderCreateWithoutPaymentInput>;
  update?: InputMaybe<OrderUpdateWithoutPaymentInput>;
  upsert?: InputMaybe<OrderUpsertWithoutPaymentInput>;
};

export type OrderUpdateOneRequiredWithoutProductsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutProductsInput>;
  create?: InputMaybe<OrderCreateWithoutProductsInput>;
  update?: InputMaybe<OrderUpdateWithoutProductsInput>;
  upsert?: InputMaybe<OrderUpsertWithoutProductsInput>;
};

export type OrderUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutDiscountCouponInput = {
  data: OrderUpdateWithoutDiscountCouponInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutCustomerInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderHistories?: InputMaybe<OrderHistoryUpdateManyWithoutOrderInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductOrderUpdateManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutDiscountCouponInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderHistories?: InputMaybe<OrderHistoryUpdateManyWithoutOrderInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductOrderUpdateManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutPaymentInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderHistories?: InputMaybe<OrderHistoryUpdateManyWithoutOrderInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  products?: InputMaybe<ProductOrderUpdateManyWithoutOrderInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutProductsInput = {
  agreementSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  conversationId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customer?: InputMaybe<CustomerUpdateOneRequiredWithoutOrdersInput>;
  discountCoupon?: InputMaybe<DiscountCouponUpdateOneWithoutOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  identityNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  informationSale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isCompleted?: InputMaybe<BoolFieldUpdateOperationsInput>;
  isShipped?: InputMaybe<BoolFieldUpdateOperationsInput>;
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderHistories?: InputMaybe<OrderHistoryUpdateManyWithoutOrderInput>;
  orderStatus?: InputMaybe<EnumOrderStatusFieldUpdateOperationsInput>;
  payment?: InputMaybe<PaymentUpdateOneWithoutOrderInput>;
  paymentAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCompany?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentTaxOffice?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingCity?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingConvertedPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingCountry?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingFirstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingLastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  shippingPrice?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  shippingTitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  update: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutDiscountCouponInput = {
  create: OrderCreateWithoutDiscountCouponInput;
  update: OrderUpdateWithoutDiscountCouponInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithoutPaymentInput = {
  create: OrderCreateWithoutPaymentInput;
  update: OrderUpdateWithoutPaymentInput;
};

export type OrderUpsertWithoutProductsInput = {
  create: OrderCreateWithoutProductsInput;
  update: OrderUpdateWithoutProductsInput;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  agreementSale?: InputMaybe<StringNullableFilter>;
  conversationId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<StringFilter>;
  discountCoupon?: InputMaybe<DiscountCouponRelationFilter>;
  discountCouponId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  identityNumber?: InputMaybe<StringNullableFilter>;
  informationSale?: InputMaybe<StringNullableFilter>;
  invoiceNumber?: InputMaybe<StringNullableFilter>;
  isCompleted?: InputMaybe<BoolFilter>;
  isShipped?: InputMaybe<BoolFilter>;
  language?: InputMaybe<StringNullableFilter>;
  orderHistories?: InputMaybe<OrderHistoryListRelationFilter>;
  orderStatus?: InputMaybe<EnumOrderStatusFilter>;
  payment?: InputMaybe<PaymentRelationFilter>;
  paymentAddress?: InputMaybe<StringNullableFilter>;
  paymentCity?: InputMaybe<StringNullableFilter>;
  paymentCompany?: InputMaybe<StringNullableFilter>;
  paymentCountry?: InputMaybe<StringNullableFilter>;
  paymentEmail?: InputMaybe<StringNullableFilter>;
  paymentFirstName?: InputMaybe<StringNullableFilter>;
  paymentLastName?: InputMaybe<StringNullableFilter>;
  paymentPhoneNumber?: InputMaybe<StringNullableFilter>;
  paymentPostalCode?: InputMaybe<StringNullableFilter>;
  paymentTaxNumber?: InputMaybe<StringNullableFilter>;
  paymentTaxOffice?: InputMaybe<StringNullableFilter>;
  products?: InputMaybe<ProductOrderListRelationFilter>;
  shippingAddress?: InputMaybe<StringNullableFilter>;
  shippingCity?: InputMaybe<StringNullableFilter>;
  shippingConvertedPrice?: InputMaybe<FloatNullableFilter>;
  shippingCountry?: InputMaybe<StringNullableFilter>;
  shippingEmail?: InputMaybe<StringNullableFilter>;
  shippingFirstName?: InputMaybe<StringNullableFilter>;
  shippingLastName?: InputMaybe<StringNullableFilter>;
  shippingNumber?: InputMaybe<StringNullableFilter>;
  shippingPhoneNumber?: InputMaybe<StringNullableFilter>;
  shippingPostalCode?: InputMaybe<StringNullableFilter>;
  shippingPrice?: InputMaybe<FloatNullableFilter>;
  shippingTitle?: InputMaybe<StringNullableFilter>;
};

export type OrderWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Page = {
  __typename?: 'Page';
  _count?: Maybe<PageCount>;
  brand: BrandType;
  content: Array<Content>;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  order: Scalars['Int'];
  pageType: PageType;
  showOnFooter: Scalars['Boolean'];
  showOnHeader: Scalars['Boolean'];
  status: Scalars['Boolean'];
};


export type PageContentArgs = {
  cursor?: InputMaybe<ContentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type PageDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};

export type PageAvgAggregate = {
  __typename?: 'PageAvgAggregate';
  order?: Maybe<Scalars['Float']>;
};

export type PageAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type PageCount = {
  __typename?: 'PageCount';
  content: Scalars['Int'];
  descriptions: Scalars['Int'];
};

export type PageCountAggregate = {
  __typename?: 'PageCountAggregate';
  _all: Scalars['Int'];
  brand: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  pageType: Scalars['Int'];
  showOnFooter: Scalars['Int'];
  showOnHeader: Scalars['Int'];
  status: Scalars['Int'];
};

export type PageCountOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
  showOnFooter?: InputMaybe<SortOrder>;
  showOnHeader?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PageCreateInput = {
  brand?: InputMaybe<BrandType>;
  content?: InputMaybe<ContentCreateNestedManyWithoutPageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutPageInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageType?: InputMaybe<PageType>;
  showOnFooter?: InputMaybe<Scalars['Boolean']>;
  showOnHeader?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PageCreateManyInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageType?: InputMaybe<PageType>;
  showOnFooter?: InputMaybe<Scalars['Boolean']>;
  showOnHeader?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PageCreateNestedOneWithoutContentInput = {
  connect?: InputMaybe<PageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PageCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<PageCreateWithoutContentInput>;
};

export type PageCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<PageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PageCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<PageCreateWithoutDescriptionsInput>;
};

export type PageCreateOrConnectWithoutContentInput = {
  create: PageCreateWithoutContentInput;
  where: PageWhereUniqueInput;
};

export type PageCreateOrConnectWithoutDescriptionsInput = {
  create: PageCreateWithoutDescriptionsInput;
  where: PageWhereUniqueInput;
};

export type PageCreateWithoutContentInput = {
  brand?: InputMaybe<BrandType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutPageInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageType?: InputMaybe<PageType>;
  showOnFooter?: InputMaybe<Scalars['Boolean']>;
  showOnHeader?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PageCreateWithoutDescriptionsInput = {
  brand?: InputMaybe<BrandType>;
  content?: InputMaybe<ContentCreateNestedManyWithoutPageInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pageType?: InputMaybe<PageType>;
  showOnFooter?: InputMaybe<Scalars['Boolean']>;
  showOnHeader?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type PageGroupBy = {
  __typename?: 'PageGroupBy';
  _avg?: Maybe<PageAvgAggregate>;
  _count?: Maybe<PageCountAggregate>;
  _max?: Maybe<PageMaxAggregate>;
  _min?: Maybe<PageMinAggregate>;
  _sum?: Maybe<PageSumAggregate>;
  brand: BrandType;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  pageType: PageType;
  showOnFooter: Scalars['Boolean'];
  showOnHeader: Scalars['Boolean'];
  status: Scalars['Boolean'];
};

export type PageMaxAggregate = {
  __typename?: 'PageMaxAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pageType?: Maybe<PageType>;
  showOnFooter?: Maybe<Scalars['Boolean']>;
  showOnHeader?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type PageMaxOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
  showOnFooter?: InputMaybe<SortOrder>;
  showOnHeader?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PageMinAggregate = {
  __typename?: 'PageMinAggregate';
  brand?: Maybe<BrandType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  pageType?: Maybe<PageType>;
  showOnFooter?: Maybe<Scalars['Boolean']>;
  showOnHeader?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type PageMinOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
  showOnFooter?: InputMaybe<SortOrder>;
  showOnHeader?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PageOrderByWithAggregationInput = {
  _avg?: InputMaybe<PageAvgOrderByAggregateInput>;
  _count?: InputMaybe<PageCountOrderByAggregateInput>;
  _max?: InputMaybe<PageMaxOrderByAggregateInput>;
  _min?: InputMaybe<PageMinOrderByAggregateInput>;
  _sum?: InputMaybe<PageSumOrderByAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
  showOnFooter?: InputMaybe<SortOrder>;
  showOnHeader?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PageOrderByWithRelationInput = {
  brand?: InputMaybe<SortOrder>;
  content?: InputMaybe<ContentOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pageType?: InputMaybe<SortOrder>;
  showOnFooter?: InputMaybe<SortOrder>;
  showOnHeader?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type PageRelationFilter = {
  is?: InputMaybe<PageWhereInput>;
  isNot?: InputMaybe<PageWhereInput>;
};

export enum PageScalarFieldEnum {
  brand = 'brand',
  createdAt = 'createdAt',
  id = 'id',
  order = 'order',
  pageType = 'pageType',
  showOnFooter = 'showOnFooter',
  showOnHeader = 'showOnHeader',
  status = 'status'
}

export type PageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PageScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PageScalarWhereWithAggregatesInput>>;
  brand?: InputMaybe<EnumBrandTypeWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  pageType?: InputMaybe<EnumPageTypeWithAggregatesFilter>;
  showOnFooter?: InputMaybe<BoolWithAggregatesFilter>;
  showOnHeader?: InputMaybe<BoolWithAggregatesFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type PageSumAggregate = {
  __typename?: 'PageSumAggregate';
  order?: Maybe<Scalars['Int']>;
};

export type PageSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export enum PageType {
  DEFAULT = 'DEFAULT',
  KVKK = 'KVKK',
  PRIVACYPOLICY = 'PRIVACYPOLICY',
  SALEAGREEMENT = 'SALEAGREEMENT',
  SALEINFO = 'SALEINFO',
  SHIPPING = 'SHIPPING',
  USERAGREEMENT = 'USERAGREEMENT'
}

export type PageUpdateInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  content?: InputMaybe<ContentUpdateManyWithoutPageInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutPageInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  pageType?: InputMaybe<EnumPageTypeFieldUpdateOperationsInput>;
  showOnFooter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showOnHeader?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PageUpdateManyMutationInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  pageType?: InputMaybe<EnumPageTypeFieldUpdateOperationsInput>;
  showOnFooter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showOnHeader?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PageUpdateOneWithoutContentInput = {
  connect?: InputMaybe<PageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PageCreateOrConnectWithoutContentInput>;
  create?: InputMaybe<PageCreateWithoutContentInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PageUpdateWithoutContentInput>;
  upsert?: InputMaybe<PageUpsertWithoutContentInput>;
};

export type PageUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<PageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PageCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<PageCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PageUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<PageUpsertWithoutDescriptionsInput>;
};

export type PageUpdateWithoutContentInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutPageInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  pageType?: InputMaybe<EnumPageTypeFieldUpdateOperationsInput>;
  showOnFooter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showOnHeader?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PageUpdateWithoutDescriptionsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  content?: InputMaybe<ContentUpdateManyWithoutPageInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  pageType?: InputMaybe<EnumPageTypeFieldUpdateOperationsInput>;
  showOnFooter?: InputMaybe<BoolFieldUpdateOperationsInput>;
  showOnHeader?: InputMaybe<BoolFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type PageUpsertWithoutContentInput = {
  create: PageCreateWithoutContentInput;
  update: PageUpdateWithoutContentInput;
};

export type PageUpsertWithoutDescriptionsInput = {
  create: PageCreateWithoutDescriptionsInput;
  update: PageUpdateWithoutDescriptionsInput;
};

export type PageWhereInput = {
  AND?: InputMaybe<Array<PageWhereInput>>;
  NOT?: InputMaybe<Array<PageWhereInput>>;
  OR?: InputMaybe<Array<PageWhereInput>>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  content?: InputMaybe<ContentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  pageType?: InputMaybe<EnumPageTypeFilter>;
  showOnFooter?: InputMaybe<BoolFilter>;
  showOnHeader?: InputMaybe<BoolFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type PageWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  __typename?: 'Payment';
  authCode?: Maybe<Scalars['String']>;
  binNumber?: Maybe<Scalars['String']>;
  cardAssociation?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  currency: Currency;
  currencyId: Scalars['String'];
  discount: Scalars['Float'];
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  installment: Scalars['Int'];
  iyziCommissionFee: Scalars['Float'];
  iyziCommissionRateAmount: Scalars['Float'];
  lastFourDigits?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
  merchantCommissionRate: Scalars['Float'];
  merchantCommissionRateAmount: Scalars['Float'];
  order: Order;
  orderId: Scalars['String'];
  paidPrice: Scalars['Float'];
  paymentId?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  status: Scalars['String'];
  systemTime?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PaymentCreateManyCurrencyInput = {
  authCode?: InputMaybe<Scalars['String']>;
  binNumber?: InputMaybe<Scalars['String']>;
  cardAssociation?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discount?: InputMaybe<Scalars['Float']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  installment?: InputMaybe<Scalars['Int']>;
  iyziCommissionFee?: InputMaybe<Scalars['Float']>;
  iyziCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  merchantCommissionRate?: InputMaybe<Scalars['Float']>;
  merchantCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['String'];
  paidPrice?: InputMaybe<Scalars['Float']>;
  paymentId?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  systemTime?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentCreateManyCurrencyInputEnvelope = {
  data: Array<PaymentCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PaymentCreateManyCurrencyInputEnvelope>;
};

export type PaymentCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<PaymentCreateWithoutOrderInput>;
};

export type PaymentCreateOrConnectWithoutCurrencyInput = {
  create: PaymentCreateWithoutCurrencyInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutOrderInput = {
  create: PaymentCreateWithoutOrderInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutCurrencyInput = {
  authCode?: InputMaybe<Scalars['String']>;
  binNumber?: InputMaybe<Scalars['String']>;
  cardAssociation?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discount?: InputMaybe<Scalars['Float']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  installment?: InputMaybe<Scalars['Int']>;
  iyziCommissionFee?: InputMaybe<Scalars['Float']>;
  iyziCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  merchantCommissionRate?: InputMaybe<Scalars['Float']>;
  merchantCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  order: OrderCreateNestedOneWithoutPaymentInput;
  paidPrice?: InputMaybe<Scalars['Float']>;
  paymentId?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  systemTime?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentCreateWithoutOrderInput = {
  authCode?: InputMaybe<Scalars['String']>;
  binNumber?: InputMaybe<Scalars['String']>;
  cardAssociation?: InputMaybe<Scalars['String']>;
  cardType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutPaymentsInput;
  discount?: InputMaybe<Scalars['Float']>;
  errorCode?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  installment?: InputMaybe<Scalars['Int']>;
  iyziCommissionFee?: InputMaybe<Scalars['Float']>;
  iyziCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  lastFourDigits?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
  merchantCommissionRate?: InputMaybe<Scalars['Float']>;
  merchantCommissionRateAmount?: InputMaybe<Scalars['Float']>;
  paidPrice?: InputMaybe<Scalars['Float']>;
  paymentId?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  systemTime?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithRelationInput = {
  authCode?: InputMaybe<SortOrder>;
  binNumber?: InputMaybe<SortOrder>;
  cardAssociation?: InputMaybe<SortOrder>;
  cardType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<CurrencyOrderByWithRelationInput>;
  currencyId?: InputMaybe<SortOrder>;
  discount?: InputMaybe<SortOrder>;
  errorCode?: InputMaybe<SortOrder>;
  errorMessage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  installment?: InputMaybe<SortOrder>;
  iyziCommissionFee?: InputMaybe<SortOrder>;
  iyziCommissionRateAmount?: InputMaybe<SortOrder>;
  lastFourDigits?: InputMaybe<SortOrder>;
  locale?: InputMaybe<SortOrder>;
  merchantCommissionRate?: InputMaybe<SortOrder>;
  merchantCommissionRateAmount?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  paidPrice?: InputMaybe<SortOrder>;
  paymentId?: InputMaybe<SortOrder>;
  phase?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  systemTime?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export enum PaymentScalarFieldEnum {
  authCode = 'authCode',
  binNumber = 'binNumber',
  cardAssociation = 'cardAssociation',
  cardType = 'cardType',
  createdAt = 'createdAt',
  currencyId = 'currencyId',
  discount = 'discount',
  errorCode = 'errorCode',
  errorMessage = 'errorMessage',
  id = 'id',
  installment = 'installment',
  iyziCommissionFee = 'iyziCommissionFee',
  iyziCommissionRateAmount = 'iyziCommissionRateAmount',
  lastFourDigits = 'lastFourDigits',
  locale = 'locale',
  merchantCommissionRate = 'merchantCommissionRate',
  merchantCommissionRateAmount = 'merchantCommissionRateAmount',
  orderId = 'orderId',
  paidPrice = 'paidPrice',
  paymentId = 'paymentId',
  phase = 'phase',
  price = 'price',
  status = 'status',
  systemTime = 'systemTime',
  updatedAt = 'updatedAt'
}

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  authCode?: InputMaybe<StringNullableFilter>;
  binNumber?: InputMaybe<StringNullableFilter>;
  cardAssociation?: InputMaybe<StringNullableFilter>;
  cardType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<StringFilter>;
  discount?: InputMaybe<FloatFilter>;
  errorCode?: InputMaybe<StringNullableFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  installment?: InputMaybe<IntFilter>;
  iyziCommissionFee?: InputMaybe<FloatFilter>;
  iyziCommissionRateAmount?: InputMaybe<FloatFilter>;
  lastFourDigits?: InputMaybe<StringNullableFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  merchantCommissionRate?: InputMaybe<FloatFilter>;
  merchantCommissionRateAmount?: InputMaybe<FloatFilter>;
  orderId?: InputMaybe<StringFilter>;
  paidPrice?: InputMaybe<FloatFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  phase?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<StringFilter>;
  systemTime?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentUpdateManyMutationInput = {
  authCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  binNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardAssociation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  errorCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  installment?: InputMaybe<IntFieldUpdateOperationsInput>;
  iyziCommissionFee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  iyziCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  lastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  merchantCommissionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  merchantCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  paidPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phase?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyWithWhereWithoutCurrencyInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PaymentCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type PaymentUpdateOneWithoutOrderInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<PaymentCreateWithoutOrderInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PaymentUpdateWithoutOrderInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutOrderInput>;
};

export type PaymentUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: PaymentUpdateWithoutCurrencyInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithoutCurrencyInput = {
  authCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  binNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardAssociation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  errorCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  installment?: InputMaybe<IntFieldUpdateOperationsInput>;
  iyziCommissionFee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  iyziCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  lastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  merchantCommissionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  merchantCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutPaymentInput>;
  paidPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phase?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutOrderInput = {
  authCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  binNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardAssociation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cardType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPaymentsInput>;
  discount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  errorCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  errorMessage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  installment?: InputMaybe<IntFieldUpdateOperationsInput>;
  iyziCommissionFee?: InputMaybe<FloatFieldUpdateOperationsInput>;
  iyziCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  lastFourDigits?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  locale?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  merchantCommissionRate?: InputMaybe<FloatFieldUpdateOperationsInput>;
  merchantCommissionRateAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  paidPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  paymentId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phase?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<StringFieldUpdateOperationsInput>;
  systemTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: PaymentCreateWithoutCurrencyInput;
  update: PaymentUpdateWithoutCurrencyInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithoutOrderInput = {
  create: PaymentCreateWithoutOrderInput;
  update: PaymentUpdateWithoutOrderInput;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  authCode?: InputMaybe<StringNullableFilter>;
  binNumber?: InputMaybe<StringNullableFilter>;
  cardAssociation?: InputMaybe<StringNullableFilter>;
  cardType?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<StringFilter>;
  discount?: InputMaybe<FloatFilter>;
  errorCode?: InputMaybe<StringNullableFilter>;
  errorMessage?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  installment?: InputMaybe<IntFilter>;
  iyziCommissionFee?: InputMaybe<FloatFilter>;
  iyziCommissionRateAmount?: InputMaybe<FloatFilter>;
  lastFourDigits?: InputMaybe<StringNullableFilter>;
  locale?: InputMaybe<StringNullableFilter>;
  merchantCommissionRate?: InputMaybe<FloatFilter>;
  merchantCommissionRateAmount?: InputMaybe<FloatFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  paidPrice?: InputMaybe<FloatFilter>;
  paymentId?: InputMaybe<StringNullableFilter>;
  phase?: InputMaybe<StringNullableFilter>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<StringFilter>;
  systemTime?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
};

export type Price = {
  __typename?: 'Price';
  _count?: Maybe<PriceCount>;
  basketItems: Array<BasketItem>;
  currency: Currency;
  currencyId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  productSize?: Maybe<ProductSize>;
  productSizeId?: Maybe<Scalars['String']>;
};


export type PriceBasketItemsArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};

export type PriceAvgAggregate = {
  __typename?: 'PriceAvgAggregate';
  price?: Maybe<Scalars['Float']>;
};

export type PriceAvgOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export type PriceCount = {
  __typename?: 'PriceCount';
  basketItems: Scalars['Int'];
};

export type PriceCountAggregate = {
  __typename?: 'PriceCountAggregate';
  _all: Scalars['Int'];
  currencyId: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['Int'];
  productId: Scalars['Int'];
  productSizeId: Scalars['Int'];
};

export type PriceCountOrderByAggregateInput = {
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productSizeId?: InputMaybe<SortOrder>;
};

export type PriceCreateInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutPriceInput>;
  currency: CurrencyCreateNestedOneWithoutPricesInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeCreateNestedOneWithoutPricesInput>;
};

export type PriceCreateManyCurrencyInput = {
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
  productSizeId?: InputMaybe<Scalars['String']>;
};

export type PriceCreateManyCurrencyInputEnvelope = {
  data: Array<PriceCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PriceCreateManyInput = {
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
  productSizeId?: InputMaybe<Scalars['String']>;
};

export type PriceCreateManyProductInput = {
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productSizeId?: InputMaybe<Scalars['String']>;
};

export type PriceCreateManyProductInputEnvelope = {
  data: Array<PriceCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PriceCreateManyProductSizeInput = {
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type PriceCreateManyProductSizeInputEnvelope = {
  data: Array<PriceCreateManyProductSizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PriceCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PriceCreateManyCurrencyInputEnvelope>;
};

export type PriceCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutProductInput>>;
  createMany?: InputMaybe<PriceCreateManyProductInputEnvelope>;
};

export type PriceCreateNestedManyWithoutProductSizeInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutProductSizeInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutProductSizeInput>>;
  createMany?: InputMaybe<PriceCreateManyProductSizeInputEnvelope>;
};

export type PriceCreateNestedOneWithoutBasketItemsInput = {
  connect?: InputMaybe<PriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceCreateOrConnectWithoutBasketItemsInput>;
  create?: InputMaybe<PriceCreateWithoutBasketItemsInput>;
};

export type PriceCreateOrConnectWithoutBasketItemsInput = {
  create: PriceCreateWithoutBasketItemsInput;
  where: PriceWhereUniqueInput;
};

export type PriceCreateOrConnectWithoutCurrencyInput = {
  create: PriceCreateWithoutCurrencyInput;
  where: PriceWhereUniqueInput;
};

export type PriceCreateOrConnectWithoutProductInput = {
  create: PriceCreateWithoutProductInput;
  where: PriceWhereUniqueInput;
};

export type PriceCreateOrConnectWithoutProductSizeInput = {
  create: PriceCreateWithoutProductSizeInput;
  where: PriceWhereUniqueInput;
};

export type PriceCreateWithoutBasketItemsInput = {
  currency: CurrencyCreateNestedOneWithoutPricesInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeCreateNestedOneWithoutPricesInput>;
};

export type PriceCreateWithoutCurrencyInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutPriceInput>;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeCreateNestedOneWithoutPricesInput>;
};

export type PriceCreateWithoutProductInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutPriceInput>;
  currency: CurrencyCreateNestedOneWithoutPricesInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productSize?: InputMaybe<ProductSizeCreateNestedOneWithoutPricesInput>;
};

export type PriceCreateWithoutProductSizeInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutPriceInput>;
  currency: CurrencyCreateNestedOneWithoutPricesInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPricesInput>;
};

export type PriceGroupBy = {
  __typename?: 'PriceGroupBy';
  _avg?: Maybe<PriceAvgAggregate>;
  _count?: Maybe<PriceCountAggregate>;
  _max?: Maybe<PriceMaxAggregate>;
  _min?: Maybe<PriceMinAggregate>;
  _sum?: Maybe<PriceSumAggregate>;
  currencyId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  productId?: Maybe<Scalars['String']>;
  productSizeId?: Maybe<Scalars['String']>;
};

export type PriceHistory = {
  __typename?: 'PriceHistory';
  createdAt: Scalars['DateTime'];
  currency: Currency;
  currencyId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PriceHistoryAvgAggregate = {
  __typename?: 'PriceHistoryAvgAggregate';
  price?: Maybe<Scalars['Float']>;
};

export type PriceHistoryAvgOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export type PriceHistoryCountAggregate = {
  __typename?: 'PriceHistoryCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  currencyId: Scalars['Int'];
  id: Scalars['Int'];
  price: Scalars['Int'];
  productId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PriceHistoryCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PriceHistoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutPriceHistoryInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPriceHistoriesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryCreateManyCurrencyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryCreateManyCurrencyInputEnvelope = {
  data: Array<PriceHistoryCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PriceHistoryCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  productId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryCreateManyProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryCreateManyProductInputEnvelope = {
  data: Array<PriceHistoryCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PriceHistoryCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceHistoryCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PriceHistoryCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PriceHistoryCreateManyCurrencyInputEnvelope>;
};

export type PriceHistoryCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceHistoryCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PriceHistoryCreateWithoutProductInput>>;
  createMany?: InputMaybe<PriceHistoryCreateManyProductInputEnvelope>;
};

export type PriceHistoryCreateOrConnectWithoutCurrencyInput = {
  create: PriceHistoryCreateWithoutCurrencyInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryCreateOrConnectWithoutProductInput = {
  create: PriceHistoryCreateWithoutProductInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryCreateWithoutCurrencyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<ProductCreateNestedOneWithoutPriceHistoriesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryCreateWithoutProductInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutPriceHistoryInput;
  id?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PriceHistoryGroupBy = {
  __typename?: 'PriceHistoryGroupBy';
  _avg?: Maybe<PriceHistoryAvgAggregate>;
  _count?: Maybe<PriceHistoryCountAggregate>;
  _max?: Maybe<PriceHistoryMaxAggregate>;
  _min?: Maybe<PriceHistoryMinAggregate>;
  _sum?: Maybe<PriceHistorySumAggregate>;
  createdAt: Scalars['DateTime'];
  currencyId: Scalars['String'];
  id: Scalars['String'];
  price: Scalars['Float'];
  productId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type PriceHistoryListRelationFilter = {
  every?: InputMaybe<PriceHistoryWhereInput>;
  none?: InputMaybe<PriceHistoryWhereInput>;
  some?: InputMaybe<PriceHistoryWhereInput>;
};

export type PriceHistoryMaxAggregate = {
  __typename?: 'PriceHistoryMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PriceHistoryMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PriceHistoryMinAggregate = {
  __typename?: 'PriceHistoryMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  currencyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PriceHistoryMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PriceHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PriceHistoryOrderByWithAggregationInput = {
  _avg?: InputMaybe<PriceHistoryAvgOrderByAggregateInput>;
  _count?: InputMaybe<PriceHistoryCountOrderByAggregateInput>;
  _max?: InputMaybe<PriceHistoryMaxOrderByAggregateInput>;
  _min?: InputMaybe<PriceHistoryMinOrderByAggregateInput>;
  _sum?: InputMaybe<PriceHistorySumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PriceHistoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<CurrencyOrderByWithRelationInput>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PriceHistoryScalarFieldEnum {
  createdAt = 'createdAt',
  currencyId = 'currencyId',
  id = 'id',
  price = 'price',
  productId = 'productId',
  updatedAt = 'updatedAt'
}

export type PriceHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<PriceHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<PriceHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<PriceHistoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PriceHistoryScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PriceHistoryScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PriceHistoryScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PriceHistoryScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  currencyId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  price?: InputMaybe<FloatWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PriceHistorySumAggregate = {
  __typename?: 'PriceHistorySumAggregate';
  price?: Maybe<Scalars['Float']>;
};

export type PriceHistorySumOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export type PriceHistoryUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPriceHistoryInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPriceHistoriesInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PriceHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PriceHistoryUpdateManyWithWhereWithoutCurrencyInput = {
  data: PriceHistoryUpdateManyMutationInput;
  where: PriceHistoryScalarWhereInput;
};

export type PriceHistoryUpdateManyWithWhereWithoutProductInput = {
  data: PriceHistoryUpdateManyMutationInput;
  where: PriceHistoryScalarWhereInput;
};

export type PriceHistoryUpdateManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceHistoryCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PriceHistoryCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PriceHistoryCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceHistoryUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<PriceHistoryUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<PriceHistoryUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type PriceHistoryUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceHistoryCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PriceHistoryCreateWithoutProductInput>>;
  createMany?: InputMaybe<PriceHistoryCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceHistoryUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<PriceHistoryUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<PriceHistoryUpsertWithWhereUniqueWithoutProductInput>>;
};

export type PriceHistoryUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: PriceHistoryUpdateWithoutCurrencyInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryUpdateWithWhereUniqueWithoutProductInput = {
  data: PriceHistoryUpdateWithoutProductInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryUpdateWithoutCurrencyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPriceHistoriesInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PriceHistoryUpdateWithoutProductInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPriceHistoryInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PriceHistoryUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: PriceHistoryCreateWithoutCurrencyInput;
  update: PriceHistoryUpdateWithoutCurrencyInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryUpsertWithWhereUniqueWithoutProductInput = {
  create: PriceHistoryCreateWithoutProductInput;
  update: PriceHistoryUpdateWithoutProductInput;
  where: PriceHistoryWhereUniqueInput;
};

export type PriceHistoryWhereInput = {
  AND?: InputMaybe<Array<PriceHistoryWhereInput>>;
  NOT?: InputMaybe<Array<PriceHistoryWhereInput>>;
  OR?: InputMaybe<Array<PriceHistoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PriceHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PriceListRelationFilter = {
  every?: InputMaybe<PriceWhereInput>;
  none?: InputMaybe<PriceWhereInput>;
  some?: InputMaybe<PriceWhereInput>;
};

export type PriceMaxAggregate = {
  __typename?: 'PriceMaxAggregate';
  currencyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  productSizeId?: Maybe<Scalars['String']>;
};

export type PriceMaxOrderByAggregateInput = {
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productSizeId?: InputMaybe<SortOrder>;
};

export type PriceMinAggregate = {
  __typename?: 'PriceMinAggregate';
  currencyId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  productSizeId?: Maybe<Scalars['String']>;
};

export type PriceMinOrderByAggregateInput = {
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productSizeId?: InputMaybe<SortOrder>;
};

export type PriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PriceOrderByWithAggregationInput = {
  _avg?: InputMaybe<PriceAvgOrderByAggregateInput>;
  _count?: InputMaybe<PriceCountOrderByAggregateInput>;
  _max?: InputMaybe<PriceMaxOrderByAggregateInput>;
  _min?: InputMaybe<PriceMinOrderByAggregateInput>;
  _sum?: InputMaybe<PriceSumOrderByAggregateInput>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  productSizeId?: InputMaybe<SortOrder>;
};

export type PriceOrderByWithRelationInput = {
  basketItems?: InputMaybe<BasketItemOrderByRelationAggregateInput>;
  currency?: InputMaybe<CurrencyOrderByWithRelationInput>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  productSize?: InputMaybe<ProductSizeOrderByWithRelationInput>;
  productSizeId?: InputMaybe<SortOrder>;
};

export type PriceRelationFilter = {
  is?: InputMaybe<PriceWhereInput>;
  isNot?: InputMaybe<PriceWhereInput>;
};

export enum PriceScalarFieldEnum {
  currencyId = 'currencyId',
  id = 'id',
  price = 'price',
  productId = 'productId',
  productSizeId = 'productSizeId'
}

export type PriceScalarWhereInput = {
  AND?: InputMaybe<Array<PriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<PriceScalarWhereInput>>;
  OR?: InputMaybe<Array<PriceScalarWhereInput>>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  productSizeId?: InputMaybe<StringNullableFilter>;
};

export type PriceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PriceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<PriceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PriceScalarWhereWithAggregatesInput>>;
  currencyId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  price?: InputMaybe<FloatWithAggregatesFilter>;
  productId?: InputMaybe<StringNullableWithAggregatesFilter>;
  productSizeId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type PriceSumAggregate = {
  __typename?: 'PriceSumAggregate';
  price?: Maybe<Scalars['Float']>;
};

export type PriceSumOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export type PriceUpdateInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutPriceInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPricesInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeUpdateOneWithoutPricesInput>;
};

export type PriceUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type PriceUpdateManyWithWhereWithoutCurrencyInput = {
  data: PriceUpdateManyMutationInput;
  where: PriceScalarWhereInput;
};

export type PriceUpdateManyWithWhereWithoutProductInput = {
  data: PriceUpdateManyMutationInput;
  where: PriceScalarWhereInput;
};

export type PriceUpdateManyWithWhereWithoutProductSizeInput = {
  data: PriceUpdateManyMutationInput;
  where: PriceScalarWhereInput;
};

export type PriceUpdateManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<PriceCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<PriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<PriceUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<PriceUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type PriceUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutProductInput>>;
  createMany?: InputMaybe<PriceCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<PriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<PriceUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<PriceUpsertWithWhereUniqueWithoutProductInput>>;
};

export type PriceUpdateManyWithoutProductSizeInput = {
  connect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PriceCreateOrConnectWithoutProductSizeInput>>;
  create?: InputMaybe<Array<PriceCreateWithoutProductSizeInput>>;
  createMany?: InputMaybe<PriceCreateManyProductSizeInputEnvelope>;
  delete?: InputMaybe<Array<PriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PriceWhereUniqueInput>>;
  set?: InputMaybe<Array<PriceWhereUniqueInput>>;
  update?: InputMaybe<Array<PriceUpdateWithWhereUniqueWithoutProductSizeInput>>;
  updateMany?: InputMaybe<Array<PriceUpdateManyWithWhereWithoutProductSizeInput>>;
  upsert?: InputMaybe<Array<PriceUpsertWithWhereUniqueWithoutProductSizeInput>>;
};

export type PriceUpdateOneRequiredWithoutBasketItemsInput = {
  connect?: InputMaybe<PriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PriceCreateOrConnectWithoutBasketItemsInput>;
  create?: InputMaybe<PriceCreateWithoutBasketItemsInput>;
  update?: InputMaybe<PriceUpdateWithoutBasketItemsInput>;
  upsert?: InputMaybe<PriceUpsertWithoutBasketItemsInput>;
};

export type PriceUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: PriceUpdateWithoutCurrencyInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpdateWithWhereUniqueWithoutProductInput = {
  data: PriceUpdateWithoutProductInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpdateWithWhereUniqueWithoutProductSizeInput = {
  data: PriceUpdateWithoutProductSizeInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpdateWithoutBasketItemsInput = {
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPricesInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeUpdateOneWithoutPricesInput>;
};

export type PriceUpdateWithoutCurrencyInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutPriceInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPricesInput>;
  productSize?: InputMaybe<ProductSizeUpdateOneWithoutPricesInput>;
};

export type PriceUpdateWithoutProductInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutPriceInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPricesInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  productSize?: InputMaybe<ProductSizeUpdateOneWithoutPricesInput>;
};

export type PriceUpdateWithoutProductSizeInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutPriceInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutPricesInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneWithoutPricesInput>;
};

export type PriceUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: PriceCreateWithoutCurrencyInput;
  update: PriceUpdateWithoutCurrencyInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpsertWithWhereUniqueWithoutProductInput = {
  create: PriceCreateWithoutProductInput;
  update: PriceUpdateWithoutProductInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpsertWithWhereUniqueWithoutProductSizeInput = {
  create: PriceCreateWithoutProductSizeInput;
  update: PriceUpdateWithoutProductSizeInput;
  where: PriceWhereUniqueInput;
};

export type PriceUpsertWithoutBasketItemsInput = {
  create: PriceCreateWithoutBasketItemsInput;
  update: PriceUpdateWithoutBasketItemsInput;
};

export type PriceWhereInput = {
  AND?: InputMaybe<Array<PriceWhereInput>>;
  NOT?: InputMaybe<Array<PriceWhereInput>>;
  OR?: InputMaybe<Array<PriceWhereInput>>;
  basketItems?: InputMaybe<BasketItemListRelationFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringNullableFilter>;
  productSize?: InputMaybe<ProductSizeRelationFilter>;
  productSizeId?: InputMaybe<StringNullableFilter>;
};

export type PriceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Product = {
  __typename?: 'Product';
  _count?: Maybe<ProductCount>;
  basketItems: Array<BasketItem>;
  brand: BrandType;
  category: Category;
  categoryId: Scalars['String'];
  collection?: Maybe<Collection>;
  collectionId?: Maybe<Scalars['String']>;
  colors: Array<ProductColor>;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  discountAmount: Scalars['Float'];
  discountType: DiscountType;
  id: Scalars['String'];
  order: Scalars['Int'];
  photos: Array<Scalars['String']>;
  priceHistories: Array<PriceHistory>;
  prices: Array<Price>;
  productOrders: Array<ProductOrder>;
  sizes: Array<ProductSize>;
  sku?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};


export type ProductBasketItemsArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type ProductColorsArgs = {
  cursor?: InputMaybe<ProductColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type ProductDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type ProductPriceHistoriesArgs = {
  cursor?: InputMaybe<PriceHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type ProductPricesArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type ProductProductOrdersArgs = {
  cursor?: InputMaybe<ProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductOrderWhereInput>;
};


export type ProductSizesArgs = {
  cursor?: InputMaybe<ProductSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};

export type ProductAvgAggregate = {
  __typename?: 'ProductAvgAggregate';
  discountAmount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Float']>;
};

export type ProductAvgOrderByAggregateInput = {
  discountAmount?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type ProductColor = {
  __typename?: 'ProductColor';
  BasketItem: Array<BasketItem>;
  _count?: Maybe<ProductColorCount>;
  color: Color;
  colorId: Scalars['String'];
  id: Scalars['String'];
  product: Product;
  productId: Scalars['String'];
};


export type ProductColorBasketItemArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};

export type ProductColorCount = {
  __typename?: 'ProductColorCount';
  BasketItem: Scalars['Int'];
};

export type ProductColorCountAggregate = {
  __typename?: 'ProductColorCountAggregate';
  _all: Scalars['Int'];
  colorId: Scalars['Int'];
  id: Scalars['Int'];
  productId: Scalars['Int'];
};

export type ProductColorCountOrderByAggregateInput = {
  colorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductColorCreateInput = {
  BasketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedColorInput>;
  color: ColorCreateNestedOneWithoutProductColorInput;
  id?: InputMaybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutColorsInput;
};

export type ProductColorCreateManyColorInput = {
  id?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type ProductColorCreateManyColorInputEnvelope = {
  data: Array<ProductColorCreateManyColorInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductColorCreateManyInput = {
  colorId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type ProductColorCreateManyProductInput = {
  colorId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type ProductColorCreateManyProductInputEnvelope = {
  data: Array<ProductColorCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductColorCreateNestedManyWithoutColorInput = {
  connect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductColorCreateOrConnectWithoutColorInput>>;
  create?: InputMaybe<Array<ProductColorCreateWithoutColorInput>>;
  createMany?: InputMaybe<ProductColorCreateManyColorInputEnvelope>;
};

export type ProductColorCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductColorCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductColorCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductColorCreateManyProductInputEnvelope>;
};

export type ProductColorCreateNestedOneWithoutBasketItemInput = {
  connect?: InputMaybe<ProductColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductColorCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<ProductColorCreateWithoutBasketItemInput>;
};

export type ProductColorCreateOrConnectWithoutBasketItemInput = {
  create: ProductColorCreateWithoutBasketItemInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorCreateOrConnectWithoutColorInput = {
  create: ProductColorCreateWithoutColorInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorCreateOrConnectWithoutProductInput = {
  create: ProductColorCreateWithoutProductInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorCreateWithoutBasketItemInput = {
  color: ColorCreateNestedOneWithoutProductColorInput;
  id?: InputMaybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutColorsInput;
};

export type ProductColorCreateWithoutColorInput = {
  BasketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedColorInput>;
  id?: InputMaybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutColorsInput;
};

export type ProductColorCreateWithoutProductInput = {
  BasketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedColorInput>;
  color: ColorCreateNestedOneWithoutProductColorInput;
  id?: InputMaybe<Scalars['String']>;
};

export type ProductColorGroupBy = {
  __typename?: 'ProductColorGroupBy';
  _count?: Maybe<ProductColorCountAggregate>;
  _max?: Maybe<ProductColorMaxAggregate>;
  _min?: Maybe<ProductColorMinAggregate>;
  colorId: Scalars['String'];
  id: Scalars['String'];
  productId: Scalars['String'];
};

export type ProductColorListRelationFilter = {
  every?: InputMaybe<ProductColorWhereInput>;
  none?: InputMaybe<ProductColorWhereInput>;
  some?: InputMaybe<ProductColorWhereInput>;
};

export type ProductColorMaxAggregate = {
  __typename?: 'ProductColorMaxAggregate';
  colorId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type ProductColorMaxOrderByAggregateInput = {
  colorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductColorMinAggregate = {
  __typename?: 'ProductColorMinAggregate';
  colorId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type ProductColorMinOrderByAggregateInput = {
  colorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductColorOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductColorOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductColorCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductColorMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductColorMinOrderByAggregateInput>;
  colorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductColorOrderByWithRelationInput = {
  BasketItem?: InputMaybe<BasketItemOrderByRelationAggregateInput>;
  color?: InputMaybe<ColorOrderByWithRelationInput>;
  colorId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
};

export type ProductColorRelationFilter = {
  is?: InputMaybe<ProductColorWhereInput>;
  isNot?: InputMaybe<ProductColorWhereInput>;
};

export enum ProductColorScalarFieldEnum {
  colorId = 'colorId',
  id = 'id',
  productId = 'productId'
}

export type ProductColorScalarWhereInput = {
  AND?: InputMaybe<Array<ProductColorScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductColorScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductColorScalarWhereInput>>;
  colorId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductColorScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductColorScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductColorScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductColorScalarWhereWithAggregatesInput>>;
  colorId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductColorUpdateInput = {
  BasketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedColorInput>;
  color?: InputMaybe<ColorUpdateOneRequiredWithoutProductColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutColorsInput>;
};

export type ProductColorUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductColorUpdateManyWithWhereWithoutColorInput = {
  data: ProductColorUpdateManyMutationInput;
  where: ProductColorScalarWhereInput;
};

export type ProductColorUpdateManyWithWhereWithoutProductInput = {
  data: ProductColorUpdateManyMutationInput;
  where: ProductColorScalarWhereInput;
};

export type ProductColorUpdateManyWithoutColorInput = {
  connect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductColorCreateOrConnectWithoutColorInput>>;
  create?: InputMaybe<Array<ProductColorCreateWithoutColorInput>>;
  createMany?: InputMaybe<ProductColorCreateManyColorInputEnvelope>;
  delete?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductColorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductColorUpdateWithWhereUniqueWithoutColorInput>>;
  updateMany?: InputMaybe<Array<ProductColorUpdateManyWithWhereWithoutColorInput>>;
  upsert?: InputMaybe<Array<ProductColorUpsertWithWhereUniqueWithoutColorInput>>;
};

export type ProductColorUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductColorCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductColorCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductColorCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductColorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductColorWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductColorUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductColorUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductColorUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductColorUpdateOneWithoutBasketItemInput = {
  connect?: InputMaybe<ProductColorWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductColorCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<ProductColorCreateWithoutBasketItemInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductColorUpdateWithoutBasketItemInput>;
  upsert?: InputMaybe<ProductColorUpsertWithoutBasketItemInput>;
};

export type ProductColorUpdateWithWhereUniqueWithoutColorInput = {
  data: ProductColorUpdateWithoutColorInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductColorUpdateWithoutProductInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorUpdateWithoutBasketItemInput = {
  color?: InputMaybe<ColorUpdateOneRequiredWithoutProductColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutColorsInput>;
};

export type ProductColorUpdateWithoutColorInput = {
  BasketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutColorsInput>;
};

export type ProductColorUpdateWithoutProductInput = {
  BasketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedColorInput>;
  color?: InputMaybe<ColorUpdateOneRequiredWithoutProductColorInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductColorUpsertWithWhereUniqueWithoutColorInput = {
  create: ProductColorCreateWithoutColorInput;
  update: ProductColorUpdateWithoutColorInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductColorCreateWithoutProductInput;
  update: ProductColorUpdateWithoutProductInput;
  where: ProductColorWhereUniqueInput;
};

export type ProductColorUpsertWithoutBasketItemInput = {
  create: ProductColorCreateWithoutBasketItemInput;
  update: ProductColorUpdateWithoutBasketItemInput;
};

export type ProductColorWhereInput = {
  AND?: InputMaybe<Array<ProductColorWhereInput>>;
  BasketItem?: InputMaybe<BasketItemListRelationFilter>;
  NOT?: InputMaybe<Array<ProductColorWhereInput>>;
  OR?: InputMaybe<Array<ProductColorWhereInput>>;
  color?: InputMaybe<ColorRelationFilter>;
  colorId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringFilter>;
};

export type ProductColorWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProductCount = {
  __typename?: 'ProductCount';
  basketItems: Scalars['Int'];
  colors: Scalars['Int'];
  descriptions: Scalars['Int'];
  priceHistories: Scalars['Int'];
  prices: Scalars['Int'];
  productOrders: Scalars['Int'];
  sizes: Scalars['Int'];
};

export type ProductCountAggregate = {
  __typename?: 'ProductCountAggregate';
  _all: Scalars['Int'];
  brand: Scalars['Int'];
  categoryId: Scalars['Int'];
  collectionId: Scalars['Int'];
  createdAt: Scalars['Int'];
  discountAmount: Scalars['Int'];
  discountType: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  photos: Scalars['Int'];
  sku: Scalars['Int'];
  status: Scalars['Int'];
};

export type ProductCountOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ProductCreateCustomInput = {
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  price: Scalars['Float'];
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateManyCategoryInput = {
  brand: BrandType;
  collectionId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateManyCategoryInputEnvelope = {
  data: Array<ProductCreateManyCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateManyCollectionInput = {
  brand: BrandType;
  categoryId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateManyCollectionInputEnvelope = {
  data: Array<ProductCreateManyCollectionInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateManyInput = {
  brand: BrandType;
  categoryId: Scalars['String'];
  collectionId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateNestedManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ProductCreateManyCategoryInputEnvelope>;
};

export type ProductCreateNestedManyWithoutCollectionInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<ProductCreateManyCollectionInputEnvelope>;
};

export type ProductCreateNestedOneWithoutBasketItemsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutBasketItemsInput>;
  create?: InputMaybe<ProductCreateWithoutBasketItemsInput>;
};

export type ProductCreateNestedOneWithoutColorsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutColorsInput>;
  create?: InputMaybe<ProductCreateWithoutColorsInput>;
};

export type ProductCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ProductCreateWithoutDescriptionsInput>;
};

export type ProductCreateNestedOneWithoutPriceHistoriesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPriceHistoriesInput>;
  create?: InputMaybe<ProductCreateWithoutPriceHistoriesInput>;
};

export type ProductCreateNestedOneWithoutPricesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<ProductCreateWithoutPricesInput>;
};

export type ProductCreateNestedOneWithoutProductOrdersInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductOrdersInput>;
  create?: InputMaybe<ProductCreateWithoutProductOrdersInput>;
};

export type ProductCreateNestedOneWithoutSizesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutSizesInput>;
  create?: InputMaybe<ProductCreateWithoutSizesInput>;
};

export type ProductCreateOrConnectWithoutBasketItemsInput = {
  create: ProductCreateWithoutBasketItemsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutCategoryInput = {
  create: ProductCreateWithoutCategoryInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutCollectionInput = {
  create: ProductCreateWithoutCollectionInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutColorsInput = {
  create: ProductCreateWithoutColorsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutDescriptionsInput = {
  create: ProductCreateWithoutDescriptionsInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPriceHistoriesInput = {
  create: ProductCreateWithoutPriceHistoriesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutPricesInput = {
  create: ProductCreateWithoutPricesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutProductOrdersInput = {
  create: ProductCreateWithoutProductOrdersInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateOrConnectWithoutSizesInput = {
  create: ProductCreateWithoutSizesInput;
  where: ProductWhereUniqueInput;
};

export type ProductCreateWithoutBasketItemsInput = {
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutCategoryInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutCollectionInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutColorsInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutDescriptionsInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutPriceHistoriesInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutPricesInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutProductOrdersInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreateWithoutSizesInput = {
  basketItems?: InputMaybe<BasketItemCreateNestedManyWithoutProductInput>;
  brand: BrandType;
  category: CategoryCreateNestedOneWithoutProductsInput;
  collection?: InputMaybe<CollectionCreateNestedOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorCreateNestedManyWithoutProductInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutProductInput>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  photos?: InputMaybe<ProductCreatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryCreateNestedManyWithoutProductInput>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderCreateNestedManyWithoutProductInput>;
  sku?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
};

export type ProductCreatephotosInput = {
  set: Array<Scalars['String']>;
};

export type ProductGroupBy = {
  __typename?: 'ProductGroupBy';
  _avg?: Maybe<ProductAvgAggregate>;
  _count?: Maybe<ProductCountAggregate>;
  _max?: Maybe<ProductMaxAggregate>;
  _min?: Maybe<ProductMinAggregate>;
  _sum?: Maybe<ProductSumAggregate>;
  brand: BrandType;
  categoryId: Scalars['String'];
  collectionId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  discountAmount: Scalars['Float'];
  discountType: DiscountType;
  id: Scalars['String'];
  order: Scalars['Int'];
  photos?: Maybe<Array<Scalars['String']>>;
  sku?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type ProductListRelationFilter = {
  every?: InputMaybe<ProductWhereInput>;
  none?: InputMaybe<ProductWhereInput>;
  some?: InputMaybe<ProductWhereInput>;
};

export type ProductMaxAggregate = {
  __typename?: 'ProductMaxAggregate';
  brand?: Maybe<BrandType>;
  categoryId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<DiscountType>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ProductMaxOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ProductMinAggregate = {
  __typename?: 'ProductMinAggregate';
  brand?: Maybe<BrandType>;
  categoryId?: Maybe<Scalars['String']>;
  collectionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  discountAmount?: Maybe<Scalars['Float']>;
  discountType?: Maybe<DiscountType>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type ProductMinOrderByAggregateInput = {
  brand?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  convertedPrice: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  currency: Currency;
  currencyId: Scalars['String'];
  id: Scalars['String'];
  order: Order;
  orderId: Scalars['String'];
  price: Scalars['Float'];
  product: Product;
  productId: Scalars['String'];
  quantity: Scalars['Int'];
  selectedProductSizeId?: Maybe<Scalars['String']>;
  selectedSize?: Maybe<ProductSize>;
  updatedAt: Scalars['DateTime'];
};

export type ProductOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProductAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProductCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProductSumOrderByAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  collectionId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ProductOrderByWithRelationInput = {
  basketItems?: InputMaybe<BasketItemOrderByRelationAggregateInput>;
  brand?: InputMaybe<SortOrder>;
  category?: InputMaybe<CategoryOrderByWithRelationInput>;
  categoryId?: InputMaybe<SortOrder>;
  collection?: InputMaybe<CollectionOrderByWithRelationInput>;
  collectionId?: InputMaybe<SortOrder>;
  colors?: InputMaybe<ProductColorOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  discountAmount?: InputMaybe<SortOrder>;
  discountType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  photos?: InputMaybe<SortOrder>;
  priceHistories?: InputMaybe<PriceHistoryOrderByRelationAggregateInput>;
  prices?: InputMaybe<PriceOrderByRelationAggregateInput>;
  productOrders?: InputMaybe<ProductOrderOrderByRelationAggregateInput>;
  sizes?: InputMaybe<ProductSizeOrderByRelationAggregateInput>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type ProductOrderCreateManyCurrencyInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateManyCurrencyInputEnvelope = {
  data: Array<ProductOrderCreateManyCurrencyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOrderCreateManyOrderInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateManyOrderInputEnvelope = {
  data: Array<ProductOrderCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOrderCreateManyProductInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedProductSizeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateManyProductInputEnvelope = {
  data: Array<ProductOrderCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOrderCreateManySelectedSizeInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currencyId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  price: Scalars['Float'];
  productId: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateManySelectedSizeInputEnvelope = {
  data: Array<ProductOrderCreateManySelectedSizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductOrderCreateNestedManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyCurrencyInputEnvelope>;
};

export type ProductOrderCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyOrderInputEnvelope>;
};

export type ProductOrderCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyProductInputEnvelope>;
};

export type ProductOrderCreateNestedManyWithoutSelectedSizeInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutSelectedSizeInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutSelectedSizeInput>>;
  createMany?: InputMaybe<ProductOrderCreateManySelectedSizeInputEnvelope>;
};

export type ProductOrderCreateOrConnectWithoutCurrencyInput = {
  create: ProductOrderCreateWithoutCurrencyInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderCreateOrConnectWithoutOrderInput = {
  create: ProductOrderCreateWithoutOrderInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderCreateOrConnectWithoutProductInput = {
  create: ProductOrderCreateWithoutProductInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderCreateOrConnectWithoutSelectedSizeInput = {
  create: ProductOrderCreateWithoutSelectedSizeInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderCreateWithoutCurrencyInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  price: Scalars['Float'];
  product: ProductCreateNestedOneWithoutProductOrdersInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateWithoutOrderInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutProductOrdersInput;
  id?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  product: ProductCreateNestedOneWithoutProductOrdersInput;
  quantity?: InputMaybe<Scalars['Int']>;
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateWithoutProductInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutProductOrdersInput;
  id?: InputMaybe<Scalars['String']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  price: Scalars['Float'];
  quantity?: InputMaybe<Scalars['Int']>;
  selectedSize?: InputMaybe<ProductSizeCreateNestedOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderCreateWithoutSelectedSizeInput = {
  convertedPrice: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  currency: CurrencyCreateNestedOneWithoutProductOrdersInput;
  id?: InputMaybe<Scalars['String']>;
  order: OrderCreateNestedOneWithoutProductsInput;
  price: Scalars['Float'];
  product: ProductCreateNestedOneWithoutProductOrdersInput;
  quantity?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ProductOrderListRelationFilter = {
  every?: InputMaybe<ProductOrderWhereInput>;
  none?: InputMaybe<ProductOrderWhereInput>;
  some?: InputMaybe<ProductOrderWhereInput>;
};

export type ProductOrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductOrderOrderByWithRelationInput = {
  convertedPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  currency?: InputMaybe<CurrencyOrderByWithRelationInput>;
  currencyId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  selectedProductSizeId?: InputMaybe<SortOrder>;
  selectedSize?: InputMaybe<ProductSizeOrderByWithRelationInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ProductOrderScalarFieldEnum {
  convertedPrice = 'convertedPrice',
  createdAt = 'createdAt',
  currencyId = 'currencyId',
  id = 'id',
  orderId = 'orderId',
  price = 'price',
  productId = 'productId',
  quantity = 'quantity',
  selectedProductSizeId = 'selectedProductSizeId',
  updatedAt = 'updatedAt'
}

export type ProductOrderScalarWhereInput = {
  AND?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  convertedPrice?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  productId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  selectedProductSizeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductOrderUpdateManyMutationInput = {
  convertedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOrderUpdateManyWithWhereWithoutCurrencyInput = {
  data: ProductOrderUpdateManyMutationInput;
  where: ProductOrderScalarWhereInput;
};

export type ProductOrderUpdateManyWithWhereWithoutOrderInput = {
  data: ProductOrderUpdateManyMutationInput;
  where: ProductOrderScalarWhereInput;
};

export type ProductOrderUpdateManyWithWhereWithoutProductInput = {
  data: ProductOrderUpdateManyMutationInput;
  where: ProductOrderScalarWhereInput;
};

export type ProductOrderUpdateManyWithWhereWithoutSelectedSizeInput = {
  data: ProductOrderUpdateManyMutationInput;
  where: ProductOrderScalarWhereInput;
};

export type ProductOrderUpdateManyWithoutCurrencyInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutCurrencyInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutCurrencyInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyCurrencyInputEnvelope>;
  delete?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductOrderUpdateWithWhereUniqueWithoutCurrencyInput>>;
  updateMany?: InputMaybe<Array<ProductOrderUpdateManyWithWhereWithoutCurrencyInput>>;
  upsert?: InputMaybe<Array<ProductOrderUpsertWithWhereUniqueWithoutCurrencyInput>>;
};

export type ProductOrderUpdateManyWithoutOrderInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutOrderInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductOrderUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<ProductOrderUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<ProductOrderUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type ProductOrderUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductOrderCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductOrderUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductOrderUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductOrderUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductOrderUpdateManyWithoutSelectedSizeInput = {
  connect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductOrderCreateOrConnectWithoutSelectedSizeInput>>;
  create?: InputMaybe<Array<ProductOrderCreateWithoutSelectedSizeInput>>;
  createMany?: InputMaybe<ProductOrderCreateManySelectedSizeInputEnvelope>;
  delete?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductOrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductOrderWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductOrderUpdateWithWhereUniqueWithoutSelectedSizeInput>>;
  updateMany?: InputMaybe<Array<ProductOrderUpdateManyWithWhereWithoutSelectedSizeInput>>;
  upsert?: InputMaybe<Array<ProductOrderUpsertWithWhereUniqueWithoutSelectedSizeInput>>;
};

export type ProductOrderUpdateWithWhereUniqueWithoutCurrencyInput = {
  data: ProductOrderUpdateWithoutCurrencyInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpdateWithWhereUniqueWithoutOrderInput = {
  data: ProductOrderUpdateWithoutOrderInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductOrderUpdateWithoutProductInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpdateWithWhereUniqueWithoutSelectedSizeInput = {
  data: ProductOrderUpdateWithoutSelectedSizeInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpdateWithoutCurrencyInput = {
  convertedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductOrdersInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOrderUpdateWithoutOrderInput = {
  convertedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProductOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductOrdersInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOrderUpdateWithoutProductInput = {
  convertedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProductOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  selectedSize?: InputMaybe<ProductSizeUpdateOneWithoutProductOrderInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOrderUpdateWithoutSelectedSizeInput = {
  convertedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  currency?: InputMaybe<CurrencyUpdateOneRequiredWithoutProductOrdersInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateOneRequiredWithoutProductsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutProductOrdersInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProductOrderUpsertWithWhereUniqueWithoutCurrencyInput = {
  create: ProductOrderCreateWithoutCurrencyInput;
  update: ProductOrderUpdateWithoutCurrencyInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpsertWithWhereUniqueWithoutOrderInput = {
  create: ProductOrderCreateWithoutOrderInput;
  update: ProductOrderUpdateWithoutOrderInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductOrderCreateWithoutProductInput;
  update: ProductOrderUpdateWithoutProductInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderUpsertWithWhereUniqueWithoutSelectedSizeInput = {
  create: ProductOrderCreateWithoutSelectedSizeInput;
  update: ProductOrderUpdateWithoutSelectedSizeInput;
  where: ProductOrderWhereUniqueInput;
};

export type ProductOrderWhereInput = {
  AND?: InputMaybe<Array<ProductOrderWhereInput>>;
  NOT?: InputMaybe<Array<ProductOrderWhereInput>>;
  OR?: InputMaybe<Array<ProductOrderWhereInput>>;
  convertedPrice?: InputMaybe<FloatFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  currency?: InputMaybe<CurrencyRelationFilter>;
  currencyId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<StringFilter>;
  price?: InputMaybe<FloatFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntFilter>;
  selectedProductSizeId?: InputMaybe<StringNullableFilter>;
  selectedSize?: InputMaybe<ProductSizeRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ProductOrderWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductWhereInput>;
  isNot?: InputMaybe<ProductWhereInput>;
};

export enum ProductScalarFieldEnum {
  brand = 'brand',
  categoryId = 'categoryId',
  collectionId = 'collectionId',
  createdAt = 'createdAt',
  discountAmount = 'discountAmount',
  discountType = 'discountType',
  id = 'id',
  order = 'order',
  photos = 'photos',
  sku = 'sku',
  status = 'status'
}

export type ProductScalarWhereInput = {
  AND?: InputMaybe<Array<ProductScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereInput>>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  categoryId?: InputMaybe<StringFilter>;
  collectionId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  discountAmount?: InputMaybe<FloatFilter>;
  discountType?: InputMaybe<EnumDiscountTypeFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  sku?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type ProductScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductScalarWhereWithAggregatesInput>>;
  brand?: InputMaybe<EnumBrandTypeWithAggregatesFilter>;
  categoryId?: InputMaybe<StringWithAggregatesFilter>;
  collectionId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  discountAmount?: InputMaybe<FloatWithAggregatesFilter>;
  discountType?: InputMaybe<EnumDiscountTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  sku?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type ProductSize = {
  __typename?: 'ProductSize';
  _count?: Maybe<ProductSizeCount>;
  basketItem: Array<BasketItem>;
  id: Scalars['String'];
  prices: Array<Price>;
  product: Product;
  productId: Scalars['String'];
  productOrder: Array<ProductOrder>;
  size: Size;
  sizeId: Scalars['String'];
};


export type ProductSizeBasketItemArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type ProductSizePricesArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type ProductSizeProductOrderArgs = {
  cursor?: InputMaybe<ProductOrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductOrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductOrderWhereInput>;
};

export type ProductSizeCount = {
  __typename?: 'ProductSizeCount';
  basketItem: Scalars['Int'];
  prices: Scalars['Int'];
  productOrder: Scalars['Int'];
};

export type ProductSizeCountAggregate = {
  __typename?: 'ProductSizeCountAggregate';
  _all: Scalars['Int'];
  id: Scalars['Int'];
  productId: Scalars['Int'];
  sizeId: Scalars['Int'];
};

export type ProductSizeCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
};

export type ProductSizeCreateInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductSizeInput>;
  product: ProductCreateNestedOneWithoutSizesInput;
  productOrder?: InputMaybe<ProductOrderCreateNestedManyWithoutSelectedSizeInput>;
  size: SizeCreateNestedOneWithoutProductSizeInput;
};

export type ProductSizeCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
  sizeId: Scalars['String'];
};

export type ProductSizeCreateManyProductInput = {
  id?: InputMaybe<Scalars['String']>;
  sizeId: Scalars['String'];
};

export type ProductSizeCreateManyProductInputEnvelope = {
  data: Array<ProductSizeCreateManyProductInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductSizeCreateManySizeInput = {
  id?: InputMaybe<Scalars['String']>;
  productId: Scalars['String'];
};

export type ProductSizeCreateManySizeInputEnvelope = {
  data: Array<ProductSizeCreateManySizeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ProductSizeCreateNestedManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSizeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductSizeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductSizeCreateManyProductInputEnvelope>;
};

export type ProductSizeCreateNestedManyWithoutSizeInput = {
  connect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSizeCreateOrConnectWithoutSizeInput>>;
  create?: InputMaybe<Array<ProductSizeCreateWithoutSizeInput>>;
  createMany?: InputMaybe<ProductSizeCreateManySizeInputEnvelope>;
};

export type ProductSizeCreateNestedOneWithoutBasketItemInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<ProductSizeCreateWithoutBasketItemInput>;
};

export type ProductSizeCreateNestedOneWithoutPricesInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<ProductSizeCreateWithoutPricesInput>;
};

export type ProductSizeCreateNestedOneWithoutProductOrderInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutProductOrderInput>;
  create?: InputMaybe<ProductSizeCreateWithoutProductOrderInput>;
};

export type ProductSizeCreateOrConnectWithoutBasketItemInput = {
  create: ProductSizeCreateWithoutBasketItemInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeCreateOrConnectWithoutPricesInput = {
  create: ProductSizeCreateWithoutPricesInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeCreateOrConnectWithoutProductInput = {
  create: ProductSizeCreateWithoutProductInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeCreateOrConnectWithoutProductOrderInput = {
  create: ProductSizeCreateWithoutProductOrderInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeCreateOrConnectWithoutSizeInput = {
  create: ProductSizeCreateWithoutSizeInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeCreateWithoutBasketItemInput = {
  id?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductSizeInput>;
  product: ProductCreateNestedOneWithoutSizesInput;
  productOrder?: InputMaybe<ProductOrderCreateNestedManyWithoutSelectedSizeInput>;
  size: SizeCreateNestedOneWithoutProductSizeInput;
};

export type ProductSizeCreateWithoutPricesInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  product: ProductCreateNestedOneWithoutSizesInput;
  productOrder?: InputMaybe<ProductOrderCreateNestedManyWithoutSelectedSizeInput>;
  size: SizeCreateNestedOneWithoutProductSizeInput;
};

export type ProductSizeCreateWithoutProductInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductSizeInput>;
  productOrder?: InputMaybe<ProductOrderCreateNestedManyWithoutSelectedSizeInput>;
  size: SizeCreateNestedOneWithoutProductSizeInput;
};

export type ProductSizeCreateWithoutProductOrderInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductSizeInput>;
  product: ProductCreateNestedOneWithoutSizesInput;
  size: SizeCreateNestedOneWithoutProductSizeInput;
};

export type ProductSizeCreateWithoutSizeInput = {
  basketItem?: InputMaybe<BasketItemCreateNestedManyWithoutSelectedSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  prices?: InputMaybe<PriceCreateNestedManyWithoutProductSizeInput>;
  product: ProductCreateNestedOneWithoutSizesInput;
  productOrder?: InputMaybe<ProductOrderCreateNestedManyWithoutSelectedSizeInput>;
};

export type ProductSizeGroupBy = {
  __typename?: 'ProductSizeGroupBy';
  _count?: Maybe<ProductSizeCountAggregate>;
  _max?: Maybe<ProductSizeMaxAggregate>;
  _min?: Maybe<ProductSizeMinAggregate>;
  id: Scalars['String'];
  productId: Scalars['String'];
  sizeId: Scalars['String'];
};

export type ProductSizeListRelationFilter = {
  every?: InputMaybe<ProductSizeWhereInput>;
  none?: InputMaybe<ProductSizeWhereInput>;
  some?: InputMaybe<ProductSizeWhereInput>;
};

export type ProductSizeMaxAggregate = {
  __typename?: 'ProductSizeMaxAggregate';
  id?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sizeId?: Maybe<Scalars['String']>;
};

export type ProductSizeMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
};

export type ProductSizeMinAggregate = {
  __typename?: 'ProductSizeMinAggregate';
  id?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  sizeId?: Maybe<Scalars['String']>;
};

export type ProductSizeMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
};

export type ProductSizeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProductSizeOrderByWithAggregationInput = {
  _count?: InputMaybe<ProductSizeCountOrderByAggregateInput>;
  _max?: InputMaybe<ProductSizeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProductSizeMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sizeId?: InputMaybe<SortOrder>;
};

export type ProductSizeOrderByWithRelationInput = {
  basketItem?: InputMaybe<BasketItemOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  prices?: InputMaybe<PriceOrderByRelationAggregateInput>;
  product?: InputMaybe<ProductOrderByWithRelationInput>;
  productId?: InputMaybe<SortOrder>;
  productOrder?: InputMaybe<ProductOrderOrderByRelationAggregateInput>;
  size?: InputMaybe<SizeOrderByWithRelationInput>;
  sizeId?: InputMaybe<SortOrder>;
};

export type ProductSizeRelationFilter = {
  is?: InputMaybe<ProductSizeWhereInput>;
  isNot?: InputMaybe<ProductSizeWhereInput>;
};

export enum ProductSizeScalarFieldEnum {
  id = 'id',
  productId = 'productId',
  sizeId = 'sizeId'
}

export type ProductSizeScalarWhereInput = {
  AND?: InputMaybe<Array<ProductSizeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProductSizeScalarWhereInput>>;
  OR?: InputMaybe<Array<ProductSizeScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  productId?: InputMaybe<StringFilter>;
  sizeId?: InputMaybe<StringFilter>;
};

export type ProductSizeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProductSizeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProductSizeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProductSizeScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  productId?: InputMaybe<StringWithAggregatesFilter>;
  sizeId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ProductSizeUpdateInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductSizeInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutSizesInput>;
  productOrder?: InputMaybe<ProductOrderUpdateManyWithoutSelectedSizeInput>;
  size?: InputMaybe<SizeUpdateOneRequiredWithoutProductSizeInput>;
};

export type ProductSizeUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProductSizeUpdateManyWithWhereWithoutProductInput = {
  data: ProductSizeUpdateManyMutationInput;
  where: ProductSizeScalarWhereInput;
};

export type ProductSizeUpdateManyWithWhereWithoutSizeInput = {
  data: ProductSizeUpdateManyMutationInput;
  where: ProductSizeScalarWhereInput;
};

export type ProductSizeUpdateManyWithoutProductInput = {
  connect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSizeCreateOrConnectWithoutProductInput>>;
  create?: InputMaybe<Array<ProductSizeCreateWithoutProductInput>>;
  createMany?: InputMaybe<ProductSizeCreateManyProductInputEnvelope>;
  delete?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductSizeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductSizeUpdateWithWhereUniqueWithoutProductInput>>;
  updateMany?: InputMaybe<Array<ProductSizeUpdateManyWithWhereWithoutProductInput>>;
  upsert?: InputMaybe<Array<ProductSizeUpsertWithWhereUniqueWithoutProductInput>>;
};

export type ProductSizeUpdateManyWithoutSizeInput = {
  connect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductSizeCreateOrConnectWithoutSizeInput>>;
  create?: InputMaybe<Array<ProductSizeCreateWithoutSizeInput>>;
  createMany?: InputMaybe<ProductSizeCreateManySizeInputEnvelope>;
  delete?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductSizeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductSizeWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductSizeUpdateWithWhereUniqueWithoutSizeInput>>;
  updateMany?: InputMaybe<Array<ProductSizeUpdateManyWithWhereWithoutSizeInput>>;
  upsert?: InputMaybe<Array<ProductSizeUpsertWithWhereUniqueWithoutSizeInput>>;
};

export type ProductSizeUpdateOneWithoutBasketItemInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutBasketItemInput>;
  create?: InputMaybe<ProductSizeCreateWithoutBasketItemInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductSizeUpdateWithoutBasketItemInput>;
  upsert?: InputMaybe<ProductSizeUpsertWithoutBasketItemInput>;
};

export type ProductSizeUpdateOneWithoutPricesInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<ProductSizeCreateWithoutPricesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductSizeUpdateWithoutPricesInput>;
  upsert?: InputMaybe<ProductSizeUpsertWithoutPricesInput>;
};

export type ProductSizeUpdateOneWithoutProductOrderInput = {
  connect?: InputMaybe<ProductSizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductSizeCreateOrConnectWithoutProductOrderInput>;
  create?: InputMaybe<ProductSizeCreateWithoutProductOrderInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductSizeUpdateWithoutProductOrderInput>;
  upsert?: InputMaybe<ProductSizeUpsertWithoutProductOrderInput>;
};

export type ProductSizeUpdateWithWhereUniqueWithoutProductInput = {
  data: ProductSizeUpdateWithoutProductInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeUpdateWithWhereUniqueWithoutSizeInput = {
  data: ProductSizeUpdateWithoutSizeInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeUpdateWithoutBasketItemInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductSizeInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutSizesInput>;
  productOrder?: InputMaybe<ProductOrderUpdateManyWithoutSelectedSizeInput>;
  size?: InputMaybe<SizeUpdateOneRequiredWithoutProductSizeInput>;
};

export type ProductSizeUpdateWithoutPricesInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutSizesInput>;
  productOrder?: InputMaybe<ProductOrderUpdateManyWithoutSelectedSizeInput>;
  size?: InputMaybe<SizeUpdateOneRequiredWithoutProductSizeInput>;
};

export type ProductSizeUpdateWithoutProductInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductSizeInput>;
  productOrder?: InputMaybe<ProductOrderUpdateManyWithoutSelectedSizeInput>;
  size?: InputMaybe<SizeUpdateOneRequiredWithoutProductSizeInput>;
};

export type ProductSizeUpdateWithoutProductOrderInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductSizeInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutSizesInput>;
  size?: InputMaybe<SizeUpdateOneRequiredWithoutProductSizeInput>;
};

export type ProductSizeUpdateWithoutSizeInput = {
  basketItem?: InputMaybe<BasketItemUpdateManyWithoutSelectedSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductSizeInput>;
  product?: InputMaybe<ProductUpdateOneRequiredWithoutSizesInput>;
  productOrder?: InputMaybe<ProductOrderUpdateManyWithoutSelectedSizeInput>;
};

export type ProductSizeUpsertWithWhereUniqueWithoutProductInput = {
  create: ProductSizeCreateWithoutProductInput;
  update: ProductSizeUpdateWithoutProductInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeUpsertWithWhereUniqueWithoutSizeInput = {
  create: ProductSizeCreateWithoutSizeInput;
  update: ProductSizeUpdateWithoutSizeInput;
  where: ProductSizeWhereUniqueInput;
};

export type ProductSizeUpsertWithoutBasketItemInput = {
  create: ProductSizeCreateWithoutBasketItemInput;
  update: ProductSizeUpdateWithoutBasketItemInput;
};

export type ProductSizeUpsertWithoutPricesInput = {
  create: ProductSizeCreateWithoutPricesInput;
  update: ProductSizeUpdateWithoutPricesInput;
};

export type ProductSizeUpsertWithoutProductOrderInput = {
  create: ProductSizeCreateWithoutProductOrderInput;
  update: ProductSizeUpdateWithoutProductOrderInput;
};

export type ProductSizeWhereInput = {
  AND?: InputMaybe<Array<ProductSizeWhereInput>>;
  NOT?: InputMaybe<Array<ProductSizeWhereInput>>;
  OR?: InputMaybe<Array<ProductSizeWhereInput>>;
  basketItem?: InputMaybe<BasketItemListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  prices?: InputMaybe<PriceListRelationFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<StringFilter>;
  productOrder?: InputMaybe<ProductOrderListRelationFilter>;
  size?: InputMaybe<SizeRelationFilter>;
  sizeId?: InputMaybe<StringFilter>;
};

export type ProductSizeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProductSumAggregate = {
  __typename?: 'ProductSumAggregate';
  discountAmount?: Maybe<Scalars['Float']>;
  order?: Maybe<Scalars['Int']>;
};

export type ProductSumOrderByAggregateInput = {
  discountAmount?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type ProductUpdateInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateManyMutationInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateManyWithWhereWithoutCategoryInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithWhereWithoutCollectionInput = {
  data: ProductUpdateManyMutationInput;
  where: ProductScalarWhereInput;
};

export type ProductUpdateManyWithoutCategoryInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutCategoryInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutCategoryInput>>;
  createMany?: InputMaybe<ProductCreateManyCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutCategoryInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutCategoryInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutCategoryInput>>;
};

export type ProductUpdateManyWithoutCollectionInput = {
  connect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProductCreateOrConnectWithoutCollectionInput>>;
  create?: InputMaybe<Array<ProductCreateWithoutCollectionInput>>;
  createMany?: InputMaybe<ProductCreateManyCollectionInputEnvelope>;
  delete?: InputMaybe<Array<ProductWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProductScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProductWhereUniqueInput>>;
  set?: InputMaybe<Array<ProductWhereUniqueInput>>;
  update?: InputMaybe<Array<ProductUpdateWithWhereUniqueWithoutCollectionInput>>;
  updateMany?: InputMaybe<Array<ProductUpdateManyWithWhereWithoutCollectionInput>>;
  upsert?: InputMaybe<Array<ProductUpsertWithWhereUniqueWithoutCollectionInput>>;
};

export type ProductUpdateOneRequiredWithoutBasketItemsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutBasketItemsInput>;
  create?: InputMaybe<ProductCreateWithoutBasketItemsInput>;
  update?: InputMaybe<ProductUpdateWithoutBasketItemsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutBasketItemsInput>;
};

export type ProductUpdateOneRequiredWithoutColorsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutColorsInput>;
  create?: InputMaybe<ProductCreateWithoutColorsInput>;
  update?: InputMaybe<ProductUpdateWithoutColorsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutColorsInput>;
};

export type ProductUpdateOneRequiredWithoutProductOrdersInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutProductOrdersInput>;
  create?: InputMaybe<ProductCreateWithoutProductOrdersInput>;
  update?: InputMaybe<ProductUpdateWithoutProductOrdersInput>;
  upsert?: InputMaybe<ProductUpsertWithoutProductOrdersInput>;
};

export type ProductUpdateOneRequiredWithoutSizesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutSizesInput>;
  create?: InputMaybe<ProductCreateWithoutSizesInput>;
  update?: InputMaybe<ProductUpdateWithoutSizesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutSizesInput>;
};

export type ProductUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<ProductCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<ProductUpsertWithoutDescriptionsInput>;
};

export type ProductUpdateOneWithoutPriceHistoriesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPriceHistoriesInput>;
  create?: InputMaybe<ProductCreateWithoutPriceHistoriesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductUpdateWithoutPriceHistoriesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutPriceHistoriesInput>;
};

export type ProductUpdateOneWithoutPricesInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProductCreateOrConnectWithoutPricesInput>;
  create?: InputMaybe<ProductCreateWithoutPricesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ProductUpdateWithoutPricesInput>;
  upsert?: InputMaybe<ProductUpsertWithoutPricesInput>;
};

export type ProductUpdateWithWhereUniqueWithoutCategoryInput = {
  data: ProductUpdateWithoutCategoryInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithWhereUniqueWithoutCollectionInput = {
  data: ProductUpdateWithoutCollectionInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpdateWithoutBasketItemsInput = {
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutCategoryInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutCollectionInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutColorsInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutDescriptionsInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutPriceHistoriesInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutPricesInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutProductOrdersInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  sizes?: InputMaybe<ProductSizeUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdateWithoutSizesInput = {
  basketItems?: InputMaybe<BasketItemUpdateManyWithoutProductInput>;
  brand?: InputMaybe<EnumBrandTypeFieldUpdateOperationsInput>;
  category?: InputMaybe<CategoryUpdateOneRequiredWithoutProductsInput>;
  collection?: InputMaybe<CollectionUpdateOneWithoutProductsInput>;
  colors?: InputMaybe<ProductColorUpdateManyWithoutProductInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutProductInput>;
  discountAmount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  discountType?: InputMaybe<EnumDiscountTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  photos?: InputMaybe<ProductUpdatephotosInput>;
  priceHistories?: InputMaybe<PriceHistoryUpdateManyWithoutProductInput>;
  prices?: InputMaybe<PriceUpdateManyWithoutProductInput>;
  productOrders?: InputMaybe<ProductOrderUpdateManyWithoutProductInput>;
  sku?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProductUpdatephotosInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductUpsertWithWhereUniqueWithoutCategoryInput = {
  create: ProductCreateWithoutCategoryInput;
  update: ProductUpdateWithoutCategoryInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithWhereUniqueWithoutCollectionInput = {
  create: ProductCreateWithoutCollectionInput;
  update: ProductUpdateWithoutCollectionInput;
  where: ProductWhereUniqueInput;
};

export type ProductUpsertWithoutBasketItemsInput = {
  create: ProductCreateWithoutBasketItemsInput;
  update: ProductUpdateWithoutBasketItemsInput;
};

export type ProductUpsertWithoutColorsInput = {
  create: ProductCreateWithoutColorsInput;
  update: ProductUpdateWithoutColorsInput;
};

export type ProductUpsertWithoutDescriptionsInput = {
  create: ProductCreateWithoutDescriptionsInput;
  update: ProductUpdateWithoutDescriptionsInput;
};

export type ProductUpsertWithoutPriceHistoriesInput = {
  create: ProductCreateWithoutPriceHistoriesInput;
  update: ProductUpdateWithoutPriceHistoriesInput;
};

export type ProductUpsertWithoutPricesInput = {
  create: ProductCreateWithoutPricesInput;
  update: ProductUpdateWithoutPricesInput;
};

export type ProductUpsertWithoutProductOrdersInput = {
  create: ProductCreateWithoutProductOrdersInput;
  update: ProductUpdateWithoutProductOrdersInput;
};

export type ProductUpsertWithoutSizesInput = {
  create: ProductCreateWithoutSizesInput;
  update: ProductUpdateWithoutSizesInput;
};

export type ProductWhereInput = {
  AND?: InputMaybe<Array<ProductWhereInput>>;
  NOT?: InputMaybe<Array<ProductWhereInput>>;
  OR?: InputMaybe<Array<ProductWhereInput>>;
  basketItems?: InputMaybe<BasketItemListRelationFilter>;
  brand?: InputMaybe<EnumBrandTypeFilter>;
  category?: InputMaybe<CategoryRelationFilter>;
  categoryId?: InputMaybe<StringFilter>;
  collection?: InputMaybe<CollectionRelationFilter>;
  collectionId?: InputMaybe<StringNullableFilter>;
  colors?: InputMaybe<ProductColorListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  discountAmount?: InputMaybe<FloatFilter>;
  discountType?: InputMaybe<EnumDiscountTypeFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  photos?: InputMaybe<StringNullableListFilter>;
  priceHistories?: InputMaybe<PriceHistoryListRelationFilter>;
  prices?: InputMaybe<PriceListRelationFilter>;
  productOrders?: InputMaybe<ProductOrderListRelationFilter>;
  sizes?: InputMaybe<ProductSizeListRelationFilter>;
  sku?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type ProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
};

export type ProductsPayload = {
  __typename?: 'ProductsPayload';
  count: Scalars['Int'];
  items: Array<Product>;
};

export type Query = {
  __typename?: 'Query';
  address?: Maybe<Address>;
  addresses: Array<Address>;
  aggregateAddress: AggregateAddress;
  aggregateBasket: AggregateBasket;
  aggregateBasketItem: AggregateBasketItem;
  aggregateCategory: AggregateCategory;
  aggregateCollection: AggregateCollection;
  aggregateColor: AggregateColor;
  aggregateContent: AggregateContent;
  aggregateCurrency: AggregateCurrency;
  aggregateCustomer: AggregateCustomer;
  aggregateDescription: AggregateDescription;
  aggregateDiscountCoupon: AggregateDiscountCoupon;
  aggregateOrder: AggregateOrder;
  aggregatePage: AggregatePage;
  aggregatePrice: AggregatePrice;
  aggregatePriceHistory: AggregatePriceHistory;
  aggregateProduct: AggregateProduct;
  aggregateProductColor: AggregateProductColor;
  aggregateProductSize: AggregateProductSize;
  aggregateSize: AggregateSize;
  aggregateStaff: AggregateStaff;
  basket: Basket;
  basketItem?: Maybe<BasketItem>;
  basketItems: Array<BasketItem>;
  baskets: Array<Basket>;
  categories: Array<Category>;
  category?: Maybe<Category>;
  checkMeCustomer: Customer;
  checkOrderResultCustomer: Order;
  collection?: Maybe<Collection>;
  collections: Array<Collection>;
  color?: Maybe<Color>;
  colors: Array<Color>;
  content?: Maybe<Content>;
  contents: Array<Content>;
  countBasket: BasketInputPayload;
  currencies: Array<Currency>;
  currency?: Maybe<Currency>;
  customProducts: CustomProductsPayload;
  customer?: Maybe<Customer>;
  customers: CustomersPayload;
  dashboardStatistics: DashboardStatisticsPayload;
  description?: Maybe<Description>;
  descriptions: Array<Description>;
  discountCoupon?: Maybe<DiscountCoupon>;
  discountCoupons: Array<DiscountCoupon>;
  findFirstAddress?: Maybe<Address>;
  findFirstBasket?: Maybe<Basket>;
  findFirstBasketItem?: Maybe<BasketItem>;
  findFirstCategory?: Maybe<Category>;
  findFirstCollection?: Maybe<Collection>;
  findFirstColor?: Maybe<Color>;
  findFirstContent?: Maybe<Content>;
  findFirstCurrency?: Maybe<Currency>;
  findFirstCustomer?: Maybe<Customer>;
  findFirstDescription?: Maybe<Description>;
  findFirstDiscountCoupon?: Maybe<DiscountCoupon>;
  findFirstOrder?: Maybe<Order>;
  findFirstPage?: Maybe<Page>;
  findFirstPrice?: Maybe<Price>;
  findFirstPriceHistory?: Maybe<PriceHistory>;
  findFirstProduct?: Maybe<Product>;
  findFirstProductColor?: Maybe<ProductColor>;
  findFirstProductSize?: Maybe<ProductSize>;
  findFirstSize?: Maybe<Size>;
  findFirstStaff?: Maybe<Staff>;
  findManyStaff: Array<Staff>;
  findUniqueStaff?: Maybe<Staff>;
  getAgreementSale: Page;
  groupByAddress: Array<AddressGroupBy>;
  groupByBasket: Array<BasketGroupBy>;
  groupByBasketItem: Array<BasketItemGroupBy>;
  groupByCategory: Array<CategoryGroupBy>;
  groupByCollection: Array<CollectionGroupBy>;
  groupByColor: Array<ColorGroupBy>;
  groupByContent: Array<ContentGroupBy>;
  groupByCurrency: Array<CurrencyGroupBy>;
  groupByCustomer: Array<CustomerGroupBy>;
  groupByDescription: Array<DescriptionGroupBy>;
  groupByDiscountCoupon: Array<DiscountCouponGroupBy>;
  groupByOrder: Array<OrderGroupBy>;
  groupByPage: Array<PageGroupBy>;
  groupByPrice: Array<PriceGroupBy>;
  groupByPriceHistory: Array<PriceHistoryGroupBy>;
  groupByProduct: Array<ProductGroupBy>;
  groupByProductColor: Array<ProductColorGroupBy>;
  groupByProductSize: Array<ProductSizeGroupBy>;
  groupBySize: Array<SizeGroupBy>;
  groupByStaff: Array<StaffGroupBy>;
  myBasketItems: Array<BasketItem>;
  myOrder: Order;
  myOrders: Array<Order>;
  order?: Maybe<Order>;
  orders: Array<Order>;
  page?: Maybe<Page>;
  pages: Array<Page>;
  price?: Maybe<Price>;
  priceHistories: Array<PriceHistory>;
  priceHistory?: Maybe<PriceHistory>;
  prices: Array<Price>;
  product?: Maybe<Product>;
  productColor?: Maybe<ProductColor>;
  productColors: Array<ProductColor>;
  productSize?: Maybe<ProductSize>;
  productSizes: Array<ProductSize>;
  products: ProductsPayload;
  size?: Maybe<Size>;
  sizes: Array<Size>;
  webPage: Page;
};


export type QueryAddressArgs = {
  where: AddressWhereUniqueInput;
};


export type QueryAddressesArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryAggregateAddressArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryAggregateBasketArgs = {
  cursor?: InputMaybe<BasketWhereUniqueInput>;
  orderBy?: InputMaybe<Array<BasketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketWhereInput>;
};


export type QueryAggregateBasketItemArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type QueryAggregateCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryAggregateCollectionArgs = {
  cursor?: InputMaybe<CollectionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CollectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionWhereInput>;
};


export type QueryAggregateColorArgs = {
  cursor?: InputMaybe<ColorWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ColorWhereInput>;
};


export type QueryAggregateContentArgs = {
  cursor?: InputMaybe<ContentWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryAggregateCurrencyArgs = {
  cursor?: InputMaybe<CurrencyWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CurrencyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type QueryAggregateCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryAggregateDescriptionArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type QueryAggregateDiscountCouponArgs = {
  cursor?: InputMaybe<DiscountCouponWhereUniqueInput>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type QueryAggregateOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryAggregatePageArgs = {
  cursor?: InputMaybe<PageWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryAggregatePriceArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type QueryAggregatePriceHistoryArgs = {
  cursor?: InputMaybe<PriceHistoryWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type QueryAggregateProductArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryAggregateProductColorArgs = {
  cursor?: InputMaybe<ProductColorWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type QueryAggregateProductSizeArgs = {
  cursor?: InputMaybe<ProductSizeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type QueryAggregateSizeArgs = {
  cursor?: InputMaybe<SizeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SizeWhereInput>;
};


export type QueryAggregateStaffArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryBasketItemArgs = {
  where: BasketItemWhereUniqueInput;
};


export type QueryBasketItemsArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type QueryBasketsArgs = {
  cursor?: InputMaybe<BasketWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketWhereInput>;
};


export type QueryCategoriesArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryCheckOrderResultCustomerArgs = {
  conversationId: Scalars['String'];
};


export type QueryCollectionArgs = {
  where: CollectionWhereUniqueInput;
};


export type QueryCollectionsArgs = {
  cursor?: InputMaybe<CollectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<CollectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CollectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionWhereInput>;
};


export type QueryColorArgs = {
  where: ColorWhereUniqueInput;
};


export type QueryColorsArgs = {
  cursor?: InputMaybe<ColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ColorWhereInput>;
};


export type QueryContentArgs = {
  where: ContentWhereUniqueInput;
};


export type QueryContentsArgs = {
  cursor?: InputMaybe<ContentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryCurrenciesArgs = {
  cursor?: InputMaybe<CurrencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<CurrencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CurrencyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type QueryCurrencyArgs = {
  where: CurrencyWhereUniqueInput;
};


export type QueryCustomProductsArgs = {
  CustomProductsOrderByFilter?: InputMaybe<CustomProductsOrderByFilter>;
  brand?: InputMaybe<BrandType>;
  categorySlug?: InputMaybe<Scalars['String']>;
  collectionSlug?: InputMaybe<Scalars['String']>;
  currencyCode: Scalars['String'];
  language: Scalars['String'];
  searchValue?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type QueryCustomersArgs = {
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryDescriptionArgs = {
  where: DescriptionWhereUniqueInput;
};


export type QueryDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type QueryDiscountCouponArgs = {
  where: DiscountCouponWhereUniqueInput;
};


export type QueryDiscountCouponsArgs = {
  cursor?: InputMaybe<DiscountCouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<DiscountCouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type QueryFindFirstAddressArgs = {
  cursor?: InputMaybe<AddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryFindFirstBasketArgs = {
  cursor?: InputMaybe<BasketWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketWhereInput>;
};


export type QueryFindFirstBasketItemArgs = {
  cursor?: InputMaybe<BasketItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<BasketItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type QueryFindFirstCategoryArgs = {
  cursor?: InputMaybe<CategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<CategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryFindFirstCollectionArgs = {
  cursor?: InputMaybe<CollectionWhereUniqueInput>;
  distinct?: InputMaybe<Array<CollectionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CollectionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionWhereInput>;
};


export type QueryFindFirstColorArgs = {
  cursor?: InputMaybe<ColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ColorWhereInput>;
};


export type QueryFindFirstContentArgs = {
  cursor?: InputMaybe<ContentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryFindFirstCurrencyArgs = {
  cursor?: InputMaybe<CurrencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<CurrencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CurrencyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type QueryFindFirstCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryFindFirstDescriptionArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type QueryFindFirstDiscountCouponArgs = {
  cursor?: InputMaybe<DiscountCouponWhereUniqueInput>;
  distinct?: InputMaybe<Array<DiscountCouponScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type QueryFindFirstOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstPageArgs = {
  cursor?: InputMaybe<PageWhereUniqueInput>;
  distinct?: InputMaybe<Array<PageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryFindFirstPriceArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type QueryFindFirstPriceHistoryArgs = {
  cursor?: InputMaybe<PriceHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type QueryFindFirstProductArgs = {
  cursor?: InputMaybe<ProductWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryFindFirstProductColorArgs = {
  cursor?: InputMaybe<ProductColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type QueryFindFirstProductSizeArgs = {
  cursor?: InputMaybe<ProductSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type QueryFindFirstSizeArgs = {
  cursor?: InputMaybe<SizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<SizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SizeWhereInput>;
};


export type QueryFindFirstStaffArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  distinct?: InputMaybe<Array<StaffScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryFindManyStaffArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  distinct?: InputMaybe<Array<StaffScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryFindUniqueStaffArgs = {
  where: StaffWhereUniqueInput;
};


export type QueryGetAgreementSaleArgs = {
  language: Scalars['String'];
};


export type QueryGroupByAddressArgs = {
  by: Array<AddressScalarFieldEnum>;
  having?: InputMaybe<AddressScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AddressOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddressWhereInput>;
};


export type QueryGroupByBasketArgs = {
  by: Array<BasketScalarFieldEnum>;
  having?: InputMaybe<BasketScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<BasketOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketWhereInput>;
};


export type QueryGroupByBasketItemArgs = {
  by: Array<BasketItemScalarFieldEnum>;
  having?: InputMaybe<BasketItemScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<BasketItemOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BasketItemWhereInput>;
};


export type QueryGroupByCategoryArgs = {
  by: Array<CategoryScalarFieldEnum>;
  having?: InputMaybe<CategoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryGroupByCollectionArgs = {
  by: Array<CollectionScalarFieldEnum>;
  having?: InputMaybe<CollectionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CollectionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CollectionWhereInput>;
};


export type QueryGroupByColorArgs = {
  by: Array<ColorScalarFieldEnum>;
  having?: InputMaybe<ColorScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ColorOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ColorWhereInput>;
};


export type QueryGroupByContentArgs = {
  by: Array<ContentScalarFieldEnum>;
  having?: InputMaybe<ContentScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ContentOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentWhereInput>;
};


export type QueryGroupByCurrencyArgs = {
  by: Array<CurrencyScalarFieldEnum>;
  having?: InputMaybe<CurrencyScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CurrencyOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CurrencyWhereInput>;
};


export type QueryGroupByCustomerArgs = {
  by: Array<CustomerScalarFieldEnum>;
  having?: InputMaybe<CustomerScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryGroupByDescriptionArgs = {
  by: Array<DescriptionScalarFieldEnum>;
  having?: InputMaybe<DescriptionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type QueryGroupByDiscountCouponArgs = {
  by: Array<DiscountCouponScalarFieldEnum>;
  having?: InputMaybe<DiscountCouponScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DiscountCouponWhereInput>;
};


export type QueryGroupByOrderArgs = {
  by: Array<OrderScalarFieldEnum>;
  having?: InputMaybe<OrderScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryGroupByPageArgs = {
  by: Array<PageScalarFieldEnum>;
  having?: InputMaybe<PageScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PageOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryGroupByPriceArgs = {
  by: Array<PriceScalarFieldEnum>;
  having?: InputMaybe<PriceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PriceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type QueryGroupByPriceHistoryArgs = {
  by: Array<PriceHistoryScalarFieldEnum>;
  having?: InputMaybe<PriceHistoryScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type QueryGroupByProductArgs = {
  by: Array<ProductScalarFieldEnum>;
  having?: InputMaybe<ProductScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProductOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QueryGroupByProductColorArgs = {
  by: Array<ProductColorScalarFieldEnum>;
  having?: InputMaybe<ProductColorScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type QueryGroupByProductSizeArgs = {
  by: Array<ProductSizeScalarFieldEnum>;
  having?: InputMaybe<ProductSizeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type QueryGroupBySizeArgs = {
  by: Array<SizeScalarFieldEnum>;
  having?: InputMaybe<SizeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<SizeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SizeWhereInput>;
};


export type QueryGroupByStaffArgs = {
  by: Array<StaffScalarFieldEnum>;
  having?: InputMaybe<StaffScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<StaffOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryMyOrderArgs = {
  orderId: Scalars['String'];
};


export type QueryMyOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryPageArgs = {
  where: PageWhereUniqueInput;
};


export type QueryPagesArgs = {
  cursor?: InputMaybe<PageWhereUniqueInput>;
  distinct?: InputMaybe<Array<PageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageWhereInput>;
};


export type QueryPriceArgs = {
  where: PriceWhereUniqueInput;
};


export type QueryPriceHistoriesArgs = {
  cursor?: InputMaybe<PriceHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceHistoryWhereInput>;
};


export type QueryPriceHistoryArgs = {
  where: PriceHistoryWhereUniqueInput;
};


export type QueryPricesArgs = {
  cursor?: InputMaybe<PriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<PriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PriceWhereInput>;
};


export type QueryProductArgs = {
  where: ProductWhereUniqueInput;
};


export type QueryProductColorArgs = {
  where: ProductColorWhereUniqueInput;
};


export type QueryProductColorsArgs = {
  cursor?: InputMaybe<ProductColorWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductColorScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductColorOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductColorWhereInput>;
};


export type QueryProductSizeArgs = {
  where: ProductSizeWhereUniqueInput;
};


export type QueryProductSizesArgs = {
  cursor?: InputMaybe<ProductSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};


export type QueryProductsArgs = {
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductWhereInput>;
};


export type QuerySizeArgs = {
  where: SizeWhereUniqueInput;
};


export type QuerySizesArgs = {
  cursor?: InputMaybe<SizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<SizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SizeWhereInput>;
};


export type QueryWebPageArgs = {
  language: Scalars['String'];
  slug: Scalars['String'];
};

export enum QueryMode {
  default = 'default',
  insensitive = 'insensitive'
}

export type Size = {
  __typename?: 'Size';
  _count?: Maybe<SizeCount>;
  createdAt: Scalars['DateTime'];
  descriptions: Array<Description>;
  id: Scalars['String'];
  order: Scalars['Int'];
  productSize: Array<ProductSize>;
  sku: Scalars['String'];
  status: Scalars['Boolean'];
};


export type SizeDescriptionsArgs = {
  cursor?: InputMaybe<DescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<DescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DescriptionWhereInput>;
};


export type SizeProductSizeArgs = {
  cursor?: InputMaybe<ProductSizeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProductSizeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProductSizeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductSizeWhereInput>;
};

export type SizeAvgAggregate = {
  __typename?: 'SizeAvgAggregate';
  order?: Maybe<Scalars['Float']>;
};

export type SizeAvgOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SizeCount = {
  __typename?: 'SizeCount';
  descriptions: Scalars['Int'];
  productSize: Scalars['Int'];
};

export type SizeCountAggregate = {
  __typename?: 'SizeCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  sku: Scalars['Int'];
  status: Scalars['Int'];
};

export type SizeCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type SizeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  productSize?: InputMaybe<ProductSizeCreateNestedManyWithoutSizeInput>;
  sku: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
};

export type SizeCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
};

export type SizeCreateNestedOneWithoutDescriptionsInput = {
  connect?: InputMaybe<SizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SizeCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<SizeCreateWithoutDescriptionsInput>;
};

export type SizeCreateNestedOneWithoutProductSizeInput = {
  connect?: InputMaybe<SizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SizeCreateOrConnectWithoutProductSizeInput>;
  create?: InputMaybe<SizeCreateWithoutProductSizeInput>;
};

export type SizeCreateOrConnectWithoutDescriptionsInput = {
  create: SizeCreateWithoutDescriptionsInput;
  where: SizeWhereUniqueInput;
};

export type SizeCreateOrConnectWithoutProductSizeInput = {
  create: SizeCreateWithoutProductSizeInput;
  where: SizeWhereUniqueInput;
};

export type SizeCreateWithoutDescriptionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  productSize?: InputMaybe<ProductSizeCreateNestedManyWithoutSizeInput>;
  sku: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
};

export type SizeCreateWithoutProductSizeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  descriptions?: InputMaybe<DescriptionCreateNestedManyWithoutSizeInput>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  sku: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
};

export type SizeGroupBy = {
  __typename?: 'SizeGroupBy';
  _avg?: Maybe<SizeAvgAggregate>;
  _count?: Maybe<SizeCountAggregate>;
  _max?: Maybe<SizeMaxAggregate>;
  _min?: Maybe<SizeMinAggregate>;
  _sum?: Maybe<SizeSumAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  order: Scalars['Int'];
  sku: Scalars['String'];
  status: Scalars['Boolean'];
};

export type SizeMaxAggregate = {
  __typename?: 'SizeMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SizeMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type SizeMinAggregate = {
  __typename?: 'SizeMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Boolean']>;
};

export type SizeMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type SizeOrderByWithAggregationInput = {
  _avg?: InputMaybe<SizeAvgOrderByAggregateInput>;
  _count?: InputMaybe<SizeCountOrderByAggregateInput>;
  _max?: InputMaybe<SizeMaxOrderByAggregateInput>;
  _min?: InputMaybe<SizeMinOrderByAggregateInput>;
  _sum?: InputMaybe<SizeSumOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type SizeOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  descriptions?: InputMaybe<DescriptionOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  productSize?: InputMaybe<ProductSizeOrderByRelationAggregateInput>;
  sku?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type SizeRelationFilter = {
  is?: InputMaybe<SizeWhereInput>;
  isNot?: InputMaybe<SizeWhereInput>;
};

export enum SizeScalarFieldEnum {
  createdAt = 'createdAt',
  id = 'id',
  order = 'order',
  sku = 'sku',
  status = 'status'
}

export type SizeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SizeScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<SizeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SizeScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  order?: InputMaybe<IntWithAggregatesFilter>;
  sku?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<BoolWithAggregatesFilter>;
};

export type SizeSumAggregate = {
  __typename?: 'SizeSumAggregate';
  order?: Maybe<Scalars['Int']>;
};

export type SizeSumOrderByAggregateInput = {
  order?: InputMaybe<SortOrder>;
};

export type SizeUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  productSize?: InputMaybe<ProductSizeUpdateManyWithoutSizeInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SizeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SizeUpdateOneRequiredWithoutProductSizeInput = {
  connect?: InputMaybe<SizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SizeCreateOrConnectWithoutProductSizeInput>;
  create?: InputMaybe<SizeCreateWithoutProductSizeInput>;
  update?: InputMaybe<SizeUpdateWithoutProductSizeInput>;
  upsert?: InputMaybe<SizeUpsertWithoutProductSizeInput>;
};

export type SizeUpdateOneWithoutDescriptionsInput = {
  connect?: InputMaybe<SizeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SizeCreateOrConnectWithoutDescriptionsInput>;
  create?: InputMaybe<SizeCreateWithoutDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SizeUpdateWithoutDescriptionsInput>;
  upsert?: InputMaybe<SizeUpsertWithoutDescriptionsInput>;
};

export type SizeUpdateWithoutDescriptionsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  productSize?: InputMaybe<ProductSizeUpdateManyWithoutSizeInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SizeUpdateWithoutProductSizeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  descriptions?: InputMaybe<DescriptionUpdateManyWithoutSizeInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  sku?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type SizeUpsertWithoutDescriptionsInput = {
  create: SizeCreateWithoutDescriptionsInput;
  update: SizeUpdateWithoutDescriptionsInput;
};

export type SizeUpsertWithoutProductSizeInput = {
  create: SizeCreateWithoutProductSizeInput;
  update: SizeUpdateWithoutProductSizeInput;
};

export type SizeWhereInput = {
  AND?: InputMaybe<Array<SizeWhereInput>>;
  NOT?: InputMaybe<Array<SizeWhereInput>>;
  OR?: InputMaybe<Array<SizeWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptions?: InputMaybe<DescriptionListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  productSize?: InputMaybe<ProductSizeListRelationFilter>;
  sku?: InputMaybe<StringFilter>;
  status?: InputMaybe<BoolFilter>;
};

export type SizeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  sku?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}

export type Staff = {
  __typename?: 'Staff';
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  role: StaffRoleType;
  surname?: Maybe<Scalars['String']>;
};

export type StaffCountAggregate = {
  __typename?: 'StaffCountAggregate';
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  email: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  password: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  role: Scalars['Int'];
  surname: Scalars['Int'];
};

export type StaffCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
};

export type StaffCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<StaffRoleType>;
  surname?: InputMaybe<Scalars['String']>;
};

export type StaffCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<StaffRoleType>;
  surname?: InputMaybe<Scalars['String']>;
};

export type StaffGroupBy = {
  __typename?: 'StaffGroupBy';
  _count?: Maybe<StaffCountAggregate>;
  _max?: Maybe<StaffMaxAggregate>;
  _min?: Maybe<StaffMinAggregate>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  role: StaffRoleType;
  surname?: Maybe<Scalars['String']>;
};

export type StaffLoginPayload = {
  __typename?: 'StaffLoginPayload';
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export type StaffMaxAggregate = {
  __typename?: 'StaffMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<StaffRoleType>;
  surname?: Maybe<Scalars['String']>;
};

export type StaffMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
};

export type StaffMinAggregate = {
  __typename?: 'StaffMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<StaffRoleType>;
  surname?: Maybe<Scalars['String']>;
};

export type StaffMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
};

export type StaffOrderByWithAggregationInput = {
  _count?: InputMaybe<StaffCountOrderByAggregateInput>;
  _max?: InputMaybe<StaffMaxOrderByAggregateInput>;
  _min?: InputMaybe<StaffMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
};

export type StaffOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  surname?: InputMaybe<SortOrder>;
};

export enum StaffRoleType {
  ADMIN = 'ADMIN',
  SALES = 'SALES'
}

export enum StaffScalarFieldEnum {
  createdAt = 'createdAt',
  email = 'email',
  id = 'id',
  name = 'name',
  password = 'password',
  phoneNumber = 'phoneNumber',
  role = 'role',
  surname = 'surname'
}

export type StaffScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<StaffScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<StaffScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<StaffScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  email?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  password?: InputMaybe<StringWithAggregatesFilter>;
  phoneNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  role?: InputMaybe<EnumStaffRoleTypeWithAggregatesFilter>;
  surname?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type StaffUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumStaffRoleTypeFieldUpdateOperationsInput>;
  surname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StaffUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  email?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  password?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumStaffRoleTypeFieldUpdateOperationsInput>;
  surname?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type StaffWhereInput = {
  AND?: InputMaybe<Array<StaffWhereInput>>;
  NOT?: InputMaybe<Array<StaffWhereInput>>;
  OR?: InputMaybe<Array<StaffWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  password?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  role?: InputMaybe<EnumStaffRoleTypeFilter>;
  surname?: InputMaybe<StringNullableFilter>;
};

export type StaffWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type UpdateMeInput = {
  currentPassword?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  identityNumber: Scalars['String'];
  name: Scalars['String'];
  newPassword?: InputMaybe<StringFieldUpdateOperationsInput>;
  phoneNumber: Scalars['String'];
  surname: Scalars['String'];
};

export type DeleteManyBasketItemMutationVariables = Exact<{
  where?: InputMaybe<BasketItemWhereInput>;
}>;


export type DeleteManyBasketItemMutation = { __typename?: 'Mutation', deleteManyBasketItem: { __typename?: 'AffectedRowsOutput', count: number } };

export type CategoriesQueryVariables = Exact<{
  where?: InputMaybe<CategoryWhereInput>;
  orderBy?: InputMaybe<Array<CategoryOrderByWithRelationInput> | CategoryOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type CategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, createdAt: any, brand: BrandType, photos: Array<string>, discountAmount: number, status: boolean, parentCategoryId?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }>, _count?: { __typename?: 'CategoryCount', subCategories: number } | null, parentCategory?: { __typename?: 'Category', descriptions: Array<{ __typename?: 'Description', title: string, language: LanguageOptions }> } | null }> };

export type CategoryQueryVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type CategoryQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: string, createdAt: any, brand: BrandType, photos: Array<string>, parentCategoryId?: string | null, discountAmount: number, status: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } | null };

export type CreateCategoryMutationVariables = Exact<{
  data: CategoryCreateInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', createCategory: { __typename?: 'Category', id: string } };

export type DeleteCategoryMutationVariables = Exact<{
  where: CategoryWhereUniqueInput;
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory?: { __typename?: 'Category', id: string } | null };

export type MakeCategoryDiscountMutationVariables = Exact<{
  where: CategoryWhereUniqueInput;
  discountAmount: Scalars['Float'];
}>;


export type MakeCategoryDiscountMutation = { __typename?: 'Mutation', makeCategoryDiscount: boolean };

export type OrderCategoryMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'Category', id: string } | null };

export type UpdateCategoryMutationVariables = Exact<{
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'Mutation', updateCategory?: { __typename?: 'Category', id: string } | null };

export type CollectionQueryVariables = Exact<{
  where: CollectionWhereUniqueInput;
}>;


export type CollectionQuery = { __typename?: 'Query', collection?: { __typename?: 'Collection', id: string, createdAt: any, photos: Array<string>, status: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } | null };

export type CollectionsQueryVariables = Exact<{
  where?: InputMaybe<CollectionWhereInput>;
  orderBy?: InputMaybe<Array<CollectionOrderByWithRelationInput> | CollectionOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type CollectionsQuery = { __typename?: 'Query', collections: Array<{ __typename?: 'Collection', id: string, createdAt: any, photos: Array<string>, status: boolean, order: number, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type CreateCollectionMutationVariables = Exact<{
  data: CollectionCreateInput;
}>;


export type CreateCollectionMutation = { __typename?: 'Mutation', createCollection: { __typename?: 'Collection', id: string } };

export type DeleteCollectionMutationVariables = Exact<{
  where: CollectionWhereUniqueInput;
}>;


export type DeleteCollectionMutation = { __typename?: 'Mutation', deleteCollection?: { __typename?: 'Collection', id: string } | null };

export type OrderCollectionMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderCollectionMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'Collection', id: string } | null };

export type UpdateCollectionMutationVariables = Exact<{
  data: CollectionUpdateInput;
  where: CollectionWhereUniqueInput;
}>;


export type UpdateCollectionMutation = { __typename?: 'Mutation', updateCollection?: { __typename?: 'Collection', id: string } | null };

export type ColorQueryVariables = Exact<{
  where: ColorWhereUniqueInput;
}>;


export type ColorQuery = { __typename?: 'Query', color?: { __typename?: 'Color', id: string, createdAt: any, code?: string | null, order: number } | null };

export type ColorsQueryVariables = Exact<{
  where?: InputMaybe<ColorWhereInput>;
  orderBy?: InputMaybe<Array<ColorOrderByWithRelationInput> | ColorOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ColorsQuery = { __typename?: 'Query', colors: Array<{ __typename?: 'Color', id: string, createdAt: any, code?: string | null, order: number, status: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type CreateColorMutationVariables = Exact<{
  data: ColorCreateInput;
}>;


export type CreateColorMutation = { __typename?: 'Mutation', createColor: { __typename?: 'Color', id: string } };

export type DeleteColorMutationVariables = Exact<{
  where: ColorWhereUniqueInput;
}>;


export type DeleteColorMutation = { __typename?: 'Mutation', deleteColor?: { __typename?: 'Color', id: string } | null };

export type OrderColorMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderColorMutation = { __typename?: 'Mutation', updateColor?: { __typename?: 'Color', id: string } | null };

export type UpdateColorMutationVariables = Exact<{
  data: ColorUpdateInput;
  where: ColorWhereUniqueInput;
}>;


export type UpdateColorMutation = { __typename?: 'Mutation', updateColor?: { __typename?: 'Color', id: string } | null };

export type ContentQueryVariables = Exact<{
  where: ContentWhereUniqueInput;
}>;


export type ContentQuery = { __typename?: 'Query', content?: { __typename?: 'Content', id: string, contentType: ContentType, mediaType: MediaType, photos: Array<string>, video?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } | null };

export type ContentsQueryVariables = Exact<{
  where?: InputMaybe<ContentWhereInput>;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput> | ContentOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ContentsQuery = { __typename?: 'Query', contents: Array<{ __typename?: 'Content', id: string, contentType: ContentType, mediaType: MediaType, photos: Array<string>, video?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type CreateContentMutationVariables = Exact<{
  data: ContentCreateInput;
}>;


export type CreateContentMutation = { __typename?: 'Mutation', createContent: { __typename?: 'Content', id: string } };

export type DeleteContentMutationVariables = Exact<{
  where: ContentWhereUniqueInput;
}>;


export type DeleteContentMutation = { __typename?: 'Mutation', deleteContent?: { __typename?: 'Content', id: string } | null };

export type OrderContentMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderContentMutation = { __typename?: 'Mutation', updateContent?: { __typename?: 'Content', id: string } | null };

export type UpdateContentMutationVariables = Exact<{
  data: ContentUpdateInput;
  where: ContentWhereUniqueInput;
}>;


export type UpdateContentMutation = { __typename?: 'Mutation', updateContent?: { __typename?: 'Content', id: string } | null };

export type CreateCurrencyMutationVariables = Exact<{
  data: CurrencyCreateInput;
}>;


export type CreateCurrencyMutation = { __typename?: 'Mutation', createCurrency: { __typename?: 'Currency', id: string } };

export type CurrenciesQueryVariables = Exact<{
  where?: InputMaybe<CurrencyWhereInput>;
  orderBy?: InputMaybe<Array<CurrencyOrderByWithRelationInput> | CurrencyOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type CurrenciesQuery = { __typename?: 'Query', currencies: Array<{ __typename?: 'Currency', id: string, status: boolean, order: number, code: string, prefix?: string | null, suffix?: string | null, buy: number, sell: number, isDefault: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type CurrencyQueryVariables = Exact<{
  where: CurrencyWhereUniqueInput;
}>;


export type CurrencyQuery = { __typename?: 'Query', currency?: { __typename?: 'Currency', id: string, status: boolean, order: number, code: string, prefix?: string | null, suffix?: string | null, buy: number, sell: number, isDefault: boolean, autoUpdate: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } | null };

export type DeleteCurrencyMutationVariables = Exact<{
  where: CurrencyWhereUniqueInput;
}>;


export type DeleteCurrencyMutation = { __typename?: 'Mutation', deleteCurrency?: { __typename?: 'Currency', id: string } | null };

export type OrderCurrencyMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderCurrencyMutation = { __typename?: 'Mutation', updateCurrency?: { __typename?: 'Currency', id: string } | null };

export type UpdateCurrencyMutationVariables = Exact<{
  data: CurrencyUpdateInput;
  where: CurrencyWhereUniqueInput;
}>;


export type UpdateCurrencyMutation = { __typename?: 'Mutation', updateCurrency?: { __typename?: 'Currency', id: string } | null };

export type CreateCustomerMutationVariables = Exact<{
  data: CustomerCreateInput;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer: { __typename?: 'Customer', id: string } };

export type CustomerQueryVariables = Exact<{
  where: CustomerWhereUniqueInput;
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, createdAt: any, name: string, surname: string, email: string, phoneNumber?: string | null, phoneActivated: boolean, emailActivated: boolean, addresses: Array<{ __typename?: 'Address', id: string, title: string, city: string, postalCode?: string | null, state?: string | null, addressLineOne: string, addressLineTwo?: string | null }> } | null };

export type CustomersQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type CustomersQuery = { __typename?: 'Query', customers: { __typename?: 'CustomersPayload', count: number, items: Array<{ __typename?: 'Customer', id: string, createdAt: any, name: string, surname: string, email: string, emailActivated: boolean, phoneNumber?: string | null, phoneActivated: boolean, _count?: { __typename?: 'CustomerCount', orders: number } | null }> } };

export type DeleteCustomerMutationVariables = Exact<{
  where: CustomerWhereUniqueInput;
}>;


export type DeleteCustomerMutation = { __typename?: 'Mutation', deleteCustomer?: { __typename?: 'Customer', id: string } | null };

export type UpdateCustomerMutationVariables = Exact<{
  data: CustomerUpdateInput;
  where: CustomerWhereUniqueInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id: string } | null };

export type DashboardStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardStatisticsQuery = { __typename?: 'Query', dashboardStatistics: { __typename?: 'DashboardStatisticsPayload', todayOrderCount?: number | null, weeklyOrderCount?: number | null, todayEarnings?: number | null, weeklyEarnings?: number | null, last4Products?: Array<{ __typename?: 'Product', id: string, photos: Array<string>, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> | null, pendingOrders?: Array<{ __typename?: 'Order', id: string, identityNumber?: string | null, conversationId?: string | null, paymentFirstName?: string | null, paymentLastName?: string | null, shippingFirstName?: string | null, shippingLastName?: string | null, isCompleted: boolean, orderStatus: OrderStatus, createdAt: any, customer: { __typename?: 'Customer', id: string, name: string, surname: string }, payment?: { __typename?: 'Payment', id: string, price: number, paidPrice: number, discount: number, installment: number } | null, _count?: { __typename?: 'OrderCount', products: number } | null }> | null } };

export type CreateDescriptionMutationVariables = Exact<{
  data: DescriptionCreateInput;
}>;


export type CreateDescriptionMutation = { __typename?: 'Mutation', createDescription: { __typename?: 'Description', id: string } };

export type DeleteDescriptionMutationVariables = Exact<{
  where: DescriptionWhereUniqueInput;
}>;


export type DeleteDescriptionMutation = { __typename?: 'Mutation', deleteDescription?: { __typename?: 'Description', id: string } | null };

export type DescriptionQueryVariables = Exact<{
  where: DescriptionWhereUniqueInput;
}>;


export type DescriptionQuery = { __typename?: 'Query', description?: { __typename?: 'Description', id: string, title: string, slug: string, description?: string | null, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions } | null };

export type UpdateDescriptionMutationVariables = Exact<{
  data: DescriptionUpdateInput;
  where: DescriptionWhereUniqueInput;
}>;


export type UpdateDescriptionMutation = { __typename?: 'Mutation', updateDescription?: { __typename?: 'Description', id: string } | null };

export type CreateDiscountCouponMutationVariables = Exact<{
  data: DiscountCouponCreateInput;
}>;


export type CreateDiscountCouponMutation = { __typename?: 'Mutation', createDiscountCoupon: { __typename?: 'DiscountCoupon', id: string } };

export type DeleteDiscountCouponMutationVariables = Exact<{
  where: DiscountCouponWhereUniqueInput;
}>;


export type DeleteDiscountCouponMutation = { __typename?: 'Mutation', deleteDiscountCoupon?: { __typename?: 'DiscountCoupon', id: string } | null };

export type DiscountCouponQueryVariables = Exact<{
  where: DiscountCouponWhereUniqueInput;
}>;


export type DiscountCouponQuery = { __typename?: 'Query', discountCoupon?: { __typename?: 'DiscountCoupon', id: string, createdAt: any, isPercentage: boolean, code: string, amount: number, validUntil: any, status: boolean, image?: string | null, customerId?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } | null };

export type DiscountCouponsQueryVariables = Exact<{
  where?: InputMaybe<DiscountCouponWhereInput>;
  orderBy?: InputMaybe<Array<DiscountCouponOrderByWithRelationInput> | DiscountCouponOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type DiscountCouponsQuery = { __typename?: 'Query', discountCoupons: Array<{ __typename?: 'DiscountCoupon', id: string, createdAt: any, isPercentage: boolean, code: string, amount: number, validUntil: any, status: boolean, image?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type UpdateDiscountCouponMutationVariables = Exact<{
  data: DiscountCouponUpdateInput;
  where: DiscountCouponWhereUniqueInput;
}>;


export type UpdateDiscountCouponMutation = { __typename?: 'Mutation', updateDiscountCoupon?: { __typename?: 'DiscountCoupon', id: string } | null };

export type OrderQueryVariables = Exact<{
  where: OrderWhereUniqueInput;
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', id: string, createdAt: any, conversationId?: string | null, identityNumber?: string | null, paymentFirstName?: string | null, paymentLastName?: string | null, paymentEmail?: string | null, paymentPhoneNumber?: string | null, paymentCompany?: string | null, paymentTaxNumber?: string | null, paymentTaxOffice?: string | null, paymentAddress?: string | null, paymentPostalCode?: string | null, paymentCity?: string | null, paymentCountry?: string | null, shippingFirstName?: string | null, shippingLastName?: string | null, shippingEmail?: string | null, shippingPhoneNumber?: string | null, shippingAddress?: string | null, shippingPostalCode?: string | null, shippingCity?: string | null, shippingCountry?: string | null, shippingConvertedPrice?: number | null, shippingTitle?: string | null, shippingPrice?: number | null, shippingNumber?: string | null, isShipped: boolean, isCompleted: boolean, invoiceNumber?: string | null, agreementSale?: string | null, informationSale?: string | null, language?: string | null, orderStatus: OrderStatus, products: Array<{ __typename?: 'ProductOrder', id: string, createdAt: any, price: number, convertedPrice: number, quantity: number, product: { __typename?: 'Product', id: string, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }, selectedSize?: { __typename?: 'ProductSize', id: string, size: { __typename?: 'Size', id: string, sku: string, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } } | null }>, orderHistories: Array<{ __typename?: 'OrderHistory', id: string, createdAt: any, title: string, description?: string | null }>, discountCoupon?: { __typename?: 'DiscountCoupon', id: string, createdAt: any, code: string, amount: number } | null, payment?: { __typename?: 'Payment', id: string, createdAt: any, status: string, errorCode?: string | null, errorMessage?: string | null, locale?: string | null, systemTime?: string | null, price: number, paidPrice: number, merchantCommissionRate: number, merchantCommissionRateAmount: number, iyziCommissionRateAmount: number, iyziCommissionFee: number, discount: number, installment: number, paymentId?: string | null, cardType?: string | null, binNumber?: string | null, cardAssociation?: string | null, lastFourDigits?: string | null, authCode?: string | null, phase?: string | null, orderId: string } | null, customer: { __typename?: 'Customer', id: string, createdAt: any, name: string, surname: string, email: string, phoneNumber?: string | null, identityNumber?: string | null } } | null };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: string, createdAt: any, conversationId?: string | null, isShipped: boolean, isCompleted: boolean, orderStatus: OrderStatus, customer: { __typename?: 'Customer', id: string, name: string, surname: string }, payment?: { __typename?: 'Payment', id: string, price: number, paidPrice: number, currency: { __typename?: 'Currency', id: string, code: string, prefix?: string | null, suffix?: string | null } } | null }> };

export type UpdateOrderMutationVariables = Exact<{
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id: string } | null };

export type CreatePageMutationVariables = Exact<{
  data: PageCreateInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPage: { __typename?: 'Page', id: string } };

export type DeletePageMutationVariables = Exact<{
  where: PageWhereUniqueInput;
}>;


export type DeletePageMutation = { __typename?: 'Mutation', deletePage?: { __typename?: 'Page', id: string } | null };

export type OrderPageMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderPageMutation = { __typename?: 'Mutation', updatePage?: { __typename?: 'Page', id: string } | null };

export type PageQueryVariables = Exact<{
  where: PageWhereUniqueInput;
  orderBy?: InputMaybe<Array<ContentOrderByWithRelationInput> | ContentOrderByWithRelationInput>;
}>;


export type PageQuery = { __typename?: 'Query', page?: { __typename?: 'Page', id: string, status: boolean, pageType: PageType, showOnHeader: boolean, showOnFooter: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null }>, content: Array<{ __typename?: 'Content', id: string, contentType: ContentType, mediaType: MediaType, photos: Array<string>, video?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null }> }> } | null };

export type PagesQueryVariables = Exact<{
  where?: InputMaybe<PageWhereInput>;
  orderBy?: InputMaybe<Array<PageOrderByWithRelationInput> | PageOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type PagesQuery = { __typename?: 'Query', pages: Array<{ __typename?: 'Page', id: string, status: boolean, pageType: PageType, showOnHeader: boolean, showOnFooter: boolean, _count?: { __typename?: 'PageCount', content: number } | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type UpdatePageMutationVariables = Exact<{
  data: PageUpdateInput;
  where: PageWhereUniqueInput;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePage?: { __typename?: 'Page', id: string } | null };

export type CreatePriceMutationVariables = Exact<{
  data: PriceCreateInput;
}>;


export type CreatePriceMutation = { __typename?: 'Mutation', createPrice: { __typename?: 'Price', id: string } };

export type DeletePriceMutationVariables = Exact<{
  where: PriceWhereUniqueInput;
}>;


export type DeletePriceMutation = { __typename?: 'Mutation', deletePrice?: { __typename?: 'Price', id: string } | null };

export type PriceQueryVariables = Exact<{
  where: PriceWhereUniqueInput;
}>;


export type PriceQuery = { __typename?: 'Query', price?: { __typename?: 'Price', id: string, price: number, currencyId: string, productId?: string | null } | null };

export type UpdatePriceMutationVariables = Exact<{
  price: Scalars['Float'];
  productId: Scalars['String'];
}>;


export type UpdatePriceMutation = { __typename?: 'Mutation', updatePrice: boolean };

export type PriceHistoriesQueryVariables = Exact<{
  where?: InputMaybe<PriceHistoryWhereInput>;
  orderBy?: InputMaybe<Array<PriceHistoryOrderByWithRelationInput> | PriceHistoryOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type PriceHistoriesQuery = { __typename?: 'Query', priceHistories: Array<{ __typename?: 'PriceHistory', id: string, price: number, currencyId: string, productId?: string | null, createdAt: any, updatedAt: any, currency: { __typename?: 'Currency', id: string, code: string } }> };

export type CreateProductCustomMutationVariables = Exact<{
  data: ProductCreateCustomInput;
}>;


export type CreateProductCustomMutation = { __typename?: 'Mutation', createProductCustom: { __typename?: 'Product', id: string } };

export type DeleteProductMutationVariables = Exact<{
  where: ProductWhereUniqueInput;
}>;


export type DeleteProductMutation = { __typename?: 'Mutation', deleteProduct?: { __typename?: 'Product', id: string } | null };

export type OrderProductMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string } };

export type ProductQueryVariables = Exact<{
  where: ProductWhereUniqueInput;
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, createdAt: any, sku?: string | null, photos: Array<string>, discountType: DiscountType, discountAmount: number, status: boolean, order: number, brand: BrandType, categoryId: string, collectionId?: string | null, prices: Array<{ __typename?: 'Price', id: string, price: number, currency: { __typename?: 'Currency', id: string, code: string, buy: number, sell: number, isDefault: boolean, prefix?: string | null, suffix?: string | null } }>, sizes: Array<{ __typename?: 'ProductSize', id: string, sizeId: string, size: { __typename?: 'Size', id: string, sku: string, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } }>, colors: Array<{ __typename?: 'ProductColor', id: string, colorId: string, color: { __typename?: 'Color', id: string, code?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> } }> } | null };

export type ProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductWhereInput>;
  orderBy?: InputMaybe<Array<ProductOrderByWithRelationInput> | ProductOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsPayload', count: number, items: Array<{ __typename?: 'Product', id: string, createdAt: any, photos: Array<string>, discountType: DiscountType, discountAmount: number, status: boolean, order: number, brand: BrandType, sku?: string | null, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }>, category: { __typename?: 'Category', id: string, brand: BrandType, descriptions: Array<{ __typename?: 'Description', title: string }> }, collection?: { __typename?: 'Collection', id: string, descriptions: Array<{ __typename?: 'Description', title: string }> } | null, prices: Array<{ __typename?: 'Price', id: string, price: number, currency: { __typename?: 'Currency', id: string, code: string, buy: number, sell: number, isDefault: boolean, prefix?: string | null, suffix?: string | null } }> }> } };

export type UpdateProductMutationVariables = Exact<{
  data: ProductUpdateInput;
  where: ProductWhereUniqueInput;
}>;


export type UpdateProductMutation = { __typename?: 'Mutation', updateProduct: { __typename?: 'Product', id: string, brand: BrandType } };

export type CreateCustomProductSizeMutationVariables = Exact<{
  sizeId: Scalars['String'];
  price: Scalars['Float'];
}>;


export type CreateCustomProductSizeMutation = { __typename?: 'Mutation', createCustomProductSize: { __typename?: 'ProductSize', id: string } };

export type ProductSizesQueryVariables = Exact<{
  where?: InputMaybe<ProductSizeWhereInput>;
  descriptionsWhere2?: InputMaybe<DescriptionWhereInput>;
}>;


export type ProductSizesQuery = { __typename?: 'Query', productSizes: Array<{ __typename?: 'ProductSize', id: string, prices: Array<{ __typename?: 'Price', id: string, price: number, currencyId: string, currency: { __typename?: 'Currency', code: string, id: string } }>, size: { __typename?: 'Size', id: string, sku: string, descriptions: Array<{ __typename?: 'Description', id: string, language: LanguageOptions, title: string }> } }> };

export type UpdateCustomProductSizeMutationVariables = Exact<{
  sizeId: Scalars['String'];
  price: Scalars['Float'];
  priceId: Scalars['String'];
}>;


export type UpdateCustomProductSizeMutation = { __typename?: 'Mutation', updateCustomProductSize: { __typename?: 'ProductSize', id: string } };

export type CreateSizeMutationVariables = Exact<{
  data: SizeCreateInput;
}>;


export type CreateSizeMutation = { __typename?: 'Mutation', createSize: { __typename?: 'Size', id: string } };

export type DeleteSizeMutationVariables = Exact<{
  where: SizeWhereUniqueInput;
}>;


export type DeleteSizeMutation = { __typename?: 'Mutation', deleteSize?: { __typename?: 'Size', id: string } | null };

export type OrderSizeMutationVariables = Exact<{
  id: Scalars['String'];
  order: Scalars['Int'];
}>;


export type OrderSizeMutation = { __typename?: 'Mutation', updateSize?: { __typename?: 'Size', id: string } | null };

export type SizeQueryVariables = Exact<{
  where: SizeWhereUniqueInput;
}>;


export type SizeQuery = { __typename?: 'Query', size?: { __typename?: 'Size', id: string, createdAt: any, sku: string, order: number } | null };

export type SizesQueryVariables = Exact<{
  where?: InputMaybe<SizeWhereInput>;
  orderBy?: InputMaybe<Array<SizeOrderByWithRelationInput> | SizeOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type SizesQuery = { __typename?: 'Query', sizes: Array<{ __typename?: 'Size', id: string, createdAt: any, sku: string, order: number, status: boolean, descriptions: Array<{ __typename?: 'Description', id: string, title: string, description?: string | null, slug: string, headline?: string | null, buttonText?: string | null, buttonUrl?: string | null, language: LanguageOptions }> }> };

export type UpdateSizeMutationVariables = Exact<{
  data: SizeUpdateInput;
  where: SizeWhereUniqueInput;
}>;


export type UpdateSizeMutation = { __typename?: 'Mutation', updateSize?: { __typename?: 'Size', id: string } | null };

export type CreateStaffMutationVariables = Exact<{
  data: StaffCreateInput;
}>;


export type CreateStaffMutation = { __typename?: 'Mutation', createStaff: { __typename?: 'Staff', id: string } };

export type FindManyStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type FindManyStaffQuery = { __typename?: 'Query', findManyStaff: Array<{ __typename?: 'Staff', id: string, name: string, surname?: string | null, email: string, phoneNumber?: string | null, role: StaffRoleType, createdAt: any }> };

export type FindUniqueStaffQueryVariables = Exact<{
  where: StaffWhereUniqueInput;
}>;


export type FindUniqueStaffQuery = { __typename?: 'Query', findUniqueStaff?: { __typename?: 'Staff', createdAt: any, email: string, id: string, name: string, phoneNumber?: string | null, role: StaffRoleType, surname?: string | null } | null };

export type StaffLoginMutationVariables = Exact<{
  data: LoginInput;
}>;


export type StaffLoginMutation = { __typename?: 'Mutation', staffLogin: { __typename?: 'StaffLoginPayload', id: string, name: string, email: string, token: string } };

export type UpdateStaffMutationVariables = Exact<{
  data: StaffUpdateInput;
  where: StaffWhereUniqueInput;
}>;


export type UpdateStaffMutation = { __typename?: 'Mutation', updateStaff?: { __typename?: 'Staff', id: string } | null };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadFileMutation = { __typename?: 'Mutation', uploadFile: any };


export const DeleteManyBasketItemDocument = gql`
    mutation DeleteManyBasketItem($where: BasketItemWhereInput) {
  deleteManyBasketItem(where: $where) {
    count
  }
}
    `;
export type DeleteManyBasketItemMutationFn = Apollo.MutationFunction<DeleteManyBasketItemMutation, DeleteManyBasketItemMutationVariables>;

/**
 * __useDeleteManyBasketItemMutation__
 *
 * To run a mutation, you first call `useDeleteManyBasketItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyBasketItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyBasketItemMutation, { data, loading, error }] = useDeleteManyBasketItemMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteManyBasketItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManyBasketItemMutation, DeleteManyBasketItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManyBasketItemMutation, DeleteManyBasketItemMutationVariables>(DeleteManyBasketItemDocument, options);
      }
export type DeleteManyBasketItemMutationHookResult = ReturnType<typeof useDeleteManyBasketItemMutation>;
export type DeleteManyBasketItemMutationResult = Apollo.MutationResult<DeleteManyBasketItemMutation>;
export type DeleteManyBasketItemMutationOptions = Apollo.BaseMutationOptions<DeleteManyBasketItemMutation, DeleteManyBasketItemMutationVariables>;
export const CategoriesDocument = gql`
    query Categories($where: CategoryWhereInput, $orderBy: [CategoryOrderByWithRelationInput!], $take: Int, $skip: Int) {
  categories(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    brand
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
    _count {
      subCategories
    }
    photos
    discountAmount
    status
    parentCategoryId
    parentCategory {
      descriptions {
        title
        language
      }
    }
  }
}
    `;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a React component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
      }
export function useCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriesQuery, CategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, options);
        }
export type CategoriesQueryHookResult = ReturnType<typeof useCategoriesQuery>;
export type CategoriesLazyQueryHookResult = ReturnType<typeof useCategoriesLazyQuery>;
export type CategoriesQueryResult = Apollo.QueryResult<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryDocument = gql`
    query Category($where: CategoryWhereUniqueInput!) {
  category(where: $where) {
    id
    createdAt
    brand
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
    photos
    parentCategoryId
    discountAmount
    status
  }
}
    `;

/**
 * __useCategoryQuery__
 *
 * To run a query within a React component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCategoryQuery(baseOptions: Apollo.QueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
      }
export function useCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryQuery, CategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, options);
        }
export type CategoryQueryHookResult = ReturnType<typeof useCategoryQuery>;
export type CategoryLazyQueryHookResult = ReturnType<typeof useCategoryLazyQuery>;
export type CategoryQueryResult = Apollo.QueryResult<CategoryQuery, CategoryQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($data: CategoryCreateInput!) {
  createCategory(data: $data) {
    id
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const DeleteCategoryDocument = gql`
    mutation DeleteCategory($where: CategoryWhereUniqueInput!) {
  deleteCategory(where: $where) {
    id
  }
}
    `;
export type DeleteCategoryMutationFn = Apollo.MutationFunction<DeleteCategoryMutation, DeleteCategoryMutationVariables>;

/**
 * __useDeleteCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCategoryMutation, { data, loading, error }] = useDeleteCategoryMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCategoryMutation, DeleteCategoryMutationVariables>(DeleteCategoryDocument, options);
      }
export type DeleteCategoryMutationHookResult = ReturnType<typeof useDeleteCategoryMutation>;
export type DeleteCategoryMutationResult = Apollo.MutationResult<DeleteCategoryMutation>;
export type DeleteCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteCategoryMutation, DeleteCategoryMutationVariables>;
export const MakeCategoryDiscountDocument = gql`
    mutation MakeCategoryDiscount($where: CategoryWhereUniqueInput!, $discountAmount: Float!) {
  makeCategoryDiscount(where: $where, discountAmount: $discountAmount)
}
    `;
export type MakeCategoryDiscountMutationFn = Apollo.MutationFunction<MakeCategoryDiscountMutation, MakeCategoryDiscountMutationVariables>;

/**
 * __useMakeCategoryDiscountMutation__
 *
 * To run a mutation, you first call `useMakeCategoryDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCategoryDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCategoryDiscountMutation, { data, loading, error }] = useMakeCategoryDiscountMutation({
 *   variables: {
 *      where: // value for 'where'
 *      discountAmount: // value for 'discountAmount'
 *   },
 * });
 */
export function useMakeCategoryDiscountMutation(baseOptions?: Apollo.MutationHookOptions<MakeCategoryDiscountMutation, MakeCategoryDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCategoryDiscountMutation, MakeCategoryDiscountMutationVariables>(MakeCategoryDiscountDocument, options);
      }
export type MakeCategoryDiscountMutationHookResult = ReturnType<typeof useMakeCategoryDiscountMutation>;
export type MakeCategoryDiscountMutationResult = Apollo.MutationResult<MakeCategoryDiscountMutation>;
export type MakeCategoryDiscountMutationOptions = Apollo.BaseMutationOptions<MakeCategoryDiscountMutation, MakeCategoryDiscountMutationVariables>;
export const OrderCategoryDocument = gql`
    mutation orderCategory($id: String!, $order: Int!) {
  updateCategory(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderCategoryMutationFn = Apollo.MutationFunction<OrderCategoryMutation, OrderCategoryMutationVariables>;

/**
 * __useOrderCategoryMutation__
 *
 * To run a mutation, you first call `useOrderCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCategoryMutation, { data, loading, error }] = useOrderCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderCategoryMutation(baseOptions?: Apollo.MutationHookOptions<OrderCategoryMutation, OrderCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCategoryMutation, OrderCategoryMutationVariables>(OrderCategoryDocument, options);
      }
export type OrderCategoryMutationHookResult = ReturnType<typeof useOrderCategoryMutation>;
export type OrderCategoryMutationResult = Apollo.MutationResult<OrderCategoryMutation>;
export type OrderCategoryMutationOptions = Apollo.BaseMutationOptions<OrderCategoryMutation, OrderCategoryMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($data: CategoryUpdateInput!, $where: CategoryWhereUniqueInput!) {
  updateCategory(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateCategoryMutationFn = Apollo.MutationFunction<UpdateCategoryMutation, UpdateCategoryMutationVariables>;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCategoryMutation, { data, loading, error }] = useUpdateCategoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
      }
export type UpdateCategoryMutationHookResult = ReturnType<typeof useUpdateCategoryMutation>;
export type UpdateCategoryMutationResult = Apollo.MutationResult<UpdateCategoryMutation>;
export type UpdateCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const CollectionDocument = gql`
    query Collection($where: CollectionWhereUniqueInput!) {
  collection(where: $where) {
    id
    createdAt
    photos
    status
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useCollectionQuery__
 *
 * To run a query within a React component, call `useCollectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCollectionQuery(baseOptions: Apollo.QueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
      }
export function useCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionQuery, CollectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionQuery, CollectionQueryVariables>(CollectionDocument, options);
        }
export type CollectionQueryHookResult = ReturnType<typeof useCollectionQuery>;
export type CollectionLazyQueryHookResult = ReturnType<typeof useCollectionLazyQuery>;
export type CollectionQueryResult = Apollo.QueryResult<CollectionQuery, CollectionQueryVariables>;
export const CollectionsDocument = gql`
    query Collections($where: CollectionWhereInput, $orderBy: [CollectionOrderByWithRelationInput!], $take: Int, $skip: Int) {
  collections(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    photos
    status
    order
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useCollectionsQuery__
 *
 * To run a query within a React component, call `useCollectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCollectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCollectionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCollectionsQuery(baseOptions?: Apollo.QueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
      }
export function useCollectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CollectionsQuery, CollectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument, options);
        }
export type CollectionsQueryHookResult = ReturnType<typeof useCollectionsQuery>;
export type CollectionsLazyQueryHookResult = ReturnType<typeof useCollectionsLazyQuery>;
export type CollectionsQueryResult = Apollo.QueryResult<CollectionsQuery, CollectionsQueryVariables>;
export const CreateCollectionDocument = gql`
    mutation CreateCollection($data: CollectionCreateInput!) {
  createCollection(data: $data) {
    id
  }
}
    `;
export type CreateCollectionMutationFn = Apollo.MutationFunction<CreateCollectionMutation, CreateCollectionMutationVariables>;

/**
 * __useCreateCollectionMutation__
 *
 * To run a mutation, you first call `useCreateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCollectionMutation, { data, loading, error }] = useCreateCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCollectionMutation, CreateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCollectionMutation, CreateCollectionMutationVariables>(CreateCollectionDocument, options);
      }
export type CreateCollectionMutationHookResult = ReturnType<typeof useCreateCollectionMutation>;
export type CreateCollectionMutationResult = Apollo.MutationResult<CreateCollectionMutation>;
export type CreateCollectionMutationOptions = Apollo.BaseMutationOptions<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const DeleteCollectionDocument = gql`
    mutation DeleteCollection($where: CollectionWhereUniqueInput!) {
  deleteCollection(where: $where) {
    id
  }
}
    `;
export type DeleteCollectionMutationFn = Apollo.MutationFunction<DeleteCollectionMutation, DeleteCollectionMutationVariables>;

/**
 * __useDeleteCollectionMutation__
 *
 * To run a mutation, you first call `useDeleteCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCollectionMutation, { data, loading, error }] = useDeleteCollectionMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCollectionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCollectionMutation, DeleteCollectionMutationVariables>(DeleteCollectionDocument, options);
      }
export type DeleteCollectionMutationHookResult = ReturnType<typeof useDeleteCollectionMutation>;
export type DeleteCollectionMutationResult = Apollo.MutationResult<DeleteCollectionMutation>;
export type DeleteCollectionMutationOptions = Apollo.BaseMutationOptions<DeleteCollectionMutation, DeleteCollectionMutationVariables>;
export const OrderCollectionDocument = gql`
    mutation orderCollection($id: String!, $order: Int!) {
  updateCollection(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderCollectionMutationFn = Apollo.MutationFunction<OrderCollectionMutation, OrderCollectionMutationVariables>;

/**
 * __useOrderCollectionMutation__
 *
 * To run a mutation, you first call `useOrderCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCollectionMutation, { data, loading, error }] = useOrderCollectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderCollectionMutation(baseOptions?: Apollo.MutationHookOptions<OrderCollectionMutation, OrderCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCollectionMutation, OrderCollectionMutationVariables>(OrderCollectionDocument, options);
      }
export type OrderCollectionMutationHookResult = ReturnType<typeof useOrderCollectionMutation>;
export type OrderCollectionMutationResult = Apollo.MutationResult<OrderCollectionMutation>;
export type OrderCollectionMutationOptions = Apollo.BaseMutationOptions<OrderCollectionMutation, OrderCollectionMutationVariables>;
export const UpdateCollectionDocument = gql`
    mutation UpdateCollection($data: CollectionUpdateInput!, $where: CollectionWhereUniqueInput!) {
  updateCollection(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateCollectionMutationFn = Apollo.MutationFunction<UpdateCollectionMutation, UpdateCollectionMutationVariables>;

/**
 * __useUpdateCollectionMutation__
 *
 * To run a mutation, you first call `useUpdateCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCollectionMutation, { data, loading, error }] = useUpdateCollectionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCollectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCollectionMutation, UpdateCollectionMutationVariables>(UpdateCollectionDocument, options);
      }
export type UpdateCollectionMutationHookResult = ReturnType<typeof useUpdateCollectionMutation>;
export type UpdateCollectionMutationResult = Apollo.MutationResult<UpdateCollectionMutation>;
export type UpdateCollectionMutationOptions = Apollo.BaseMutationOptions<UpdateCollectionMutation, UpdateCollectionMutationVariables>;
export const ColorDocument = gql`
    query Color($where: ColorWhereUniqueInput!) {
  color(where: $where) {
    id
    createdAt
    code
    order
  }
}
    `;

/**
 * __useColorQuery__
 *
 * To run a query within a React component, call `useColorQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useColorQuery(baseOptions: Apollo.QueryHookOptions<ColorQuery, ColorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorQuery, ColorQueryVariables>(ColorDocument, options);
      }
export function useColorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorQuery, ColorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorQuery, ColorQueryVariables>(ColorDocument, options);
        }
export type ColorQueryHookResult = ReturnType<typeof useColorQuery>;
export type ColorLazyQueryHookResult = ReturnType<typeof useColorLazyQuery>;
export type ColorQueryResult = Apollo.QueryResult<ColorQuery, ColorQueryVariables>;
export const ColorsDocument = gql`
    query Colors($where: ColorWhereInput, $orderBy: [ColorOrderByWithRelationInput!], $take: Int, $skip: Int) {
  colors(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    code
    order
    status
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useColorsQuery__
 *
 * To run a query within a React component, call `useColorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useColorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useColorsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useColorsQuery(baseOptions?: Apollo.QueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
      }
export function useColorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ColorsQuery, ColorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ColorsQuery, ColorsQueryVariables>(ColorsDocument, options);
        }
export type ColorsQueryHookResult = ReturnType<typeof useColorsQuery>;
export type ColorsLazyQueryHookResult = ReturnType<typeof useColorsLazyQuery>;
export type ColorsQueryResult = Apollo.QueryResult<ColorsQuery, ColorsQueryVariables>;
export const CreateColorDocument = gql`
    mutation CreateColor($data: ColorCreateInput!) {
  createColor(data: $data) {
    id
  }
}
    `;
export type CreateColorMutationFn = Apollo.MutationFunction<CreateColorMutation, CreateColorMutationVariables>;

/**
 * __useCreateColorMutation__
 *
 * To run a mutation, you first call `useCreateColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createColorMutation, { data, loading, error }] = useCreateColorMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateColorMutation(baseOptions?: Apollo.MutationHookOptions<CreateColorMutation, CreateColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateColorMutation, CreateColorMutationVariables>(CreateColorDocument, options);
      }
export type CreateColorMutationHookResult = ReturnType<typeof useCreateColorMutation>;
export type CreateColorMutationResult = Apollo.MutationResult<CreateColorMutation>;
export type CreateColorMutationOptions = Apollo.BaseMutationOptions<CreateColorMutation, CreateColorMutationVariables>;
export const DeleteColorDocument = gql`
    mutation DeleteColor($where: ColorWhereUniqueInput!) {
  deleteColor(where: $where) {
    id
  }
}
    `;
export type DeleteColorMutationFn = Apollo.MutationFunction<DeleteColorMutation, DeleteColorMutationVariables>;

/**
 * __useDeleteColorMutation__
 *
 * To run a mutation, you first call `useDeleteColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteColorMutation, { data, loading, error }] = useDeleteColorMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteColorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteColorMutation, DeleteColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteColorMutation, DeleteColorMutationVariables>(DeleteColorDocument, options);
      }
export type DeleteColorMutationHookResult = ReturnType<typeof useDeleteColorMutation>;
export type DeleteColorMutationResult = Apollo.MutationResult<DeleteColorMutation>;
export type DeleteColorMutationOptions = Apollo.BaseMutationOptions<DeleteColorMutation, DeleteColorMutationVariables>;
export const OrderColorDocument = gql`
    mutation orderColor($id: String!, $order: Int!) {
  updateColor(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderColorMutationFn = Apollo.MutationFunction<OrderColorMutation, OrderColorMutationVariables>;

/**
 * __useOrderColorMutation__
 *
 * To run a mutation, you first call `useOrderColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderColorMutation, { data, loading, error }] = useOrderColorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderColorMutation(baseOptions?: Apollo.MutationHookOptions<OrderColorMutation, OrderColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderColorMutation, OrderColorMutationVariables>(OrderColorDocument, options);
      }
export type OrderColorMutationHookResult = ReturnType<typeof useOrderColorMutation>;
export type OrderColorMutationResult = Apollo.MutationResult<OrderColorMutation>;
export type OrderColorMutationOptions = Apollo.BaseMutationOptions<OrderColorMutation, OrderColorMutationVariables>;
export const UpdateColorDocument = gql`
    mutation UpdateColor($data: ColorUpdateInput!, $where: ColorWhereUniqueInput!) {
  updateColor(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateColorMutationFn = Apollo.MutationFunction<UpdateColorMutation, UpdateColorMutationVariables>;

/**
 * __useUpdateColorMutation__
 *
 * To run a mutation, you first call `useUpdateColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColorMutation, { data, loading, error }] = useUpdateColorMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColorMutation, UpdateColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColorMutation, UpdateColorMutationVariables>(UpdateColorDocument, options);
      }
export type UpdateColorMutationHookResult = ReturnType<typeof useUpdateColorMutation>;
export type UpdateColorMutationResult = Apollo.MutationResult<UpdateColorMutation>;
export type UpdateColorMutationOptions = Apollo.BaseMutationOptions<UpdateColorMutation, UpdateColorMutationVariables>;
export const ContentDocument = gql`
    query Content($where: ContentWhereUniqueInput!) {
  content(where: $where) {
    id
    contentType
    mediaType
    photos
    video
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useContentQuery__
 *
 * To run a query within a React component, call `useContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useContentQuery(baseOptions: Apollo.QueryHookOptions<ContentQuery, ContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
      }
export function useContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentQuery, ContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentQuery, ContentQueryVariables>(ContentDocument, options);
        }
export type ContentQueryHookResult = ReturnType<typeof useContentQuery>;
export type ContentLazyQueryHookResult = ReturnType<typeof useContentLazyQuery>;
export type ContentQueryResult = Apollo.QueryResult<ContentQuery, ContentQueryVariables>;
export const ContentsDocument = gql`
    query Contents($where: ContentWhereInput, $orderBy: [ContentOrderByWithRelationInput!], $take: Int, $skip: Int) {
  contents(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    contentType
    mediaType
    photos
    video
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useContentsQuery__
 *
 * To run a query within a React component, call `useContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useContentsQuery(baseOptions?: Apollo.QueryHookOptions<ContentsQuery, ContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentsQuery, ContentsQueryVariables>(ContentsDocument, options);
      }
export function useContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentsQuery, ContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentsQuery, ContentsQueryVariables>(ContentsDocument, options);
        }
export type ContentsQueryHookResult = ReturnType<typeof useContentsQuery>;
export type ContentsLazyQueryHookResult = ReturnType<typeof useContentsLazyQuery>;
export type ContentsQueryResult = Apollo.QueryResult<ContentsQuery, ContentsQueryVariables>;
export const CreateContentDocument = gql`
    mutation CreateContent($data: ContentCreateInput!) {
  createContent(data: $data) {
    id
  }
}
    `;
export type CreateContentMutationFn = Apollo.MutationFunction<CreateContentMutation, CreateContentMutationVariables>;

/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentMutation, CreateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentMutation, CreateContentMutationVariables>(CreateContentDocument, options);
      }
export type CreateContentMutationHookResult = ReturnType<typeof useCreateContentMutation>;
export type CreateContentMutationResult = Apollo.MutationResult<CreateContentMutation>;
export type CreateContentMutationOptions = Apollo.BaseMutationOptions<CreateContentMutation, CreateContentMutationVariables>;
export const DeleteContentDocument = gql`
    mutation DeleteContent($where: ContentWhereUniqueInput!) {
  deleteContent(where: $where) {
    id
  }
}
    `;
export type DeleteContentMutationFn = Apollo.MutationFunction<DeleteContentMutation, DeleteContentMutationVariables>;

/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContentMutation, DeleteContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContentMutation, DeleteContentMutationVariables>(DeleteContentDocument, options);
      }
export type DeleteContentMutationHookResult = ReturnType<typeof useDeleteContentMutation>;
export type DeleteContentMutationResult = Apollo.MutationResult<DeleteContentMutation>;
export type DeleteContentMutationOptions = Apollo.BaseMutationOptions<DeleteContentMutation, DeleteContentMutationVariables>;
export const OrderContentDocument = gql`
    mutation orderContent($id: String!, $order: Int!) {
  updateContent(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderContentMutationFn = Apollo.MutationFunction<OrderContentMutation, OrderContentMutationVariables>;

/**
 * __useOrderContentMutation__
 *
 * To run a mutation, you first call `useOrderContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderContentMutation, { data, loading, error }] = useOrderContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderContentMutation(baseOptions?: Apollo.MutationHookOptions<OrderContentMutation, OrderContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderContentMutation, OrderContentMutationVariables>(OrderContentDocument, options);
      }
export type OrderContentMutationHookResult = ReturnType<typeof useOrderContentMutation>;
export type OrderContentMutationResult = Apollo.MutationResult<OrderContentMutation>;
export type OrderContentMutationOptions = Apollo.BaseMutationOptions<OrderContentMutation, OrderContentMutationVariables>;
export const UpdateContentDocument = gql`
    mutation UpdateContent($data: ContentUpdateInput!, $where: ContentWhereUniqueInput!) {
  updateContent(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateContentMutationFn = Apollo.MutationFunction<UpdateContentMutation, UpdateContentMutationVariables>;

/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentMutation, UpdateContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentMutation, UpdateContentMutationVariables>(UpdateContentDocument, options);
      }
export type UpdateContentMutationHookResult = ReturnType<typeof useUpdateContentMutation>;
export type UpdateContentMutationResult = Apollo.MutationResult<UpdateContentMutation>;
export type UpdateContentMutationOptions = Apollo.BaseMutationOptions<UpdateContentMutation, UpdateContentMutationVariables>;
export const CreateCurrencyDocument = gql`
    mutation CreateCurrency($data: CurrencyCreateInput!) {
  createCurrency(data: $data) {
    id
  }
}
    `;
export type CreateCurrencyMutationFn = Apollo.MutationFunction<CreateCurrencyMutation, CreateCurrencyMutationVariables>;

/**
 * __useCreateCurrencyMutation__
 *
 * To run a mutation, you first call `useCreateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCurrencyMutation, { data, loading, error }] = useCreateCurrencyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCurrencyMutation, CreateCurrencyMutationVariables>(CreateCurrencyDocument, options);
      }
export type CreateCurrencyMutationHookResult = ReturnType<typeof useCreateCurrencyMutation>;
export type CreateCurrencyMutationResult = Apollo.MutationResult<CreateCurrencyMutation>;
export type CreateCurrencyMutationOptions = Apollo.BaseMutationOptions<CreateCurrencyMutation, CreateCurrencyMutationVariables>;
export const CurrenciesDocument = gql`
    query Currencies($where: CurrencyWhereInput, $orderBy: [CurrencyOrderByWithRelationInput!], $take: Int, $skip: Int) {
  currencies(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    status
    order
    code
    prefix
    suffix
    buy
    sell
    isDefault
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useCurrenciesQuery__
 *
 * To run a query within a React component, call `useCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
      }
export function useCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesQuery, CurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesQuery, CurrenciesQueryVariables>(CurrenciesDocument, options);
        }
export type CurrenciesQueryHookResult = ReturnType<typeof useCurrenciesQuery>;
export type CurrenciesLazyQueryHookResult = ReturnType<typeof useCurrenciesLazyQuery>;
export type CurrenciesQueryResult = Apollo.QueryResult<CurrenciesQuery, CurrenciesQueryVariables>;
export const CurrencyDocument = gql`
    query Currency($where: CurrencyWhereUniqueInput!) {
  currency(where: $where) {
    id
    status
    order
    code
    prefix
    suffix
    buy
    sell
    isDefault
    autoUpdate
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useCurrencyQuery__
 *
 * To run a query within a React component, call `useCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCurrencyQuery(baseOptions: Apollo.QueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
      }
export function useCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyQuery, CurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyQuery, CurrencyQueryVariables>(CurrencyDocument, options);
        }
export type CurrencyQueryHookResult = ReturnType<typeof useCurrencyQuery>;
export type CurrencyLazyQueryHookResult = ReturnType<typeof useCurrencyLazyQuery>;
export type CurrencyQueryResult = Apollo.QueryResult<CurrencyQuery, CurrencyQueryVariables>;
export const DeleteCurrencyDocument = gql`
    mutation deleteCurrency($where: CurrencyWhereUniqueInput!) {
  deleteCurrency(where: $where) {
    id
  }
}
    `;
export type DeleteCurrencyMutationFn = Apollo.MutationFunction<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;

/**
 * __useDeleteCurrencyMutation__
 *
 * To run a mutation, you first call `useDeleteCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCurrencyMutation, { data, loading, error }] = useDeleteCurrencyMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>(DeleteCurrencyDocument, options);
      }
export type DeleteCurrencyMutationHookResult = ReturnType<typeof useDeleteCurrencyMutation>;
export type DeleteCurrencyMutationResult = Apollo.MutationResult<DeleteCurrencyMutation>;
export type DeleteCurrencyMutationOptions = Apollo.BaseMutationOptions<DeleteCurrencyMutation, DeleteCurrencyMutationVariables>;
export const OrderCurrencyDocument = gql`
    mutation orderCurrency($id: String!, $order: Int!) {
  updateCurrency(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderCurrencyMutationFn = Apollo.MutationFunction<OrderCurrencyMutation, OrderCurrencyMutationVariables>;

/**
 * __useOrderCurrencyMutation__
 *
 * To run a mutation, you first call `useOrderCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCurrencyMutation, { data, loading, error }] = useOrderCurrencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<OrderCurrencyMutation, OrderCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderCurrencyMutation, OrderCurrencyMutationVariables>(OrderCurrencyDocument, options);
      }
export type OrderCurrencyMutationHookResult = ReturnType<typeof useOrderCurrencyMutation>;
export type OrderCurrencyMutationResult = Apollo.MutationResult<OrderCurrencyMutation>;
export type OrderCurrencyMutationOptions = Apollo.BaseMutationOptions<OrderCurrencyMutation, OrderCurrencyMutationVariables>;
export const UpdateCurrencyDocument = gql`
    mutation UpdateCurrency($data: CurrencyUpdateInput!, $where: CurrencyWhereUniqueInput!) {
  updateCurrency(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateCurrencyMutationFn = Apollo.MutationFunction<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;

/**
 * __useUpdateCurrencyMutation__
 *
 * To run a mutation, you first call `useUpdateCurrencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrencyMutation, { data, loading, error }] = useUpdateCurrencyMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCurrencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>(UpdateCurrencyDocument, options);
      }
export type UpdateCurrencyMutationHookResult = ReturnType<typeof useUpdateCurrencyMutation>;
export type UpdateCurrencyMutationResult = Apollo.MutationResult<UpdateCurrencyMutation>;
export type UpdateCurrencyMutationOptions = Apollo.BaseMutationOptions<UpdateCurrencyMutation, UpdateCurrencyMutationVariables>;
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($data: CustomerCreateInput!) {
  createCustomer(data: $data) {
    id
  }
}
    `;
export type CreateCustomerMutationFn = Apollo.MutationFunction<CreateCustomerMutation, CreateCustomerMutationVariables>;

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerMutation, CreateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument, options);
      }
export type CreateCustomerMutationHookResult = ReturnType<typeof useCreateCustomerMutation>;
export type CreateCustomerMutationResult = Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const CustomerDocument = gql`
    query Customer($where: CustomerWhereUniqueInput!) {
  customer(where: $where) {
    id
    createdAt
    name
    surname
    email
    phoneNumber
    phoneActivated
    emailActivated
    addresses {
      id
      title
      city
      postalCode
      state
      addressLineOne
      addressLineTwo
    }
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;
export const CustomersDocument = gql`
    query Customers($where: CustomerWhereInput, $orderBy: [CustomerOrderByWithRelationInput!], $take: Int, $skip: Int) {
  customers(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    count
    items {
      id
      createdAt
      name
      surname
      email
      emailActivated
      phoneNumber
      phoneActivated
      _count {
        orders
      }
    }
  }
}
    `;

/**
 * __useCustomersQuery__
 *
 * To run a query within a React component, call `useCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useCustomersQuery(baseOptions?: Apollo.QueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
      }
export function useCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomersQuery, CustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomersQuery, CustomersQueryVariables>(CustomersDocument, options);
        }
export type CustomersQueryHookResult = ReturnType<typeof useCustomersQuery>;
export type CustomersLazyQueryHookResult = ReturnType<typeof useCustomersLazyQuery>;
export type CustomersQueryResult = Apollo.QueryResult<CustomersQuery, CustomersQueryVariables>;
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($where: CustomerWhereUniqueInput!) {
  deleteCustomer(where: $where) {
    id
  }
}
    `;
export type DeleteCustomerMutationFn = Apollo.MutationFunction<DeleteCustomerMutation, DeleteCustomerMutationVariables>;

/**
 * __useDeleteCustomerMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerMutation, { data, loading, error }] = useDeleteCustomerMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteCustomerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerMutation, DeleteCustomerMutationVariables>(DeleteCustomerDocument, options);
      }
export type DeleteCustomerMutationHookResult = ReturnType<typeof useDeleteCustomerMutation>;
export type DeleteCustomerMutationResult = Apollo.MutationResult<DeleteCustomerMutation>;
export type DeleteCustomerMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerMutation, DeleteCustomerMutationVariables>;
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($data: CustomerUpdateInput!, $where: CustomerWhereUniqueInput!) {
  updateCustomer(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<UpdateCustomerMutation, UpdateCustomerMutationVariables>;

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateCustomerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument, options);
      }
export type UpdateCustomerMutationHookResult = ReturnType<typeof useUpdateCustomerMutation>;
export type UpdateCustomerMutationResult = Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const DashboardStatisticsDocument = gql`
    query DashboardStatistics {
  dashboardStatistics {
    todayOrderCount
    weeklyOrderCount
    todayEarnings
    weeklyEarnings
    last4Products {
      id
      photos
      descriptions {
        id
        title
        description
        slug
        headline
        buttonText
        buttonUrl
        language
      }
    }
    pendingOrders {
      id
      identityNumber
      conversationId
      paymentFirstName
      paymentLastName
      shippingFirstName
      shippingLastName
      isCompleted
      orderStatus
      createdAt
      customer {
        id
        name
        surname
      }
      payment {
        id
        price
        paidPrice
        discount
        installment
      }
      _count {
        products
      }
    }
  }
}
    `;

/**
 * __useDashboardStatisticsQuery__
 *
 * To run a query within a React component, call `useDashboardStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>(DashboardStatisticsDocument, options);
      }
export function useDashboardStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>(DashboardStatisticsDocument, options);
        }
export type DashboardStatisticsQueryHookResult = ReturnType<typeof useDashboardStatisticsQuery>;
export type DashboardStatisticsLazyQueryHookResult = ReturnType<typeof useDashboardStatisticsLazyQuery>;
export type DashboardStatisticsQueryResult = Apollo.QueryResult<DashboardStatisticsQuery, DashboardStatisticsQueryVariables>;
export const CreateDescriptionDocument = gql`
    mutation CreateDescription($data: DescriptionCreateInput!) {
  createDescription(data: $data) {
    id
  }
}
    `;
export type CreateDescriptionMutationFn = Apollo.MutationFunction<CreateDescriptionMutation, CreateDescriptionMutationVariables>;

/**
 * __useCreateDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDescriptionMutation, { data, loading, error }] = useCreateDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateDescriptionMutation, CreateDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDescriptionMutation, CreateDescriptionMutationVariables>(CreateDescriptionDocument, options);
      }
export type CreateDescriptionMutationHookResult = ReturnType<typeof useCreateDescriptionMutation>;
export type CreateDescriptionMutationResult = Apollo.MutationResult<CreateDescriptionMutation>;
export type CreateDescriptionMutationOptions = Apollo.BaseMutationOptions<CreateDescriptionMutation, CreateDescriptionMutationVariables>;
export const DeleteDescriptionDocument = gql`
    mutation DeleteDescription($where: DescriptionWhereUniqueInput!) {
  deleteDescription(where: $where) {
    id
  }
}
    `;
export type DeleteDescriptionMutationFn = Apollo.MutationFunction<DeleteDescriptionMutation, DeleteDescriptionMutationVariables>;

/**
 * __useDeleteDescriptionMutation__
 *
 * To run a mutation, you first call `useDeleteDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDescriptionMutation, { data, loading, error }] = useDeleteDescriptionMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDescriptionMutation, DeleteDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDescriptionMutation, DeleteDescriptionMutationVariables>(DeleteDescriptionDocument, options);
      }
export type DeleteDescriptionMutationHookResult = ReturnType<typeof useDeleteDescriptionMutation>;
export type DeleteDescriptionMutationResult = Apollo.MutationResult<DeleteDescriptionMutation>;
export type DeleteDescriptionMutationOptions = Apollo.BaseMutationOptions<DeleteDescriptionMutation, DeleteDescriptionMutationVariables>;
export const DescriptionDocument = gql`
    query Description($where: DescriptionWhereUniqueInput!) {
  description(where: $where) {
    id
    title
    slug
    description
    headline
    buttonText
    buttonUrl
    language
  }
}
    `;

/**
 * __useDescriptionQuery__
 *
 * To run a query within a React component, call `useDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDescriptionQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDescriptionQuery(baseOptions: Apollo.QueryHookOptions<DescriptionQuery, DescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DescriptionQuery, DescriptionQueryVariables>(DescriptionDocument, options);
      }
export function useDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DescriptionQuery, DescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DescriptionQuery, DescriptionQueryVariables>(DescriptionDocument, options);
        }
export type DescriptionQueryHookResult = ReturnType<typeof useDescriptionQuery>;
export type DescriptionLazyQueryHookResult = ReturnType<typeof useDescriptionLazyQuery>;
export type DescriptionQueryResult = Apollo.QueryResult<DescriptionQuery, DescriptionQueryVariables>;
export const UpdateDescriptionDocument = gql`
    mutation UpdateDescription($data: DescriptionUpdateInput!, $where: DescriptionWhereUniqueInput!) {
  updateDescription(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateDescriptionMutationFn = Apollo.MutationFunction<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;

/**
 * __useUpdateDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDescriptionMutation, { data, loading, error }] = useUpdateDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>(UpdateDescriptionDocument, options);
      }
export type UpdateDescriptionMutationHookResult = ReturnType<typeof useUpdateDescriptionMutation>;
export type UpdateDescriptionMutationResult = Apollo.MutationResult<UpdateDescriptionMutation>;
export type UpdateDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateDescriptionMutation, UpdateDescriptionMutationVariables>;
export const CreateDiscountCouponDocument = gql`
    mutation CreateDiscountCoupon($data: DiscountCouponCreateInput!) {
  createDiscountCoupon(data: $data) {
    id
  }
}
    `;
export type CreateDiscountCouponMutationFn = Apollo.MutationFunction<CreateDiscountCouponMutation, CreateDiscountCouponMutationVariables>;

/**
 * __useCreateDiscountCouponMutation__
 *
 * To run a mutation, you first call `useCreateDiscountCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDiscountCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDiscountCouponMutation, { data, loading, error }] = useCreateDiscountCouponMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateDiscountCouponMutation(baseOptions?: Apollo.MutationHookOptions<CreateDiscountCouponMutation, CreateDiscountCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDiscountCouponMutation, CreateDiscountCouponMutationVariables>(CreateDiscountCouponDocument, options);
      }
export type CreateDiscountCouponMutationHookResult = ReturnType<typeof useCreateDiscountCouponMutation>;
export type CreateDiscountCouponMutationResult = Apollo.MutationResult<CreateDiscountCouponMutation>;
export type CreateDiscountCouponMutationOptions = Apollo.BaseMutationOptions<CreateDiscountCouponMutation, CreateDiscountCouponMutationVariables>;
export const DeleteDiscountCouponDocument = gql`
    mutation DeleteDiscountCoupon($where: DiscountCouponWhereUniqueInput!) {
  deleteDiscountCoupon(where: $where) {
    id
  }
}
    `;
export type DeleteDiscountCouponMutationFn = Apollo.MutationFunction<DeleteDiscountCouponMutation, DeleteDiscountCouponMutationVariables>;

/**
 * __useDeleteDiscountCouponMutation__
 *
 * To run a mutation, you first call `useDeleteDiscountCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscountCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscountCouponMutation, { data, loading, error }] = useDeleteDiscountCouponMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteDiscountCouponMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDiscountCouponMutation, DeleteDiscountCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDiscountCouponMutation, DeleteDiscountCouponMutationVariables>(DeleteDiscountCouponDocument, options);
      }
export type DeleteDiscountCouponMutationHookResult = ReturnType<typeof useDeleteDiscountCouponMutation>;
export type DeleteDiscountCouponMutationResult = Apollo.MutationResult<DeleteDiscountCouponMutation>;
export type DeleteDiscountCouponMutationOptions = Apollo.BaseMutationOptions<DeleteDiscountCouponMutation, DeleteDiscountCouponMutationVariables>;
export const DiscountCouponDocument = gql`
    query DiscountCoupon($where: DiscountCouponWhereUniqueInput!) {
  discountCoupon(where: $where) {
    id
    createdAt
    isPercentage
    code
    amount
    validUntil
    status
    image
    customerId
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useDiscountCouponQuery__
 *
 * To run a query within a React component, call `useDiscountCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCouponQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDiscountCouponQuery(baseOptions: Apollo.QueryHookOptions<DiscountCouponQuery, DiscountCouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCouponQuery, DiscountCouponQueryVariables>(DiscountCouponDocument, options);
      }
export function useDiscountCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCouponQuery, DiscountCouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCouponQuery, DiscountCouponQueryVariables>(DiscountCouponDocument, options);
        }
export type DiscountCouponQueryHookResult = ReturnType<typeof useDiscountCouponQuery>;
export type DiscountCouponLazyQueryHookResult = ReturnType<typeof useDiscountCouponLazyQuery>;
export type DiscountCouponQueryResult = Apollo.QueryResult<DiscountCouponQuery, DiscountCouponQueryVariables>;
export const DiscountCouponsDocument = gql`
    query DiscountCoupons($where: DiscountCouponWhereInput, $orderBy: [DiscountCouponOrderByWithRelationInput!], $take: Int, $skip: Int) {
  discountCoupons(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    isPercentage
    code
    amount
    validUntil
    status
    image
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useDiscountCouponsQuery__
 *
 * To run a query within a React component, call `useDiscountCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscountCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscountCouponsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useDiscountCouponsQuery(baseOptions?: Apollo.QueryHookOptions<DiscountCouponsQuery, DiscountCouponsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscountCouponsQuery, DiscountCouponsQueryVariables>(DiscountCouponsDocument, options);
      }
export function useDiscountCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscountCouponsQuery, DiscountCouponsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscountCouponsQuery, DiscountCouponsQueryVariables>(DiscountCouponsDocument, options);
        }
export type DiscountCouponsQueryHookResult = ReturnType<typeof useDiscountCouponsQuery>;
export type DiscountCouponsLazyQueryHookResult = ReturnType<typeof useDiscountCouponsLazyQuery>;
export type DiscountCouponsQueryResult = Apollo.QueryResult<DiscountCouponsQuery, DiscountCouponsQueryVariables>;
export const UpdateDiscountCouponDocument = gql`
    mutation UpdateDiscountCoupon($data: DiscountCouponUpdateInput!, $where: DiscountCouponWhereUniqueInput!) {
  updateDiscountCoupon(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateDiscountCouponMutationFn = Apollo.MutationFunction<UpdateDiscountCouponMutation, UpdateDiscountCouponMutationVariables>;

/**
 * __useUpdateDiscountCouponMutation__
 *
 * To run a mutation, you first call `useUpdateDiscountCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDiscountCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDiscountCouponMutation, { data, loading, error }] = useUpdateDiscountCouponMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateDiscountCouponMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDiscountCouponMutation, UpdateDiscountCouponMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDiscountCouponMutation, UpdateDiscountCouponMutationVariables>(UpdateDiscountCouponDocument, options);
      }
export type UpdateDiscountCouponMutationHookResult = ReturnType<typeof useUpdateDiscountCouponMutation>;
export type UpdateDiscountCouponMutationResult = Apollo.MutationResult<UpdateDiscountCouponMutation>;
export type UpdateDiscountCouponMutationOptions = Apollo.BaseMutationOptions<UpdateDiscountCouponMutation, UpdateDiscountCouponMutationVariables>;
export const OrderDocument = gql`
    query Order($where: OrderWhereUniqueInput!) {
  order(where: $where) {
    id
    createdAt
    conversationId
    identityNumber
    paymentFirstName
    paymentLastName
    paymentEmail
    paymentPhoneNumber
    paymentCompany
    paymentTaxNumber
    paymentTaxOffice
    paymentAddress
    paymentPostalCode
    paymentCity
    paymentCountry
    shippingFirstName
    shippingLastName
    shippingEmail
    shippingPhoneNumber
    shippingAddress
    shippingPostalCode
    shippingCity
    shippingCountry
    shippingConvertedPrice
    shippingTitle
    shippingPrice
    shippingNumber
    isShipped
    isCompleted
    invoiceNumber
    agreementSale
    informationSale
    language
    orderStatus
    products {
      id
      createdAt
      price
      convertedPrice
      quantity
      product {
        id
        descriptions {
          id
          title
          description
          slug
          headline
          buttonText
          buttonUrl
          language
        }
      }
      selectedSize {
        id
        size {
          id
          sku
          descriptions {
            id
            title
            description
            slug
            headline
            buttonText
            buttonUrl
            language
          }
        }
      }
    }
    orderHistories {
      id
      createdAt
      title
      description
    }
    discountCoupon {
      id
      createdAt
      code
      amount
    }
    payment {
      id
      createdAt
      status
      errorCode
      errorMessage
      locale
      systemTime
      price
      paidPrice
      merchantCommissionRate
      merchantCommissionRateAmount
      iyziCommissionRateAmount
      iyziCommissionFee
      discount
      installment
      paymentId
      cardType
      binNumber
      cardAssociation
      lastFourDigits
      authCode
      phase
      orderId
    }
    customer {
      id
      createdAt
      name
      surname
      email
      phoneNumber
      identityNumber
    }
  }
}
    `;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrdersDocument = gql`
    query Orders($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!], $take: Int, $skip: Int) {
  orders(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    conversationId
    isShipped
    isCompleted
    orderStatus
    customer {
      id
      name
      surname
    }
    payment {
      id
      price
      paidPrice
      currency {
        id
        code
        prefix
        suffix
      }
    }
  }
}
    `;

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useOrdersQuery(baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
      }
export function useOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(OrdersDocument, options);
        }
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>;
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>;
export type OrdersQueryResult = Apollo.QueryResult<OrdersQuery, OrdersQueryVariables>;
export const UpdateOrderDocument = gql`
    mutation UpdateOrder($data: OrderUpdateInput!, $where: OrderWhereUniqueInput!) {
  updateOrder(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateOrderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
      }
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($data: PageCreateInput!) {
  createPage(data: $data) {
    id
  }
}
    `;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($where: PageWhereUniqueInput!) {
  deletePage(where: $where) {
    id
  }
}
    `;
export type DeletePageMutationFn = Apollo.MutationFunction<DeletePageMutation, DeletePageMutationVariables>;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePageMutation, { data, loading, error }] = useDeletePageMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePageMutation(baseOptions?: Apollo.MutationHookOptions<DeletePageMutation, DeletePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
      }
export type DeletePageMutationHookResult = ReturnType<typeof useDeletePageMutation>;
export type DeletePageMutationResult = Apollo.MutationResult<DeletePageMutation>;
export type DeletePageMutationOptions = Apollo.BaseMutationOptions<DeletePageMutation, DeletePageMutationVariables>;
export const OrderPageDocument = gql`
    mutation orderPage($id: String!, $order: Int!) {
  updatePage(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderPageMutationFn = Apollo.MutationFunction<OrderPageMutation, OrderPageMutationVariables>;

/**
 * __useOrderPageMutation__
 *
 * To run a mutation, you first call `useOrderPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderPageMutation, { data, loading, error }] = useOrderPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderPageMutation(baseOptions?: Apollo.MutationHookOptions<OrderPageMutation, OrderPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderPageMutation, OrderPageMutationVariables>(OrderPageDocument, options);
      }
export type OrderPageMutationHookResult = ReturnType<typeof useOrderPageMutation>;
export type OrderPageMutationResult = Apollo.MutationResult<OrderPageMutation>;
export type OrderPageMutationOptions = Apollo.BaseMutationOptions<OrderPageMutation, OrderPageMutationVariables>;
export const PageDocument = gql`
    query Page($where: PageWhereUniqueInput!, $orderBy: [ContentOrderByWithRelationInput!]) {
  page(where: $where) {
    id
    status
    pageType
    showOnHeader
    showOnFooter
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
    }
    content(orderBy: $orderBy) {
      id
      contentType
      mediaType
      photos
      video
      descriptions {
        id
        title
        description
        slug
        headline
        buttonText
        buttonUrl
      }
    }
  }
}
    `;

/**
 * __usePageQuery__
 *
 * To run a query within a React component, call `usePageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePageQuery(baseOptions: Apollo.QueryHookOptions<PageQuery, PageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageQuery, PageQueryVariables>(PageDocument, options);
      }
export function usePageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageQuery, PageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageQuery, PageQueryVariables>(PageDocument, options);
        }
export type PageQueryHookResult = ReturnType<typeof usePageQuery>;
export type PageLazyQueryHookResult = ReturnType<typeof usePageLazyQuery>;
export type PageQueryResult = Apollo.QueryResult<PageQuery, PageQueryVariables>;
export const PagesDocument = gql`
    query Pages($where: PageWhereInput, $orderBy: [PageOrderByWithRelationInput!], $take: Int, $skip: Int) {
  pages(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    status
    pageType
    showOnHeader
    showOnFooter
    _count {
      content
    }
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __usePagesQuery__
 *
 * To run a query within a React component, call `usePagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePagesQuery(baseOptions?: Apollo.QueryHookOptions<PagesQuery, PagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
      }
export function usePagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagesQuery, PagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagesQuery, PagesQueryVariables>(PagesDocument, options);
        }
export type PagesQueryHookResult = ReturnType<typeof usePagesQuery>;
export type PagesLazyQueryHookResult = ReturnType<typeof usePagesLazyQuery>;
export type PagesQueryResult = Apollo.QueryResult<PagesQuery, PagesQueryVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($data: PageUpdateInput!, $where: PageWhereUniqueInput!) {
  updatePage(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const CreatePriceDocument = gql`
    mutation CreatePrice($data: PriceCreateInput!) {
  createPrice(data: $data) {
    id
  }
}
    `;
export type CreatePriceMutationFn = Apollo.MutationFunction<CreatePriceMutation, CreatePriceMutationVariables>;

/**
 * __useCreatePriceMutation__
 *
 * To run a mutation, you first call `useCreatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPriceMutation, { data, loading, error }] = useCreatePriceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePriceMutation(baseOptions?: Apollo.MutationHookOptions<CreatePriceMutation, CreatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePriceMutation, CreatePriceMutationVariables>(CreatePriceDocument, options);
      }
export type CreatePriceMutationHookResult = ReturnType<typeof useCreatePriceMutation>;
export type CreatePriceMutationResult = Apollo.MutationResult<CreatePriceMutation>;
export type CreatePriceMutationOptions = Apollo.BaseMutationOptions<CreatePriceMutation, CreatePriceMutationVariables>;
export const DeletePriceDocument = gql`
    mutation DeletePrice($where: PriceWhereUniqueInput!) {
  deletePrice(where: $where) {
    id
  }
}
    `;
export type DeletePriceMutationFn = Apollo.MutationFunction<DeletePriceMutation, DeletePriceMutationVariables>;

/**
 * __useDeletePriceMutation__
 *
 * To run a mutation, you first call `useDeletePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePriceMutation, { data, loading, error }] = useDeletePriceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeletePriceMutation(baseOptions?: Apollo.MutationHookOptions<DeletePriceMutation, DeletePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePriceMutation, DeletePriceMutationVariables>(DeletePriceDocument, options);
      }
export type DeletePriceMutationHookResult = ReturnType<typeof useDeletePriceMutation>;
export type DeletePriceMutationResult = Apollo.MutationResult<DeletePriceMutation>;
export type DeletePriceMutationOptions = Apollo.BaseMutationOptions<DeletePriceMutation, DeletePriceMutationVariables>;
export const PriceDocument = gql`
    query Price($where: PriceWhereUniqueInput!) {
  price(where: $where) {
    id
    price
    currencyId
    productId
  }
}
    `;

/**
 * __usePriceQuery__
 *
 * To run a query within a React component, call `usePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePriceQuery(baseOptions: Apollo.QueryHookOptions<PriceQuery, PriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceQuery, PriceQueryVariables>(PriceDocument, options);
      }
export function usePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceQuery, PriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceQuery, PriceQueryVariables>(PriceDocument, options);
        }
export type PriceQueryHookResult = ReturnType<typeof usePriceQuery>;
export type PriceLazyQueryHookResult = ReturnType<typeof usePriceLazyQuery>;
export type PriceQueryResult = Apollo.QueryResult<PriceQuery, PriceQueryVariables>;
export const UpdatePriceDocument = gql`
    mutation UpdatePrice($price: Float!, $productId: String!) {
  updatePrice(price: $price, productId: $productId)
}
    `;
export type UpdatePriceMutationFn = Apollo.MutationFunction<UpdatePriceMutation, UpdatePriceMutationVariables>;

/**
 * __useUpdatePriceMutation__
 *
 * To run a mutation, you first call `useUpdatePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceMutation, { data, loading, error }] = useUpdatePriceMutation({
 *   variables: {
 *      price: // value for 'price'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useUpdatePriceMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePriceMutation, UpdatePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePriceMutation, UpdatePriceMutationVariables>(UpdatePriceDocument, options);
      }
export type UpdatePriceMutationHookResult = ReturnType<typeof useUpdatePriceMutation>;
export type UpdatePriceMutationResult = Apollo.MutationResult<UpdatePriceMutation>;
export type UpdatePriceMutationOptions = Apollo.BaseMutationOptions<UpdatePriceMutation, UpdatePriceMutationVariables>;
export const PriceHistoriesDocument = gql`
    query PriceHistories($where: PriceHistoryWhereInput, $orderBy: [PriceHistoryOrderByWithRelationInput!], $take: Int, $skip: Int) {
  priceHistories(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    price
    currencyId
    productId
    createdAt
    updatedAt
    currency {
      id
      code
    }
  }
}
    `;

/**
 * __usePriceHistoriesQuery__
 *
 * To run a query within a React component, call `usePriceHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceHistoriesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function usePriceHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<PriceHistoriesQuery, PriceHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceHistoriesQuery, PriceHistoriesQueryVariables>(PriceHistoriesDocument, options);
      }
export function usePriceHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceHistoriesQuery, PriceHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceHistoriesQuery, PriceHistoriesQueryVariables>(PriceHistoriesDocument, options);
        }
export type PriceHistoriesQueryHookResult = ReturnType<typeof usePriceHistoriesQuery>;
export type PriceHistoriesLazyQueryHookResult = ReturnType<typeof usePriceHistoriesLazyQuery>;
export type PriceHistoriesQueryResult = Apollo.QueryResult<PriceHistoriesQuery, PriceHistoriesQueryVariables>;
export const CreateProductCustomDocument = gql`
    mutation CreateProductCustom($data: ProductCreateCustomInput!) {
  createProductCustom(data: $data) {
    id
  }
}
    `;
export type CreateProductCustomMutationFn = Apollo.MutationFunction<CreateProductCustomMutation, CreateProductCustomMutationVariables>;

/**
 * __useCreateProductCustomMutation__
 *
 * To run a mutation, you first call `useCreateProductCustomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductCustomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductCustomMutation, { data, loading, error }] = useCreateProductCustomMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProductCustomMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductCustomMutation, CreateProductCustomMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductCustomMutation, CreateProductCustomMutationVariables>(CreateProductCustomDocument, options);
      }
export type CreateProductCustomMutationHookResult = ReturnType<typeof useCreateProductCustomMutation>;
export type CreateProductCustomMutationResult = Apollo.MutationResult<CreateProductCustomMutation>;
export type CreateProductCustomMutationOptions = Apollo.BaseMutationOptions<CreateProductCustomMutation, CreateProductCustomMutationVariables>;
export const DeleteProductDocument = gql`
    mutation DeleteProduct($where: ProductWhereUniqueInput!) {
  deleteProduct(where: $where) {
    id
  }
}
    `;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const OrderProductDocument = gql`
    mutation orderProduct($id: String!, $order: Int!) {
  updateProduct(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderProductMutationFn = Apollo.MutationFunction<OrderProductMutation, OrderProductMutationVariables>;

/**
 * __useOrderProductMutation__
 *
 * To run a mutation, you first call `useOrderProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderProductMutation, { data, loading, error }] = useOrderProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderProductMutation(baseOptions?: Apollo.MutationHookOptions<OrderProductMutation, OrderProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderProductMutation, OrderProductMutationVariables>(OrderProductDocument, options);
      }
export type OrderProductMutationHookResult = ReturnType<typeof useOrderProductMutation>;
export type OrderProductMutationResult = Apollo.MutationResult<OrderProductMutation>;
export type OrderProductMutationOptions = Apollo.BaseMutationOptions<OrderProductMutation, OrderProductMutationVariables>;
export const ProductDocument = gql`
    query Product($where: ProductWhereUniqueInput!) {
  product(where: $where) {
    id
    createdAt
    sku
    photos
    prices {
      id
      price
      currency {
        id
        code
        buy
        sell
        isDefault
        prefix
        suffix
      }
    }
    discountType
    discountAmount
    status
    order
    brand
    categoryId
    collectionId
    sizes {
      id
      sizeId
      size {
        id
        sku
        descriptions {
          id
          title
          description
          slug
          headline
          buttonText
          buttonUrl
          language
        }
      }
    }
    colors {
      id
      colorId
      color {
        id
        code
        descriptions {
          id
          title
          description
          slug
          headline
          buttonText
          buttonUrl
          language
        }
      }
    }
  }
}
    `;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductsDocument = gql`
    query Products($where: ProductWhereInput, $orderBy: [ProductOrderByWithRelationInput!], $take: Int, $skip: Int) {
  products(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    count
    items {
      id
      createdAt
      photos
      discountType
      discountAmount
      status
      order
      brand
      sku
      descriptions {
        id
        title
        description
        slug
        headline
        buttonText
        buttonUrl
        language
      }
      category {
        id
        brand
        descriptions {
          title
        }
      }
      collection {
        id
        descriptions {
          title
        }
      }
      prices {
        id
        price
        currency {
          id
          code
          buy
          sell
          isDefault
          prefix
          suffix
        }
      }
    }
  }
}
    `;

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useProductsQuery(baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
      }
export function useProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsQuery, ProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(ProductsDocument, options);
        }
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>;
export type ProductsLazyQueryHookResult = ReturnType<typeof useProductsLazyQuery>;
export type ProductsQueryResult = Apollo.QueryResult<ProductsQuery, ProductsQueryVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($data: ProductUpdateInput!, $where: ProductWhereUniqueInput!) {
  updateProduct(data: $data, where: $where) {
    id
    brand
  }
}
    `;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const CreateCustomProductSizeDocument = gql`
    mutation CreateCustomProductSize($sizeId: String!, $price: Float!) {
  createCustomProductSize(sizeId: $sizeId, price: $price) {
    id
  }
}
    `;
export type CreateCustomProductSizeMutationFn = Apollo.MutationFunction<CreateCustomProductSizeMutation, CreateCustomProductSizeMutationVariables>;

/**
 * __useCreateCustomProductSizeMutation__
 *
 * To run a mutation, you first call `useCreateCustomProductSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomProductSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomProductSizeMutation, { data, loading, error }] = useCreateCustomProductSizeMutation({
 *   variables: {
 *      sizeId: // value for 'sizeId'
 *      price: // value for 'price'
 *   },
 * });
 */
export function useCreateCustomProductSizeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomProductSizeMutation, CreateCustomProductSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomProductSizeMutation, CreateCustomProductSizeMutationVariables>(CreateCustomProductSizeDocument, options);
      }
export type CreateCustomProductSizeMutationHookResult = ReturnType<typeof useCreateCustomProductSizeMutation>;
export type CreateCustomProductSizeMutationResult = Apollo.MutationResult<CreateCustomProductSizeMutation>;
export type CreateCustomProductSizeMutationOptions = Apollo.BaseMutationOptions<CreateCustomProductSizeMutation, CreateCustomProductSizeMutationVariables>;
export const ProductSizesDocument = gql`
    query ProductSizes($where: ProductSizeWhereInput, $descriptionsWhere2: DescriptionWhereInput) {
  productSizes(where: $where) {
    id
    prices {
      id
      price
      currencyId
      currency {
        code
        id
      }
    }
    size {
      id
      sku
      descriptions(where: $descriptionsWhere2) {
        id
        language
        title
      }
    }
  }
}
    `;

/**
 * __useProductSizesQuery__
 *
 * To run a query within a React component, call `useProductSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSizesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      descriptionsWhere2: // value for 'descriptionsWhere2'
 *   },
 * });
 */
export function useProductSizesQuery(baseOptions?: Apollo.QueryHookOptions<ProductSizesQuery, ProductSizesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSizesQuery, ProductSizesQueryVariables>(ProductSizesDocument, options);
      }
export function useProductSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSizesQuery, ProductSizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSizesQuery, ProductSizesQueryVariables>(ProductSizesDocument, options);
        }
export type ProductSizesQueryHookResult = ReturnType<typeof useProductSizesQuery>;
export type ProductSizesLazyQueryHookResult = ReturnType<typeof useProductSizesLazyQuery>;
export type ProductSizesQueryResult = Apollo.QueryResult<ProductSizesQuery, ProductSizesQueryVariables>;
export const UpdateCustomProductSizeDocument = gql`
    mutation UpdateCustomProductSize($sizeId: String!, $price: Float!, $priceId: String!) {
  updateCustomProductSize(sizeId: $sizeId, price: $price, priceId: $priceId) {
    id
  }
}
    `;
export type UpdateCustomProductSizeMutationFn = Apollo.MutationFunction<UpdateCustomProductSizeMutation, UpdateCustomProductSizeMutationVariables>;

/**
 * __useUpdateCustomProductSizeMutation__
 *
 * To run a mutation, you first call `useUpdateCustomProductSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomProductSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomProductSizeMutation, { data, loading, error }] = useUpdateCustomProductSizeMutation({
 *   variables: {
 *      sizeId: // value for 'sizeId'
 *      price: // value for 'price'
 *      priceId: // value for 'priceId'
 *   },
 * });
 */
export function useUpdateCustomProductSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomProductSizeMutation, UpdateCustomProductSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomProductSizeMutation, UpdateCustomProductSizeMutationVariables>(UpdateCustomProductSizeDocument, options);
      }
export type UpdateCustomProductSizeMutationHookResult = ReturnType<typeof useUpdateCustomProductSizeMutation>;
export type UpdateCustomProductSizeMutationResult = Apollo.MutationResult<UpdateCustomProductSizeMutation>;
export type UpdateCustomProductSizeMutationOptions = Apollo.BaseMutationOptions<UpdateCustomProductSizeMutation, UpdateCustomProductSizeMutationVariables>;
export const CreateSizeDocument = gql`
    mutation CreateSize($data: SizeCreateInput!) {
  createSize(data: $data) {
    id
  }
}
    `;
export type CreateSizeMutationFn = Apollo.MutationFunction<CreateSizeMutation, CreateSizeMutationVariables>;

/**
 * __useCreateSizeMutation__
 *
 * To run a mutation, you first call `useCreateSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSizeMutation, { data, loading, error }] = useCreateSizeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSizeMutation(baseOptions?: Apollo.MutationHookOptions<CreateSizeMutation, CreateSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSizeMutation, CreateSizeMutationVariables>(CreateSizeDocument, options);
      }
export type CreateSizeMutationHookResult = ReturnType<typeof useCreateSizeMutation>;
export type CreateSizeMutationResult = Apollo.MutationResult<CreateSizeMutation>;
export type CreateSizeMutationOptions = Apollo.BaseMutationOptions<CreateSizeMutation, CreateSizeMutationVariables>;
export const DeleteSizeDocument = gql`
    mutation DeleteSize($where: SizeWhereUniqueInput!) {
  deleteSize(where: $where) {
    id
  }
}
    `;
export type DeleteSizeMutationFn = Apollo.MutationFunction<DeleteSizeMutation, DeleteSizeMutationVariables>;

/**
 * __useDeleteSizeMutation__
 *
 * To run a mutation, you first call `useDeleteSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSizeMutation, { data, loading, error }] = useDeleteSizeMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteSizeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSizeMutation, DeleteSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSizeMutation, DeleteSizeMutationVariables>(DeleteSizeDocument, options);
      }
export type DeleteSizeMutationHookResult = ReturnType<typeof useDeleteSizeMutation>;
export type DeleteSizeMutationResult = Apollo.MutationResult<DeleteSizeMutation>;
export type DeleteSizeMutationOptions = Apollo.BaseMutationOptions<DeleteSizeMutation, DeleteSizeMutationVariables>;
export const OrderSizeDocument = gql`
    mutation orderSize($id: String!, $order: Int!) {
  updateSize(where: {id: $id}, data: {order: {set: $order}}) {
    id
  }
}
    `;
export type OrderSizeMutationFn = Apollo.MutationFunction<OrderSizeMutation, OrderSizeMutationVariables>;

/**
 * __useOrderSizeMutation__
 *
 * To run a mutation, you first call `useOrderSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSizeMutation, { data, loading, error }] = useOrderSizeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderSizeMutation(baseOptions?: Apollo.MutationHookOptions<OrderSizeMutation, OrderSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSizeMutation, OrderSizeMutationVariables>(OrderSizeDocument, options);
      }
export type OrderSizeMutationHookResult = ReturnType<typeof useOrderSizeMutation>;
export type OrderSizeMutationResult = Apollo.MutationResult<OrderSizeMutation>;
export type OrderSizeMutationOptions = Apollo.BaseMutationOptions<OrderSizeMutation, OrderSizeMutationVariables>;
export const SizeDocument = gql`
    query Size($where: SizeWhereUniqueInput!) {
  size(where: $where) {
    id
    createdAt
    sku
    order
  }
}
    `;

/**
 * __useSizeQuery__
 *
 * To run a query within a React component, call `useSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useSizeQuery(baseOptions: Apollo.QueryHookOptions<SizeQuery, SizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SizeQuery, SizeQueryVariables>(SizeDocument, options);
      }
export function useSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SizeQuery, SizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SizeQuery, SizeQueryVariables>(SizeDocument, options);
        }
export type SizeQueryHookResult = ReturnType<typeof useSizeQuery>;
export type SizeLazyQueryHookResult = ReturnType<typeof useSizeLazyQuery>;
export type SizeQueryResult = Apollo.QueryResult<SizeQuery, SizeQueryVariables>;
export const SizesDocument = gql`
    query Sizes($where: SizeWhereInput, $orderBy: [SizeOrderByWithRelationInput!], $take: Int, $skip: Int) {
  sizes(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {
    id
    createdAt
    sku
    order
    status
    descriptions {
      id
      title
      description
      slug
      headline
      buttonText
      buttonUrl
      language
    }
  }
}
    `;

/**
 * __useSizesQuery__
 *
 * To run a query within a React component, call `useSizesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSizesQuery(baseOptions?: Apollo.QueryHookOptions<SizesQuery, SizesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SizesQuery, SizesQueryVariables>(SizesDocument, options);
      }
export function useSizesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SizesQuery, SizesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SizesQuery, SizesQueryVariables>(SizesDocument, options);
        }
export type SizesQueryHookResult = ReturnType<typeof useSizesQuery>;
export type SizesLazyQueryHookResult = ReturnType<typeof useSizesLazyQuery>;
export type SizesQueryResult = Apollo.QueryResult<SizesQuery, SizesQueryVariables>;
export const UpdateSizeDocument = gql`
    mutation UpdateSize($data: SizeUpdateInput!, $where: SizeWhereUniqueInput!) {
  updateSize(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateSizeMutationFn = Apollo.MutationFunction<UpdateSizeMutation, UpdateSizeMutationVariables>;

/**
 * __useUpdateSizeMutation__
 *
 * To run a mutation, you first call `useUpdateSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSizeMutation, { data, loading, error }] = useUpdateSizeMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSizeMutation, UpdateSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSizeMutation, UpdateSizeMutationVariables>(UpdateSizeDocument, options);
      }
export type UpdateSizeMutationHookResult = ReturnType<typeof useUpdateSizeMutation>;
export type UpdateSizeMutationResult = Apollo.MutationResult<UpdateSizeMutation>;
export type UpdateSizeMutationOptions = Apollo.BaseMutationOptions<UpdateSizeMutation, UpdateSizeMutationVariables>;
export const CreateStaffDocument = gql`
    mutation CreateStaff($data: StaffCreateInput!) {
  createStaff(data: $data) {
    id
  }
}
    `;
export type CreateStaffMutationFn = Apollo.MutationFunction<CreateStaffMutation, CreateStaffMutationVariables>;

/**
 * __useCreateStaffMutation__
 *
 * To run a mutation, you first call `useCreateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStaffMutation, { data, loading, error }] = useCreateStaffMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateStaffMutation(baseOptions?: Apollo.MutationHookOptions<CreateStaffMutation, CreateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStaffMutation, CreateStaffMutationVariables>(CreateStaffDocument, options);
      }
export type CreateStaffMutationHookResult = ReturnType<typeof useCreateStaffMutation>;
export type CreateStaffMutationResult = Apollo.MutationResult<CreateStaffMutation>;
export type CreateStaffMutationOptions = Apollo.BaseMutationOptions<CreateStaffMutation, CreateStaffMutationVariables>;
export const FindManyStaffDocument = gql`
    query FindManyStaff {
  findManyStaff(orderBy: {createdAt: desc}) {
    id
    name
    surname
    email
    phoneNumber
    role
    createdAt
  }
}
    `;

/**
 * __useFindManyStaffQuery__
 *
 * To run a query within a React component, call `useFindManyStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindManyStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindManyStaffQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindManyStaffQuery(baseOptions?: Apollo.QueryHookOptions<FindManyStaffQuery, FindManyStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindManyStaffQuery, FindManyStaffQueryVariables>(FindManyStaffDocument, options);
      }
export function useFindManyStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindManyStaffQuery, FindManyStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindManyStaffQuery, FindManyStaffQueryVariables>(FindManyStaffDocument, options);
        }
export type FindManyStaffQueryHookResult = ReturnType<typeof useFindManyStaffQuery>;
export type FindManyStaffLazyQueryHookResult = ReturnType<typeof useFindManyStaffLazyQuery>;
export type FindManyStaffQueryResult = Apollo.QueryResult<FindManyStaffQuery, FindManyStaffQueryVariables>;
export const FindUniqueStaffDocument = gql`
    query FindUniqueStaff($where: StaffWhereUniqueInput!) {
  findUniqueStaff(where: $where) {
    createdAt
    email
    id
    name
    phoneNumber
    role
    surname
  }
}
    `;

/**
 * __useFindUniqueStaffQuery__
 *
 * To run a query within a React component, call `useFindUniqueStaffQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUniqueStaffQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUniqueStaffQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFindUniqueStaffQuery(baseOptions: Apollo.QueryHookOptions<FindUniqueStaffQuery, FindUniqueStaffQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindUniqueStaffQuery, FindUniqueStaffQueryVariables>(FindUniqueStaffDocument, options);
      }
export function useFindUniqueStaffLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindUniqueStaffQuery, FindUniqueStaffQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindUniqueStaffQuery, FindUniqueStaffQueryVariables>(FindUniqueStaffDocument, options);
        }
export type FindUniqueStaffQueryHookResult = ReturnType<typeof useFindUniqueStaffQuery>;
export type FindUniqueStaffLazyQueryHookResult = ReturnType<typeof useFindUniqueStaffLazyQuery>;
export type FindUniqueStaffQueryResult = Apollo.QueryResult<FindUniqueStaffQuery, FindUniqueStaffQueryVariables>;
export const StaffLoginDocument = gql`
    mutation StaffLogin($data: LoginInput!) {
  staffLogin(data: $data) {
    id
    name
    email
    token
  }
}
    `;
export type StaffLoginMutationFn = Apollo.MutationFunction<StaffLoginMutation, StaffLoginMutationVariables>;

/**
 * __useStaffLoginMutation__
 *
 * To run a mutation, you first call `useStaffLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStaffLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [staffLoginMutation, { data, loading, error }] = useStaffLoginMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useStaffLoginMutation(baseOptions?: Apollo.MutationHookOptions<StaffLoginMutation, StaffLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StaffLoginMutation, StaffLoginMutationVariables>(StaffLoginDocument, options);
      }
export type StaffLoginMutationHookResult = ReturnType<typeof useStaffLoginMutation>;
export type StaffLoginMutationResult = Apollo.MutationResult<StaffLoginMutation>;
export type StaffLoginMutationOptions = Apollo.BaseMutationOptions<StaffLoginMutation, StaffLoginMutationVariables>;
export const UpdateStaffDocument = gql`
    mutation UpdateStaff($data: StaffUpdateInput!, $where: StaffWhereUniqueInput!) {
  updateStaff(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateStaffMutationFn = Apollo.MutationFunction<UpdateStaffMutation, UpdateStaffMutationVariables>;

/**
 * __useUpdateStaffMutation__
 *
 * To run a mutation, you first call `useUpdateStaffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStaffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStaffMutation, { data, loading, error }] = useUpdateStaffMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateStaffMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStaffMutation, UpdateStaffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStaffMutation, UpdateStaffMutationVariables>(UpdateStaffDocument, options);
      }
export type UpdateStaffMutationHookResult = ReturnType<typeof useUpdateStaffMutation>;
export type UpdateStaffMutationResult = Apollo.MutationResult<UpdateStaffMutation>;
export type UpdateStaffMutationOptions = Apollo.BaseMutationOptions<UpdateStaffMutation, UpdateStaffMutationVariables>;
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!) {
  uploadFile(file: $file)
}
    `;
export type UploadFileMutationFn = Apollo.MutationFunction<UploadFileMutation, UploadFileMutationVariables>;

/**
 * __useUploadFileMutation__
 *
 * To run a mutation, you first call `useUploadFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileMutation, { data, loading, error }] = useUploadFileMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileMutation, UploadFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, options);
      }
export type UploadFileMutationHookResult = ReturnType<typeof useUploadFileMutation>;
export type UploadFileMutationResult = Apollo.MutationResult<UploadFileMutation>;
export type UploadFileMutationOptions = Apollo.BaseMutationOptions<UploadFileMutation, UploadFileMutationVariables>;